/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 17);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(25);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var context=__webpack_require__(40);var icons={};// load all icons into a big array of paths
context.keys().forEach(function(filename){icons[filename.slice(2,-4)]=context(filename);});/* harmony default export */ __webpack_exports__["a"] = (icons);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WND_css__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WND_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__WND_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BUTTON__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ICONS__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Main window class
var WND=function(_PureComponent){_inherits(WND,_PureComponent);function WND(props){_classCallCheck(this,WND);var _this=_possibleConstructorReturn(this,(WND.__proto__||Object.getPrototypeOf(WND)).call(this,props));_this.state={layer:window.WINAPI.GetWindowLayer(_this.props.hwnd),activeWindow:window.WINAPI.GetActiveWindow()};var defaultSize=_this.defaultSize();defaultSize.w=Math.min(defaultSize.w,window.innerWidth-50);defaultSize.h=Math.min(defaultSize.h,window.innerHeight-100);// x y w h is_maximized
_this.state.position=[props.initialPositionX,props.initialPositionY,defaultSize.w,defaultSize.h,!!props.initialIsMaximized];if(_this.defaultPosition()=='center'){_this.state.position[0]=Math.round((window.innerWidth-defaultSize.w)/2);_this.state.position[1]=Math.round((window.innerHeight-defaultSize.h)/2);}// for window moving
_this.isMoving=false;_this.moveOffset=[0,0];return _this;}_createClass(WND,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;this.cursorMoveHandler=function(event){if(_this2.isMoving){var oldPosition=_this2.state.position;var mousePos=window.WINAPI.GetCursorPos();_this2.setState({position:[event.clientX-_this2.moveOffset[0],event.clientY-_this2.moveOffset[1],oldPosition[2],oldPosition[3],false]});}};window.addEventListener("mousemove",this.cursorMoveHandler);this.mouseUpHandler=function(event){_this2.isMoving=false;};window.addEventListener("mouseup",this.mouseUpHandler);this.activeWindowHandler=window.WINAPI.SetWinEventHook("focus",function(){var newState={layer:window.WINAPI.GetWindowLayer(_this2.props.hwnd),activeWindow:window.WINAPI.GetActiveWindow()};if(newState.activeWindow!=_this2.props.hwnd&&_this2.state.activeWindow==_this2.props.hwnd){_this2.onFocusLost();}_this2.setState(newState);});}},{key:'onFocusLost',value:function onFocusLost(){// To be overridden
}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener("mousemove",this.cursorMoveHandler);window.removeEventListener("mouseup",this.mouseUpHandler);window.WINAPI.UnhookWinEvent("focus",this.activeWindowHandler);}},{key:'defaultSize',value:function defaultSize(){return{w:800,h:600};}},{key:'resizable',value:function resizable(){return true;}},{key:'canMinimize',value:function canMinimize(){return true;}},{key:'defaultPosition',value:function defaultPosition(){return null;// or 'center'
}},{key:'appearOnTaskbar',value:function appearOnTaskbar(){return true;}},{key:'titlebarMouseDown',value:function titlebarMouseDown(event){this.isMoving=!this.state.position[4];// Only move if not maximized
this.moveOffset=[event.clientX-this.state.position[0],event.clientY-this.state.position[1]];}},{key:'titlebarTouchStart',value:function titlebarTouchStart(event){this.takeFocus();var touch=event.changedTouches[0];this.moveOffset=[touch.pageX-this.state.position[0],touch.pageY-this.state.position[1]];}},{key:'titlebarTouchMove',value:function titlebarTouchMove(event){if(!this.state.position[4]){var oldPosition=this.state.position;var touch=event.changedTouches[0];this.setState({position:[touch.pageX-this.moveOffset[0],touch.pageY-this.moveOffset[1],oldPosition[2],oldPosition[3],false]});}}},{key:'title',value:function title(){return"Error";}},{key:'icon',value:function icon(){return null;}// Override me
},{key:'applicationContent',value:function applicationContent(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Application has experienced an internal error');}},{key:'takeFocus',value:function takeFocus(){if(this.state.activeWindow!=this.props.hwnd){window.WINAPI.SetActiveWindow(this.props.hwnd);}}},{key:'toggleMaximized',value:function toggleMaximized(){var oldPosition=this.state.position;this.setState({position:[oldPosition[0],oldPosition[1],oldPosition[2],oldPosition[3],!oldPosition[4]]});}},{key:'render',value:function render(){var _this3=this;var style={zIndex:this.state.layer};var isMaximized=this.state.position[4];if(isMaximized){// Maximized
style.width="100%";style.height="100%";}else{style.top=this.state.position[1]+'px';style.left=this.state.position[0]+'px';style.width=this.state.position[2]+'px';style.height=this.state.position[3]+'px';}var icon;if(this.icon()){icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wnd-titlebar-icon',style:{backgroundImage:"url("+this.icon()+")"}});}var active=this.state.activeWindow==this.props.hwnd;var maximizeButton;if(isMaximized){maximizeButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__BUTTON__["a" /* default */],{className:'restore',onPress:this.toggleMaximized.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__ICONS__["a" /* default */].RESTORE}));}else{maximizeButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__BUTTON__["a" /* default */],{className:'maximize',onPress:this.toggleMaximized.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__ICONS__["a" /* default */].MAXIMIZE}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"wnd"+(active?" wnd-active":"")+(isMaximized?" wnd-maximized":""),style:style,onMouseDown:this.takeFocus.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wnd-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wnd-titlebar',onMouseDown:this.titlebarMouseDown.bind(this),onTouchStart:this.titlebarTouchStart.bind(this),onTouchMove:this.titlebarTouchMove.bind(this)},icon,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wnd-titlebar-title'},this.title()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wnd-titlebar-buttons'},this.canMinimize()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__BUTTON__["a" /* default */],{className:'minimize'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__ICONS__["a" /* default */].MINIMIZE})):null,this.resizable()?maximizeButton:null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__BUTTON__["a" /* default */],{className:'close',onPress:function onPress(){window.WINAPI.CloseWindow(_this3.props.hwnd);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__ICONS__["a" /* default */].CLOSE})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wnd-clientarea'},this.applicationContent())));}}]);return WND;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (WND);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(26);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BUTTON_css__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BUTTON_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__BUTTON_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TOOLTIP__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// two ways to use BUTTON
var BUTTON=function(_PureComponent){_inherits(BUTTON,_PureComponent);function BUTTON(props){_classCallCheck(this,BUTTON);var _this=_possibleConstructorReturn(this,(BUTTON.__proto__||Object.getPrototypeOf(BUTTON)).call(this,props));_this.state={pressed:false};return _this;}_createClass(BUTTON,[{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.windowListener){window.removeEventListener('mouseup',this.windowListener);}}},{key:'mouseDown',value:function mouseDown(e){if(this.props.onDown){this.props.onDown();return;}this.setState({pressing:true,pressed:true});this.windowListener=function(event){var shouldCallOnPress=false;if(this.state.pressed&&this.props.onPress){shouldCallOnPress=true;}this.setState({pressing:false,pressed:false});window.removeEventListener('mouseup',this.windowListener);if(shouldCallOnPress){this.props.onPress();}event.stopPropagation();}.bind(this);window.addEventListener('mouseup',this.windowListener);e.stopPropagation();}},{key:'mouseEnter',value:function mouseEnter(e){if(this.state.pressing){this.setState({pressed:true});}}},{key:'mouseLeave',value:function mouseLeave(e){if(this.state.pressing){this.setState({pressed:false});}}},{key:'render',value:function render(){var className="btn ";if(this.state.pressed){className+="btn-depressed ";}if(this.props.selected){className+="btn-selected ";}if(this.props.className){className+=this.props.className;}var tooltip=undefined;if(this.props.tooltip){tooltip=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TOOLTIP__["a" /* default */],{text:this.props.tooltip});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:className,onMouseDown:this.mouseDown.bind(this),onMouseEnter:this.mouseEnter.bind(this),onMouseLeave:this.mouseLeave.bind(this),onClick:function onClick(e){return e.stopPropagation();}},this.props.children,tooltip);}}]);return BUTTON;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (BUTTON);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MENU__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// horizontal listing of multiple menus
var MENUBAR=function(_PureComponent){_inherits(MENUBAR,_PureComponent);function MENUBAR(){_classCallCheck(this,MENUBAR);return _possibleConstructorReturn(this,(MENUBAR.__proto__||Object.getPrototypeOf(MENUBAR)).apply(this,arguments));}_createClass(MENUBAR,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-bar'},this.props.menu.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i,className:'menu-bar-item'},__WEBPACK_IMPORTED_MODULE_2__MENU__["a" /* default */].annotateAccelText(item.text,item.accel));}));}}]);return MENUBAR;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (MENUBAR);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__STATUSBAR_css__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__STATUSBAR_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__STATUSBAR_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var STATUSBAR=function(_PureComponent){_inherits(STATUSBAR,_PureComponent);function STATUSBAR(props){_classCallCheck(this,STATUSBAR);return _possibleConstructorReturn(this,(STATUSBAR.__proto__||Object.getPrototypeOf(STATUSBAR)).call(this,props));}_createClass(STATUSBAR,[{key:'render',value:function render(){var parts=this.props.parts||[null];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"statusbar-container "+(this.props.className||"")},this.props.children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statusbar'},parts.map(function(part,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i,className:'statusbar-part'},part);})));}}]);return STATUSBAR;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (STATUSBAR);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TOOLTIP_css__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TOOLTIP_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TOOLTIP_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TOOLTIP=function(_PureComponent){_inherits(TOOLTIP,_PureComponent);function TOOLTIP(props){_classCallCheck(this,TOOLTIP);var _this=_possibleConstructorReturn(this,(TOOLTIP.__proto__||Object.getPrototypeOf(TOOLTIP)).call(this,props));_this.registerEvents=function(rootElem){if(rootElem==null){_this.parent.removeEventListener("mouseenter",_this.mouseenter);_this.parent.removeEventListener("mouseleave",_this.mouseleave);_this.mouseenter=undefined;_this.mouseleave=undefined;clearTimeout(_this.timeout);return;}if(_this.mouseenter!==undefined){// already bound
return;};_this.mouseenter=function(e){_this.timeout=setTimeout(function(){var mousePosition=window.WINAPI.GetCursorPos();var tooltipPos=_this.calculateTooltipPosition(mousePosition,rootElem.parentElement);_this.setState({active:true,x:tooltipPos[0],y:tooltipPos[1]});},700);};_this.mouseleave=function(e){_this.setState({active:false});clearTimeout(_this.timeout);};_this.parent=rootElem.parentElement;_this.parent.addEventListener("mouseenter",_this.mouseenter);_this.parent.addEventListener("mouseleave",_this.mouseleave);};_this.state={active:false,x:0,y:0};return _this;}_createClass(TOOLTIP,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;this.globalDismissHandler=window.WINAPI.SetWinEventHook('dismiss',function(){if(_this2.state.active==true){_this2.setState({active:false});}});}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.WINAPI.UnhookWinEvent('dismiss',this.globalDismissHandler);}},{key:'calculateTooltipPosition',value:function calculateTooltipPosition(mousePos,parent){var selfRect=this.tooltip.getBoundingClientRect();var parentRect=parent.getBoundingClientRect();var x=mousePos[0];var y=parentRect.top-selfRect.height-2;if(x+selfRect.width>window.innerWidth){x=window.innerWidth-selfRect.width;}if(y<0){y=0;}// TODO do not be clipped by edges of screen
return[x,y];}},{key:'render',value:function render(){var _this3=this;var className="tooltip";var content=null;if(this.state.active){className+=" tooltip-active";}var style={left:this.state.x,top:this.state.y};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tooltip-dummy',ref:this.registerEvents},__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:className,style:style,ref:function ref(tooltip){_this3.tooltip=tooltip;}},this.props.text),window.WINAPI.GetDesktopWindow()));}}]);return TOOLTIP;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (TOOLTIP);

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(20);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.20.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
        return (Object.getOwnPropertyNames(obj).length === 0);
    } else {
        var k;
        for (k in obj) {
            if (obj.hasOwnProperty(k)) {
                return false;
            }
        }
        return true;
    }
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.weekdayMismatch &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        }
        else {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function mod(n, x) {
    return ((n % x) + x) % x;
}

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
        return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            var aliasedRequire = require;
            !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
            getSetGlobalLocale(oldLocale);
        } catch (e) {}
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, tmpLocale, parentConfig = baseConfig;
        // MERGE
        tmpLocale = loadLocale(name);
        if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, expectedWeekday, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }

    // check for mismatching day of week
    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
        getParsingFlags(config).weekdayMismatch = true;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
    ];

    if (secondStr) {
        result.push(parseInt(secondStr, 10));
    }

    return result;
}

function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
        return 2000 + year;
    } else if (year <= 999) {
        return 1900 + year;
    }
    return year;
}

function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
}

function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
        }
    }
    return true;
}

var obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
};

function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
        return obsOffsets[obsOffset];
    } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
    } else {
        var hm = parseInt(numOffset, 10);
        var m = hm % 100, h = (hm - m) / 100;
        return h * 60 + m;
    }
}

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i));
    if (match) {
        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
            return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);

        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    switch (units) {
        case 'year': output = monthDiff(this, that) / 12; break;
        case 'month': output = monthDiff(this, that); break;
        case 'quarter': output = monthDiff(this, that) / 3; break;
        case 'second': output = (this - that) / 1e3; break; // 1000
        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default: output = this - that;
    }

    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString(keepOffset) {
    if (!this.isValid()) {
        return null;
    }
    var utc = keepOffset !== true;
    var m = utc ? this.clone().utc() : this;
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        if (utc) {
            return this.toDate().toISOString();
        } else {
            return new Date(this._d.valueOf()).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
    }
    return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0]);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function clone$1 () {
    return createDuration(this);
}

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function sign(x) {
    return ((x > 0) - (x < 0)) || +x;
}

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    var totalSign = total < 0 ? '-' : '';
    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

    return totalSign + 'P' +
        (Y ? ymSign + Y + 'Y' : '') +
        (M ? ymSign + M + 'M' : '') +
        (D ? daysSign + D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? hmsSign + h + 'H' : '') +
        (m ? hmsSign + m + 'M' : '') +
        (s ? hmsSign + s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.clone          = clone$1;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.20.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

// currently HTML5 input type only supports 24-hour formats
hooks.HTML5_FMT = {
    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
    DATE: 'YYYY-MM-DD',                             // <input type="date" />
    TIME: 'HH:mm',                                  // <input type="time" />
    TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
    TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
    WEEK: 'YYYY-[W]WW',                             // <input type="week" />
    MONTH: 'YYYY-MM'                                // <input type="month" />
};

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(114)(module)))

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MENU_css__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MENU_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MENU_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// the menu component is not just a single menu, it is a whole hierarchy
var MENU=function(_PureComponent){_inherits(MENU,_PureComponent);_createClass(MENU,null,[{key:'annotateAccelText',value:function annotateAccelText(text,accel){if(accel){var accelIndex=text.indexOf(accel);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-text'},text.substring(0,accelIndex),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'menu-item-accel'},accel),text.substring(accelIndex+1));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-text'},text);}}}]);function MENU(props){_classCallCheck(this,MENU);// first menubit is always root, starts out as visible
var _this=_possibleConstructorReturn(this,(MENU.__proto__||Object.getPrototypeOf(MENU)).call(this,props));_this.state=_this.parseMenu(props.menu);return _this;}_createClass(MENU,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){// first menubit is always root, starts out as visible
this.setState(this.parseMenu(nextProps.menu));}},{key:'parseMenu',value:function parseMenu(menu){var menuBits=this.toMenuBits(menu);return{menuBits:menuBits,bit0Position:[this.props.top,this.props.right,this.props.bottom,this.props.left]};}},{key:'toMenuBits',value:function toMenuBits(menu,key,depth){var bits=[];var items=[];depth=depth||0;var bit={style:menu.style,direction:menu.direction,items:items,depth:depth};if(!key){key={value:0};}var myKey=key.value;key.value+=1;bits.push(bit);for(var i=0;i<menu.items.length;i++){var item=Object.assign({},menu.items[i]);if(item.type=="menu"){item["menuKey"]=key.value;bits.push.apply(bits,this.toMenuBits(item,key,depth+1));delete item.items;}bit.items.push(item);}return bits;}},{key:'renderMenuItems',value:function renderMenuItems(menuItems,depth){var _this2=this;var elms=[];var anyHasShortcut=false;for(var index=0;index<menuItems.length;index++){if(menuItems[index].shortcut){anyHasShortcut=true;break;}}for(index=0;index<menuItems.length;index++){var menuItem=menuItems[index];var type=menuItem.type;if(!type){type="item";}var shortcut=null;if(anyHasShortcut){shortcut=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-item-shortcut'},menuItem.shortcut);}if(type=="divider"){elms.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-divider',key:index}));}else{var clazz;var text;var iconStyle;var onMouseEnter,onMouseExit;var onClick;(function(){clazz="menu-item menu-item-"+type;if(menuItem.disabled){clazz+=" disabled";}// Accelerator keys
text=MENU.annotateAccelText(menuItem.text,menuItem.accel);iconStyle={backgroundImage:'url('+menuItem.icon+')'};var item=menuItem;var clearOtherSubmenus=function clearOtherSubmenus(){// Clear visible menubits with depth greater than ours
for(var i=0;i<_this2.state.menuBits.length;i++){var menuBit=_this2.state.menuBits[i];if(menuBit.depth>depth&&_this2.state["bit"+i+"Position"]){var newState={};newState["bit"+i+"Position"]=null;_this2.setState(newState);}}};onMouseEnter=clearOtherSubmenus;onMouseExit=null;onClick=function onClick(e){if(_this2.props.onDismiss){_this2.props.onDismiss();}if(item.onclick){item.onclick();}e.stopPropagation();};if(menuItem.type=="menu"){onMouseEnter=function onMouseEnter(e){clearOtherSubmenus();var newState={};// TODO compute menu position
var newPosition;if(e.target.getBoundingClientRect().left+e.target.offsetWidth+150>window.innerWidth&&e.target.getBoundingClientRect().left>150){newPosition=[e.target.getBoundingClientRect().top,window.innerWidth-e.target.getBoundingClientRect().left,null,null];}else{newPosition=[e.target.getBoundingClientRect().top,null,null,e.target.getBoundingClientRect().left+e.target.offsetWidth];}newState["bit"+item.menuKey+"Position"]=newPosition;_this2.setState(newState);};onMouseExit=function onMouseExit(){};onClick=function onClick(e){e.stopPropagation();};}elms.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:clazz,key:index,onClick:onClick,onMouseEnter:onMouseEnter,onMouseExit:onMouseExit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-item-icon',style:iconStyle}),text,shortcut));})();}}return elms;}},{key:'renderMenuBits',value:function renderMenuBits(menuBits){var elms=[];for(var i=0;i<this.state.menuBits.length;i++){var menuBit=this.state.menuBits[i];var clazz="menu-bit";if(menuBit.style){clazz+=" menu-bit-style-"+menuBit.style;}var position=this.state["bit"+i+"Position"];if(position){// Render menu bit
var css={top:position[0],right:position[1],bottom:position[2],left:position[3]};var elm=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:clazz,id:"menu-bit-"+i,key:"menu-bit-"+i,style:css},this.renderMenuItems(menuBit.items,menuBit.depth));elms.push(elm);}}return elms;}},{key:'render',value:function render(){var renderedMenu=this.renderMenuBits(this.state.menuBits);return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-container',onMouseDown:function onMouseDown(e){e.stopPropagation();}},renderedMenu),window.WINAPI.GetDesktopWindow());}}]);return MENU;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (MENU);

/***/ }),
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WND_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menus_MENUBAR__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__STATUSBAR__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EXPLORER_css__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EXPLORER_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__EXPLORER_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var menu=[{text:"File",accel:"F"},{text:"Edit",accel:"E"},{text:"View",accel:"V"},{text:"Help",accel:"H"}];var paddingX=3;var paddingY=4;var strideY=75;var strideX=75;var EXPLORER_ICON=function(_PureComponent){_inherits(EXPLORER_ICON,_PureComponent);function EXPLORER_ICON(props){_classCallCheck(this,EXPLORER_ICON);var _this=_possibleConstructorReturn(this,(EXPLORER_ICON.__proto__||Object.getPrototypeOf(EXPLORER_ICON)).call(this,props));_this.lastClickTime=0;return _this;}_createClass(EXPLORER_ICON,[{key:'onClick',value:function onClick(e){this.props.onSelect();var time=new Date().getTime();var dblClickTime=1000;if(time-this.lastClickTime<=dblClickTime){this.props.onOpen();}else{this.lastClickTime=time;}e.stopPropagation();}},{key:'render',value:function render(){var style={left:this.props.position[0],top:this.props.position[1]};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"explorer-icon "+(this.props.selected?"selected":"")+" "+(this.props.isSoftLink?"explorer-icon-link":""),style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon',onClick:this.onClick.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.props.icon})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name',onClick:this.onClick.bind(this)},this.props.name));}}]);return EXPLORER_ICON;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);var EXPLCTRL=function(_React$PureComponent){_inherits(EXPLCTRL,_React$PureComponent);function EXPLCTRL(props){_classCallCheck(this,EXPLCTRL);var _this2=_possibleConstructorReturn(this,(EXPLCTRL.__proto__||Object.getPrototypeOf(EXPLCTRL)).call(this,props));_this2.state={};_this2.state.selectedIndex=-1;_this2.state.currentPositions=null;return _this2;}_createClass(EXPLCTRL,[{key:'calculatePositions',value:function calculatePositions(frameElm){if(this.state.currentPositions==null){// Recalculate positions
var width=frameElm.offsetWidth;var height=frameElm.offsetHeight;var positions=[];var x=0;var y=0;for(var i=0;i<this.props.directory.length;i++){var position=[paddingX+x*strideX,paddingY+y*strideY];if(this.props.stackVertically){if((y+2)*strideY>=height){y=0;x+=1;}else{y+=1;}}else{if((x+2)*strideX>=width){x=0;y+=1;}else{x+=1;}}positions.push(position);}this.setState({currentPositions:positions});}}},{key:'render',value:function render(){var _this3=this;var items=this.props.directory;var explorerFrame=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"explorer-frame"+(this.props.showChrome?" with-chrome":""),onClick:function onClick(){_this3.setState({selectedIndex:-1});},ref:this.calculatePositions.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'explorer-frame-area'},this.state.currentPositions?items.map(function(item,i){var position=_this3.state.currentPositions[i];if(position){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EXPLORER_ICON,{key:i,selected:_this3.state.selectedIndex==i,position:_this3.state.currentPositions[i],icon:item.icon32,name:item.displayName||item.name,isSoftLink:item.type=="link"&&item.isSoft,onSelect:function onSelect(){_this3.setState({selectedIndex:i});},onOpen:function onOpen(){var path;if(item.type=="link"){path=item.destination;}else{var pathStart=_this3.props.path?_this3.props.path+"\\":"";path=pathStart+item.name;}window.WINAPI.ShellExecute(path);_this3.setState({selectedIndex:-1});}});}else{return null;}}):null));if(this.props.showChrome){var statusBarParts=[items.length+" object(s)",""];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__STATUSBAR__["a" /* default */],{className:'explorer',parts:statusBarParts},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__menus_MENUBAR__["a" /* default */],{menu:menu}),explorerFrame);}else{return explorerFrame;}}},{key:'onFocusLost',value:function onFocusLost(){if(this.state.selectedIndex!=-1){this.setState({selectedIndex:-1});}}}]);return EXPLCTRL;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);/* harmony default export */ __webpack_exports__["a"] = (EXPLCTRL);

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(18);
module.exports = __webpack_require__(24);


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(19).enable();
  window.Promise = __webpack_require__(22);
}

// fetch() polyfill for making API calls.
__webpack_require__(23);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(7);


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(10);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 21 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(10);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__walleris_IBMPC_js__ = __webpack_require__(36);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__walleris_IBMPC_js__["a" /* default */],null),document.getElementById('root'));

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 React v16.0.0
 react.production.min.js

 Copyright (c) 2013-present, Facebook, Inc.

 This source code is licensed under the MIT license found in the
 LICENSE file in the root directory of this source tree.
*/
var f=__webpack_require__(7),p=__webpack_require__(11);__webpack_require__(12);var r=__webpack_require__(8);
function t(a){for(var b=arguments.length-1,d="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,e=0;e<b;e++)d+="\x26args[]\x3d"+encodeURIComponent(arguments[e+1]);b=Error(d+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var u={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function v(a,b,d){this.props=a;this.context=b;this.refs=p;this.updater=d||u}v.prototype.isReactComponent={};v.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?t("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};v.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function w(a,b,d){this.props=a;this.context=b;this.refs=p;this.updater=d||u}function x(){}x.prototype=v.prototype;var y=w.prototype=new x;y.constructor=w;f(y,v.prototype);y.isPureReactComponent=!0;function z(a,b,d){this.props=a;this.context=b;this.refs=p;this.updater=d||u}var A=z.prototype=new x;A.constructor=z;f(A,v.prototype);A.unstable_isAsyncReactComponent=!0;A.render=function(){return this.props.children};
var B={Component:v,PureComponent:w,AsyncComponent:z},C={current:null},D=Object.prototype.hasOwnProperty,E="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.element")||60103,F={key:!0,ref:!0,__self:!0,__source:!0};function G(a,b,d,e,c,g,k){return{$$typeof:E,type:a,key:b,ref:d,props:k,_owner:g}}
G.createElement=function(a,b,d){var e,c={},g=null,k=null,m=null,q=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),m=void 0===b.__self?null:b.__self,q=void 0===b.__source?null:b.__source,b)D.call(b,e)&&!F.hasOwnProperty(e)&&(c[e]=b[e]);var l=arguments.length-2;if(1===l)c.children=d;else if(1<l){for(var h=Array(l),n=0;n<l;n++)h[n]=arguments[n+2];c.children=h}if(a&&a.defaultProps)for(e in l=a.defaultProps,l)void 0===c[e]&&(c[e]=l[e]);return G(a,g,k,m,q,C.current,c)};
G.createFactory=function(a){var b=G.createElement.bind(null,a);b.type=a;return b};G.cloneAndReplaceKey=function(a,b){return G(a.type,b,a.ref,a._self,a._source,a._owner,a.props)};
G.cloneElement=function(a,b,d){var e=f({},a.props),c=a.key,g=a.ref,k=a._self,m=a._source,q=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,q=C.current);void 0!==b.key&&(c=""+b.key);if(a.type&&a.type.defaultProps)var l=a.type.defaultProps;for(h in b)D.call(b,h)&&!F.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==l?l[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=d;else if(1<h){l=Array(h);for(var n=0;n<h;n++)l[n]=arguments[n+2];e.children=l}return G(a.type,c,g,k,m,q,e)};
G.isValidElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===E};var H="function"===typeof Symbol&&Symbol.iterator,I="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.element")||60103;function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var J=/\/+/g,K=[];
function L(a,b,d,e){if(K.length){var c=K.pop();c.result=a;c.keyPrefix=b;c.func=d;c.context=e;c.count=0;return c}return{result:a,keyPrefix:b,func:d,context:e,count:0}}function M(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>K.length&&K.push(a)}
function N(a,b,d,e){var c=typeof a;if("undefined"===c||"boolean"===c)a=null;if(null===a||"string"===c||"number"===c||"object"===c&&a.$$typeof===I)return d(e,a,""===b?"."+O(a,0):b),1;var g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){c=a[k];var m=b+O(c,k);g+=N(c,m,d,e)}else if(m=H&&a[H]||a["@@iterator"],"function"===typeof m)for(a=m.call(a),k=0;!(c=a.next()).done;)c=c.value,m=b+O(c,k++),g+=N(c,m,d,e);else"object"===c&&(d=""+a,t("31","[object Object]"===d?"object with keys {"+
Object.keys(a).join(", ")+"}":d,""));return g}function O(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function P(a,b){a.func.call(a.context,b,a.count++)}function Q(a,b,d){var e=a.result,c=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?R(a,e,d,r.thatReturnsArgument):null!=a&&(G.isValidElement(a)&&(a=G.cloneAndReplaceKey(a,c+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(J,"$\x26/")+"/")+d)),e.push(a))}
function R(a,b,d,e,c){var g="";null!=d&&(g=(""+d).replace(J,"$\x26/")+"/");b=L(b,g,e,c);null==a||N(a,"",Q,b);M(b)}var S={forEach:function(a,b,d){if(null==a)return a;b=L(null,null,b,d);null==a||N(a,"",P,b);M(b)},map:function(a,b,d){if(null==a)return a;var e=[];R(a,e,null,b,d);return e},count:function(a){return null==a?0:N(a,"",r.thatReturnsNull,null)},toArray:function(a){var b=[];R(a,b,null,r.thatReturnsArgument);return b}};
module.exports={Children:{map:S.map,forEach:S.forEach,count:S.count,toArray:S.toArray,only:function(a){G.isValidElement(a)?void 0:t("143");return a}},Component:B.Component,PureComponent:B.PureComponent,unstable_AsyncComponent:B.AsyncComponent,createElement:G.createElement,cloneElement:G.cloneElement,isValidElement:G.isValidElement,createFactory:G.createFactory,version:"16.0.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:C,assign:f}};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 React v16.0.0
 react-dom.production.min.js

 Copyright (c) 2013-present, Facebook, Inc.

 This source code is licensed under the MIT license found in the
 LICENSE file in the root directory of this source tree.
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0);__webpack_require__(12);var l=__webpack_require__(27),n=__webpack_require__(7),ba=__webpack_require__(28),ca=__webpack_require__(8),da=__webpack_require__(11),ea=__webpack_require__(29),fa=__webpack_require__(30),ha=__webpack_require__(33),ia=__webpack_require__(34);
function w(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}aa?void 0:w("227");
function ja(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
var ka={Namespaces:{html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"},getIntrinsicNamespace:ja,getChildNamespace:function(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?ja(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}},la=null,oa={};
function pa(){if(la)for(var a in oa){var b=oa[a],c=la.indexOf(a);-1<c?void 0:w("96",a);if(!qa.plugins[c]){b.extractEvents?void 0:w("97",a);qa.plugins[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;qa.eventNameDispatchConfigs.hasOwnProperty(h)?w("99",h):void 0;qa.eventNameDispatchConfigs[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ra(k[e],g,h);e=!0}else f.registrationName?(ra(f.registrationName,g,h),e=!0):e=!1;e?void 0:w("98",d,a)}}}}
function ra(a,b,c){qa.registrationNameModules[a]?w("100",a):void 0;qa.registrationNameModules[a]=b;qa.registrationNameDependencies[a]=b.eventTypes[c].dependencies}
var qa={plugins:[],eventNameDispatchConfigs:{},registrationNameModules:{},registrationNameDependencies:{},possibleRegistrationNames:null,injectEventPluginOrder:function(a){la?w("101"):void 0;la=Array.prototype.slice.call(a);pa()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];oa.hasOwnProperty(c)&&oa[c]===d||(oa[c]?w("102",c):void 0,oa[c]=d,b=!0)}b&&pa()}},sa=qa,ta={children:!0,dangerouslySetInnerHTML:!0,autoFocus:!0,defaultValue:!0,defaultChecked:!0,
innerHTML:!0,suppressContentEditableWarning:!0,style:!0};function ua(a,b){return(a&b)===b}
var wa={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(a){var b=wa,c=a.Properties||{},d=a.DOMAttributeNamespaces||{},e=a.DOMAttributeNames||{};a=a.DOMMutationMethods||{};for(var f in c){xa.properties.hasOwnProperty(f)?w("48",f):void 0;var g=f.toLowerCase(),h=c[f];g={attributeName:g,attributeNamespace:null,propertyName:f,mutationMethod:null,mustUseProperty:ua(h,b.MUST_USE_PROPERTY),
hasBooleanValue:ua(h,b.HAS_BOOLEAN_VALUE),hasNumericValue:ua(h,b.HAS_NUMERIC_VALUE),hasPositiveNumericValue:ua(h,b.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:ua(h,b.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:ua(h,b.HAS_STRING_BOOLEAN_VALUE)};1>=g.hasBooleanValue+g.hasNumericValue+g.hasOverloadedBooleanValue?void 0:w("50",f);e.hasOwnProperty(f)&&(g.attributeName=e[f]);d.hasOwnProperty(f)&&(g.attributeNamespace=d[f]);a.hasOwnProperty(f)&&(g.mutationMethod=a[f]);xa.properties[f]=
g}}},xa={ID_ATTRIBUTE_NAME:"data-reactid",ROOT_ATTRIBUTE_NAME:"data-reactroot",ATTRIBUTE_NAME_START_CHAR:":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD",ATTRIBUTE_NAME_CHAR:":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040",
properties:{},shouldSetAttribute:function(a,b){if(xa.isReservedProp(a)||!("o"!==a[0]&&"O"!==a[0]||"n"!==a[1]&&"N"!==a[1]))return!1;if(null===b)return!0;switch(typeof b){case "boolean":return xa.shouldAttributeAcceptBooleanValue(a);case "undefined":case "number":case "string":case "object":return!0;default:return!1}},getPropertyInfo:function(a){return xa.properties.hasOwnProperty(a)?xa.properties[a]:null},shouldAttributeAcceptBooleanValue:function(a){if(xa.isReservedProp(a))return!0;var b=xa.getPropertyInfo(a);
if(b)return b.hasBooleanValue||b.hasStringBooleanValue||b.hasOverloadedBooleanValue;a=a.toLowerCase().slice(0,5);return"data-"===a||"aria-"===a},isReservedProp:function(a){return ta.hasOwnProperty(a)},injection:wa},A=xa,E={IndeterminateComponent:0,FunctionalComponent:1,ClassComponent:2,HostRoot:3,HostPortal:4,HostComponent:5,HostText:6,CoroutineComponent:7,CoroutineHandlerPhase:8,YieldComponent:9,Fragment:10},F={ELEMENT_NODE:1,TEXT_NODE:3,COMMENT_NODE:8,DOCUMENT_NODE:9,DOCUMENT_FRAGMENT_NODE:11},
ya=E.HostComponent,za=E.HostText,Aa=F.ELEMENT_NODE,Ba=F.COMMENT_NODE,Ea=A.ID_ATTRIBUTE_NAME,Fa={hasCachedChildNodes:1},Ga=Math.random().toString(36).slice(2),Ha="__reactInternalInstance$"+Ga,Ia="__reactEventHandlers$"+Ga;function La(a){for(var b;b=a._renderedComponent;)a=b;return a}function Ma(a,b){a=La(a);a._hostNode=b;b[Ha]=a}
function Na(a,b){if(!(a._flags&Fa.hasCachedChildNodes)){var c=a._renderedChildren;b=b.firstChild;var d;a:for(d in c)if(c.hasOwnProperty(d)){var e=c[d],f=La(e)._domID;if(0!==f){for(;null!==b;b=b.nextSibling){var g=b,h=f;if(g.nodeType===Aa&&g.getAttribute(Ea)===""+h||g.nodeType===Ba&&g.nodeValue===" react-text: "+h+" "||g.nodeType===Ba&&g.nodeValue===" react-empty: "+h+" "){Ma(e,b);continue a}}w("32",f)}}a._flags|=Fa.hasCachedChildNodes}}
function Oa(a){if(a[Ha])return a[Ha];for(var b=[];!a[Ha];)if(b.push(a),a.parentNode)a=a.parentNode;else return null;var c=a[Ha];if(c.tag===ya||c.tag===za)return c;for(;a&&(c=a[Ha]);a=b.pop()){var d=c;b.length&&Na(c,a)}return d}
var G={getClosestInstanceFromNode:Oa,getInstanceFromNode:function(a){var b=a[Ha];if(b)return b.tag===ya||b.tag===za?b:b._hostNode===a?b:null;b=Oa(a);return null!=b&&b._hostNode===a?b:null},getNodeFromInstance:function(a){if(a.tag===ya||a.tag===za)return a.stateNode;void 0===a._hostNode?w("33"):void 0;if(a._hostNode)return a._hostNode;for(var b=[];!a._hostNode;)b.push(a),a._hostParent?void 0:w("34"),a=a._hostParent;for(;b.length;a=b.pop())Na(a,a._hostNode);return a._hostNode},precacheChildNodes:Na,
precacheNode:Ma,uncacheNode:function(a){var b=a._hostNode;b&&(delete b[Ha],a._hostNode=null)},precacheFiberNode:function(a,b){b[Ha]=a},getFiberCurrentPropsFromNode:function(a){return a[Ia]||null},updateFiberProps:function(a,b){a[Ia]=b}},Pa={remove:function(a){a._reactInternalFiber=void 0},get:function(a){return a._reactInternalFiber},has:function(a){return void 0!==a._reactInternalFiber},set:function(a,b){a._reactInternalFiber=b}},Qa={ReactCurrentOwner:aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner};
function Ra(a){if("function"===typeof a.getName)return a.getName();if("number"===typeof a.tag){a=a.type;if("string"===typeof a)return a;if("function"===typeof a)return a.displayName||a.name}return null}var J={NoEffect:0,PerformedWork:1,Placement:2,Update:4,PlacementAndUpdate:6,Deletion:8,ContentReset:16,Callback:32,Err:64,Ref:128},Sa=E.HostComponent,Ta=E.HostRoot,Ua=E.HostPortal,Va=E.HostText,Wa=J.NoEffect,Xa=J.Placement;
function Za(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if((b.effectTag&Xa)!==Wa)return 1;for(;b["return"];)if(b=b["return"],(b.effectTag&Xa)!==Wa)return 1}return b.tag===Ta?2:3}function $a(a){2!==Za(a)?w("188"):void 0}
function ab(a){var b=a.alternate;if(!b)return b=Za(a),3===b?w("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return $a(e),a;if(g===d)return $a(e),b;g=g.sibling}w("188")}if(c["return"]!==d["return"])c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:w("189")}}c.alternate!==d?w("190"):void 0}c.tag!==Ta?w("188"):void 0;return c.stateNode.current===c?a:b}
var bb={isFiberMounted:function(a){return 2===Za(a)},isMounted:function(a){return(a=Pa.get(a))?2===Za(a):!1},findCurrentFiberUsingSlowPath:ab,findCurrentHostFiber:function(a){a=ab(a);if(!a)return null;for(var b=a;;){if(b.tag===Sa||b.tag===Va)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null},findCurrentHostFiberWithNoPortals:function(a){a=ab(a);
if(!a)return null;for(var b=a;;){if(b.tag===Sa||b.tag===Va)return b;if(b.child&&b.tag!==Ua)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}},K={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!==typeof a.invokeGuardedCallback?w("197"):void 0;cb=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,
b,c,d,e,f,g,h,k){cb.apply(K,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){K.invokeGuardedCallback.apply(this,arguments);if(K.hasCaughtError()){var p=K.clearCaughtError();K._hasRethrowError||(K._hasRethrowError=!0,K._rethrowError=p)}},rethrowCaughtError:function(){return db.apply(K,arguments)},hasCaughtError:function(){return K._hasCaughtError},clearCaughtError:function(){if(K._hasCaughtError){var a=K._caughtError;K._caughtError=null;K._hasCaughtError=!1;return a}w("198")}};
function cb(a,b,c,d,e,f,g,h,k){K._hasCaughtError=!1;K._caughtError=null;var p=Array.prototype.slice.call(arguments,3);try{b.apply(c,p)}catch(x){K._caughtError=x,K._hasCaughtError=!0}}function db(){if(K._hasRethrowError){var a=K._rethrowError;K._rethrowError=null;K._hasRethrowError=!1;throw a;}}var eb=K,fb;function gb(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=hb.getNodeFromInstance(d);eb.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
var hb={isEndish:function(a){return"topMouseUp"===a||"topTouchEnd"===a||"topTouchCancel"===a},isMoveish:function(a){return"topMouseMove"===a||"topTouchMove"===a},isStartish:function(a){return"topMouseDown"===a||"topTouchStart"===a},executeDirectDispatch:function(a){var b=a._dispatchListeners,c=a._dispatchInstances;Array.isArray(b)?w("103"):void 0;a.currentTarget=b?hb.getNodeFromInstance(c):null;b=b?b(a):null;a.currentTarget=null;a._dispatchListeners=null;a._dispatchInstances=null;return b},executeDispatchesInOrder:function(a,
b){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)gb(a,b,c[e],d[e]);else c&&gb(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null},executeDispatchesInOrderStopAtTrue:function(a){a:{var b=a._dispatchListeners;var c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++){if(b[d](a,c[d])){b=c[d];break a}}else if(b&&b(a,c)){b=c;break a}b=null}a._dispatchInstances=null;a._dispatchListeners=
null;return b},hasDispatches:function(a){return!!a._dispatchListeners},getFiberCurrentPropsFromNode:function(a){return fb.getFiberCurrentPropsFromNode(a)},getInstanceFromNode:function(a){return fb.getInstanceFromNode(a)},getNodeFromInstance:function(a){return fb.getNodeFromInstance(a)},injection:{injectComponentTree:function(a){fb=a}}},ib=hb,jb=null,kb=null,lb=null;
function mb(a){if(a=ib.getInstanceFromNode(a))if("number"===typeof a.tag){jb&&"function"===typeof jb.restoreControlledState?void 0:w("194");var b=ib.getFiberCurrentPropsFromNode(a.stateNode);jb.restoreControlledState(a.stateNode,a.type,b)}else"function"!==typeof a.restoreControlledState?w("195"):void 0,a.restoreControlledState()}
var nb={injection:{injectFiberControlledHostComponent:function(a){jb=a}},enqueueStateRestore:function(a){kb?lb?lb.push(a):lb=[a]:kb=a},restoreStateIfNeeded:function(){if(kb){var a=kb,b=lb;lb=kb=null;mb(a);if(b)for(a=0;a<b.length;a++)mb(b[a])}}};function ob(a,b,c,d,e,f){return a(b,c,d,e,f)}function pb(a,b){return a(b)}function qb(a,b){return pb(a,b)}
var rb=!1,sb={batchedUpdates:function(a,b){if(rb)return ob(qb,a,b);rb=!0;try{return ob(qb,a,b)}finally{rb=!1,nb.restoreStateIfNeeded()}},injection:{injectStackBatchedUpdates:function(a){ob=a},injectFiberBatchedUpdates:function(a){pb=a}}},tb=F.TEXT_NODE;function ub(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return a.nodeType===tb?a.parentNode:a}var vb=E.HostRoot,wb=[];
function xb(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c=b;if("number"===typeof c.tag){for(;c["return"];)c=c["return"];c=c.tag!==vb?null:c.stateNode.containerInfo}else{for(;c._hostParent;)c=c._hostParent;c=G.getNodeFromInstance(c).parentNode}if(!c)break;a.ancestors.push(b);b=G.getClosestInstanceFromNode(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],yb._handleTopLevel(a.topLevelType,b,a.nativeEvent,ub(a.nativeEvent))}
var yb={_enabled:!0,_handleTopLevel:null,setHandleTopLevel:function(a){yb._handleTopLevel=a},setEnabled:function(a){yb._enabled=!!a},isEnabled:function(){return yb._enabled},trapBubbledEvent:function(a,b,c){return c?ba.listen(c,b,yb.dispatchEvent.bind(null,a)):null},trapCapturedEvent:function(a,b,c){return c?ba.capture(c,b,yb.dispatchEvent.bind(null,a)):null},dispatchEvent:function(a,b){if(yb._enabled){var c=ub(b);c=G.getClosestInstanceFromNode(c);null===c||"number"!==typeof c.tag||bb.isFiberMounted(c)||
(c=null);if(wb.length){var d=wb.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{sb.batchedUpdates(xb,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>wb.length&&wb.push(a)}}}},L=yb;function Cb(a,b){null==b?w("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function Db(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Eb=null;function Fb(a,b){a&&(ib.executeDispatchesInOrder(a,b),a.isPersistent()||a.constructor.release(a))}function Gb(a){return Fb(a,!0)}function Hb(a){return Fb(a,!1)}
function Ib(a,b,c){switch(a){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":return!(!c.disabled||"button"!==b&&"input"!==b&&"select"!==b&&"textarea"!==b);default:return!1}}
var Jb={injection:{injectEventPluginOrder:sa.injectEventPluginOrder,injectEventPluginsByName:sa.injectEventPluginsByName},getListener:function(a,b){if("number"===typeof a.tag){var c=a.stateNode;if(!c)return null;var d=ib.getFiberCurrentPropsFromNode(c);if(!d)return null;c=d[b];if(Ib(b,a.type,d))return null}else{d=a._currentElement;if("string"===typeof d||"number"===typeof d||!a._rootNodeID)return null;a=d.props;c=a[b];if(Ib(b,d.type,a))return null}c&&"function"!==typeof c?w("231",b,typeof c):void 0;
return c},extractEvents:function(a,b,c,d){for(var e,f=sa.plugins,g=0;g<f.length;g++){var h=f[g];h&&(h=h.extractEvents(a,b,c,d))&&(e=Cb(e,h))}return e},enqueueEvents:function(a){a&&(Eb=Cb(Eb,a))},processEventQueue:function(a){var b=Eb;Eb=null;a?Db(b,Gb):Db(b,Hb);Eb?w("95"):void 0;eb.rethrowCaughtError()}},Kb;l.canUseDOM&&(Kb=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));
function Lb(a,b){if(!l.canUseDOM||b&&!("addEventListener"in document))return!1;b="on"+a;var c=b in document;c||(c=document.createElement("div"),c.setAttribute(b,"return;"),c="function"===typeof c[b]);!c&&Kb&&"wheel"===a&&(c=document.implementation.hasFeature("Events.wheel","3.0"));return c}function Mb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var Nb={animationend:Mb("Animation","AnimationEnd"),animationiteration:Mb("Animation","AnimationIteration"),animationstart:Mb("Animation","AnimationStart"),transitionend:Mb("Transition","TransitionEnd")},Ob={},Pb={};l.canUseDOM&&(Pb=document.createElement("div").style,"AnimationEvent"in window||(delete Nb.animationend.animation,delete Nb.animationiteration.animation,delete Nb.animationstart.animation),"TransitionEvent"in window||delete Nb.transitionend.transition);
function Qb(a){if(Ob[a])return Ob[a];if(!Nb[a])return a;var b=Nb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Pb)return Ob[a]=b[c];return""}
var Rb={topAbort:"abort",topAnimationEnd:Qb("animationend")||"animationend",topAnimationIteration:Qb("animationiteration")||"animationiteration",topAnimationStart:Qb("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",
topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",
topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:Qb("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},Sb={},Tb=0,Ub="_reactListenersID"+(""+Math.random()).slice(2);function Vb(a){Object.prototype.hasOwnProperty.call(a,Ub)||(a[Ub]=Tb++,Sb[a[Ub]]={});return Sb[a[Ub]]}
var M=n({},{handleTopLevel:function(a,b,c,d){a=Jb.extractEvents(a,b,c,d);Jb.enqueueEvents(a);Jb.processEventQueue(!1)}},{setEnabled:function(a){L&&L.setEnabled(a)},isEnabled:function(){return!(!L||!L.isEnabled())},listenTo:function(a,b){var c=Vb(b);a=sa.registrationNameDependencies[a];for(var d=0;d<a.length;d++){var e=a[d];c.hasOwnProperty(e)&&c[e]||("topWheel"===e?Lb("wheel")?L.trapBubbledEvent("topWheel","wheel",b):Lb("mousewheel")?L.trapBubbledEvent("topWheel","mousewheel",b):L.trapBubbledEvent("topWheel",
"DOMMouseScroll",b):"topScroll"===e?L.trapCapturedEvent("topScroll","scroll",b):"topFocus"===e||"topBlur"===e?(L.trapCapturedEvent("topFocus","focus",b),L.trapCapturedEvent("topBlur","blur",b),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(Lb("cancel",!0)&&L.trapCapturedEvent("topCancel","cancel",b),c.topCancel=!0):"topClose"===e?(Lb("close",!0)&&L.trapCapturedEvent("topClose","close",b),c.topClose=!0):Rb.hasOwnProperty(e)&&L.trapBubbledEvent(e,Rb[e],b),c[e]=!0)}},isListeningToAllDependencies:function(a,
b){b=Vb(b);a=sa.registrationNameDependencies[a];for(var c=0;c<a.length;c++){var d=a[c];if(!b.hasOwnProperty(d)||!b[d])return!1}return!0},trapBubbledEvent:function(a,b,c){return L.trapBubbledEvent(a,b,c)},trapCapturedEvent:function(a,b,c){return L.trapCapturedEvent(a,b,c)}}),Wb={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,
flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Xb=["Webkit","ms","Moz","O"];
Object.keys(Wb).forEach(function(a){Xb.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Wb[b]=Wb[a]})});
var Yb={isUnitlessNumber:Wb,shorthandPropertyExpansions:{background:{backgroundAttachment:!0,backgroundColor:!0,backgroundImage:!0,backgroundPositionX:!0,backgroundPositionY:!0,backgroundRepeat:!0},backgroundPosition:{backgroundPositionX:!0,backgroundPositionY:!0},border:{borderWidth:!0,borderStyle:!0,borderColor:!0},borderBottom:{borderBottomWidth:!0,borderBottomStyle:!0,borderBottomColor:!0},borderLeft:{borderLeftWidth:!0,borderLeftStyle:!0,borderLeftColor:!0},borderRight:{borderRightWidth:!0,borderRightStyle:!0,
borderRightColor:!0},borderTop:{borderTopWidth:!0,borderTopStyle:!0,borderTopColor:!0},font:{fontStyle:!0,fontVariant:!0,fontWeight:!0,fontSize:!0,lineHeight:!0,fontFamily:!0},outline:{outlineWidth:!0,outlineStyle:!0,outlineColor:!0}}},Zb=Yb.isUnitlessNumber,$b=!1;if(l.canUseDOM){var ac=document.createElement("div").style;try{ac.font=""}catch(a){$b=!0}}
var bc={createDangerousStringForStyles:function(){},setValueForStyles:function(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Zb.hasOwnProperty(e)&&Zb[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");if(d)a.setProperty(c,e);else if(e)a[c]=e;else if(d=$b&&Yb.shorthandPropertyExpansions[c])for(var g in d)a[g]="";else a[c]=""}}},cc=new RegExp("^["+A.ATTRIBUTE_NAME_START_CHAR+
"]["+A.ATTRIBUTE_NAME_CHAR+"]*$"),dc={},ec={};function fc(a){if(ec.hasOwnProperty(a))return!0;if(dc.hasOwnProperty(a))return!1;if(cc.test(a))return ec[a]=!0;dc[a]=!0;return!1}
var gc={setAttributeForID:function(a,b){a.setAttribute(A.ID_ATTRIBUTE_NAME,b)},setAttributeForRoot:function(a){a.setAttribute(A.ROOT_ATTRIBUTE_NAME,"")},getValueForProperty:function(){},getValueForAttribute:function(){},setValueForProperty:function(a,b,c){var d=A.getPropertyInfo(b);if(d&&A.shouldSetAttribute(b,c)){var e=d.mutationMethod;e?e(a,c):null==c||d.hasBooleanValue&&!c||d.hasNumericValue&&isNaN(c)||d.hasPositiveNumericValue&&1>c||d.hasOverloadedBooleanValue&&!1===c?gc.deleteValueForProperty(a,
b):d.mustUseProperty?a[d.propertyName]=c:(b=d.attributeName,(e=d.attributeNamespace)?a.setAttributeNS(e,b,""+c):d.hasBooleanValue||d.hasOverloadedBooleanValue&&!0===c?a.setAttribute(b,""):a.setAttribute(b,""+c))}else gc.setValueForAttribute(a,b,A.shouldSetAttribute(b,c)?c:null)},setValueForAttribute:function(a,b,c){fc(b)&&(null==c?a.removeAttribute(b):a.setAttribute(b,""+c))},deleteValueForAttribute:function(a,b){a.removeAttribute(b)},deleteValueForProperty:function(a,b){var c=A.getPropertyInfo(b);
c?(b=c.mutationMethod)?b(a,void 0):c.mustUseProperty?a[c.propertyName]=c.hasBooleanValue?!1:"":a.removeAttribute(c.attributeName):a.removeAttribute(b)}},hc=gc,ic=Qa.ReactDebugCurrentFrame;function jc(){return null}
var kc={current:null,phase:null,resetCurrentFiber:function(){ic.getCurrentStack=null;kc.current=null;kc.phase=null},setCurrentFiber:function(a,b){ic.getCurrentStack=jc;kc.current=a;kc.phase=b},getCurrentFiberOwnerName:function(){return null},getCurrentFiberStackAddendum:jc},lc=kc,mc={getHostProps:function(a,b){var c=b.value,d=b.checked;return n({type:void 0,step:void 0,min:void 0,max:void 0},b,{defaultChecked:void 0,defaultValue:void 0,value:null!=c?c:a._wrapperState.initialValue,checked:null!=d?
d:a._wrapperState.initialChecked})},initWrapperState:function(a,b){var c=b.defaultValue;a._wrapperState={initialChecked:null!=b.checked?b.checked:b.defaultChecked,initialValue:null!=b.value?b.value:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}},updateWrapper:function(a,b){var c=b.checked;null!=c&&hc.setValueForProperty(a,"checked",c||!1);c=b.value;if(null!=c)if(0===c&&""===a.value)a.value="0";else if("number"===b.type){if(b=parseFloat(a.value)||0,c!=b||c==b&&a.value!=
c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else null==b.value&&null!=b.defaultValue&&a.defaultValue!==""+b.defaultValue&&(a.defaultValue=""+b.defaultValue),null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)},postMountWrapper:function(a,b){switch(b.type){case "submit":case "reset":break;case "color":case "date":case "datetime":case "datetime-local":case "month":case "time":case "week":a.value="";a.value=a.defaultValue;break;default:a.value=a.value}b=a.name;""!==
b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)},restoreControlledState:function(a,b){mc.updateWrapper(a,b);var c=b.name;if("radio"===b.type&&null!=c){for(b=a;b.parentNode;)b=b.parentNode;c=b.querySelectorAll("input[name\x3d"+JSON.stringify(""+c)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=G.getFiberCurrentPropsFromNode(d);e?void 0:w("90");mc.updateWrapper(d,e)}}}}},qc=mc;
function rc(a){var b="";aa.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}var sc={validateProps:function(){},postMountWrapper:function(a,b){null!=b.value&&a.setAttribute("value",b.value)},getHostProps:function(a,b){a=n({children:void 0},b);if(b=rc(b.children))a.children=b;return a}};
function tc(a,b,c){a=a.options;if(b){b={};for(var d=0;d<c.length;d++)b["$"+c[d]]=!0;for(c=0;c<a.length;c++)d=b.hasOwnProperty("$"+a[c].value),a[c].selected!==d&&(a[c].selected=d)}else{c=""+c;b=null;for(d=0;d<a.length;d++){if(a[d].value===c){a[d].selected=!0;return}null!==b||a[d].disabled||(b=a[d])}null!==b&&(b.selected=!0)}}
var uc={getHostProps:function(a,b){return n({},b,{value:void 0})},initWrapperState:function(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}},postMountWrapper:function(a,b){a.multiple=!!b.multiple;var c=b.value;null!=c?tc(a,!!b.multiple,c):null!=b.defaultValue&&tc(a,!!b.multiple,b.defaultValue)},postUpdateWrapper:function(a,b){a._wrapperState.initialValue=void 0;var c=a._wrapperState.wasMultiple;a._wrapperState.wasMultiple=!!b.multiple;var d=b.value;
null!=d?tc(a,!!b.multiple,d):c!==!!b.multiple&&(null!=b.defaultValue?tc(a,!!b.multiple,b.defaultValue):tc(a,!!b.multiple,b.multiple?[]:""))},restoreControlledState:function(a,b){var c=b.value;null!=c&&tc(a,!!b.multiple,c)}},vc={getHostProps:function(a,b){null!=b.dangerouslySetInnerHTML?w("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})},initWrapperState:function(a,b){var c=b.value,d=c;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?
w("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:w("93"),b=b[0]),c=""+b),null==c&&(c=""),d=c);a._wrapperState={initialValue:""+d}},updateWrapper:function(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)},postMountWrapper:function(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)},restoreControlledState:function(a,b){vc.updateWrapper(a,b)}},wc=vc,xc=n({menuitem:!0},{area:!0,
base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});function yc(a,b){b&&(xc[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?w("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?w("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:w("61")),null!=b.style&&"object"!==typeof b.style?w("62",""):void 0)}
function zc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ac(a){var b=zc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{enumerable:c.enumerable,configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
var Bc={_getTrackerFromNode:function(a){return a._valueTracker},track:function(a){a._valueTracker||(a._valueTracker=Ac(a))},updateValueIfChanged:function(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=zc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1},stopTracking:function(a){(a=a._valueTracker)&&a.stopTracking()}};
function Cc(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
var Dc=ka.Namespaces,Ec,Fc=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Dc.svg||"innerHTML"in a)a.innerHTML=b;else for(Ec=Ec||document.createElement("div"),Ec.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e",b=Ec.firstChild;b.firstChild;)a.appendChild(b.firstChild)}),Gc=/["'&<>]/,Hc=F.TEXT_NODE;
function Ic(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&c.nodeType===Hc){c.nodeValue=b;return}}a.textContent=b}
l.canUseDOM&&("textContent"in document.documentElement||(Ic=function(a,b){if(a.nodeType===Hc)a.nodeValue=b;else{if("boolean"===typeof b||"number"===typeof b)b=""+b;else{b=""+b;var c=Gc.exec(b);if(c){var d="",e,f=0;for(e=c.index;e<b.length;e++){switch(b.charCodeAt(e)){case 34:c="\x26quot;";break;case 38:c="\x26amp;";break;case 39:c="\x26#x27;";break;case 60:c="\x26lt;";break;case 62:c="\x26gt;";break;default:continue}f!==e&&(d+=b.substring(f,e));f=e+1;d+=c}b=f!==e?d+b.substring(f,e):d}}Fc(a,b)}}));
var Jc=Ic,Kc=lc.getCurrentFiberOwnerName,Lc=F.DOCUMENT_NODE,Mc=F.DOCUMENT_FRAGMENT_NODE,Nc=M.listenTo,Oc=sa.registrationNameModules,Pc=ka.Namespaces.html,Qc=ka.getIntrinsicNamespace;function Rc(a,b){Nc(b,a.nodeType===Lc||a.nodeType===Mc?a:a.ownerDocument)}
var Sc={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",
topWaiting:"waiting"},N={createElement:function(a,b,c,d){c=c.nodeType===Lc?c:c.ownerDocument;d===Pc&&(d=Qc(a));d===Pc?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a},createTextNode:function(a,b){return(b.nodeType===Lc?b:b.ownerDocument).createTextNode(a)},setInitialProperties:function(a,b,c,d){var e=Cc(b,c);switch(b){case "iframe":case "object":M.trapBubbledEvent("topLoad",
"load",a);var f=c;break;case "video":case "audio":for(f in Sc)Sc.hasOwnProperty(f)&&M.trapBubbledEvent(f,Sc[f],a);f=c;break;case "source":M.trapBubbledEvent("topError","error",a);f=c;break;case "img":case "image":M.trapBubbledEvent("topError","error",a);M.trapBubbledEvent("topLoad","load",a);f=c;break;case "form":M.trapBubbledEvent("topReset","reset",a);M.trapBubbledEvent("topSubmit","submit",a);f=c;break;case "details":M.trapBubbledEvent("topToggle","toggle",a);f=c;break;case "input":qc.initWrapperState(a,
c);f=qc.getHostProps(a,c);M.trapBubbledEvent("topInvalid","invalid",a);Rc(d,"onChange");break;case "option":sc.validateProps(a,c);f=sc.getHostProps(a,c);break;case "select":uc.initWrapperState(a,c);f=uc.getHostProps(a,c);M.trapBubbledEvent("topInvalid","invalid",a);Rc(d,"onChange");break;case "textarea":wc.initWrapperState(a,c);f=wc.getHostProps(a,c);M.trapBubbledEvent("topInvalid","invalid",a);Rc(d,"onChange");break;default:f=c}yc(b,f,Kc);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===
h?bc.setValueForStyles(a,k):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&Fc(a,k)):"children"===h?"string"===typeof k?Jc(a,k):"number"===typeof k&&Jc(a,""+k):"suppressContentEditableWarning"!==h&&(Oc.hasOwnProperty(h)?null!=k&&Rc(d,h):e?hc.setValueForAttribute(a,h,k):null!=k&&hc.setValueForProperty(a,h,k))}switch(b){case "input":Bc.track(a);qc.postMountWrapper(a,c);break;case "textarea":Bc.track(a);wc.postMountWrapper(a,c);break;case "option":sc.postMountWrapper(a,c);break;case "select":uc.postMountWrapper(a,
c);break;default:"function"===typeof f.onClick&&(a.onclick=ca)}},diffProperties:function(a,b,c,d,e){var f=null;switch(b){case "input":c=qc.getHostProps(a,c);d=qc.getHostProps(a,d);f=[];break;case "option":c=sc.getHostProps(a,c);d=sc.getHostProps(a,d);f=[];break;case "select":c=uc.getHostProps(a,c);d=uc.getHostProps(a,d);f=[];break;case "textarea":c=wc.getHostProps(a,c);d=wc.getHostProps(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=ca)}yc(b,d,Kc);
var g,h;a=null;for(g in c)if(!d.hasOwnProperty(g)&&c.hasOwnProperty(g)&&null!=c[g])if("style"===g)for(h in b=c[g],b)b.hasOwnProperty(h)&&(a||(a={}),a[h]="");else"dangerouslySetInnerHTML"!==g&&"children"!==g&&"suppressContentEditableWarning"!==g&&(Oc.hasOwnProperty(g)?f||(f=[]):(f=f||[]).push(g,null));for(g in d){var k=d[g];b=null!=c?c[g]:void 0;if(d.hasOwnProperty(g)&&k!==b&&(null!=k||null!=b))if("style"===g)if(b){for(h in b)!b.hasOwnProperty(h)||k&&k.hasOwnProperty(h)||(a||(a={}),a[h]="");for(h in k)k.hasOwnProperty(h)&&
b[h]!==k[h]&&(a||(a={}),a[h]=k[h])}else a||(f||(f=[]),f.push(g,a)),a=k;else"dangerouslySetInnerHTML"===g?(k=k?k.__html:void 0,b=b?b.__html:void 0,null!=k&&b!==k&&(f=f||[]).push(g,""+k)):"children"===g?b===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(g,""+k):"suppressContentEditableWarning"!==g&&(Oc.hasOwnProperty(g)?(null!=k&&Rc(e,g),f||b===k||(f=[])):(f=f||[]).push(g,k))}a&&(f=f||[]).push("style",a);return f},updateProperties:function(a,b,c,d,e){Cc(c,d);d=Cc(c,e);for(var f=0;f<b.length;f+=
2){var g=b[f],h=b[f+1];"style"===g?bc.setValueForStyles(a,h):"dangerouslySetInnerHTML"===g?Fc(a,h):"children"===g?Jc(a,h):d?null!=h?hc.setValueForAttribute(a,g,h):hc.deleteValueForAttribute(a,g):null!=h?hc.setValueForProperty(a,g,h):hc.deleteValueForProperty(a,g)}switch(c){case "input":qc.updateWrapper(a,e);Bc.updateValueIfChanged(a);break;case "textarea":wc.updateWrapper(a,e);break;case "select":uc.postUpdateWrapper(a,e)}},diffHydratedProperties:function(a,b,c,d,e){switch(b){case "iframe":case "object":M.trapBubbledEvent("topLoad",
"load",a);break;case "video":case "audio":for(var f in Sc)Sc.hasOwnProperty(f)&&M.trapBubbledEvent(f,Sc[f],a);break;case "source":M.trapBubbledEvent("topError","error",a);break;case "img":case "image":M.trapBubbledEvent("topError","error",a);M.trapBubbledEvent("topLoad","load",a);break;case "form":M.trapBubbledEvent("topReset","reset",a);M.trapBubbledEvent("topSubmit","submit",a);break;case "details":M.trapBubbledEvent("topToggle","toggle",a);break;case "input":qc.initWrapperState(a,c);M.trapBubbledEvent("topInvalid",
"invalid",a);Rc(e,"onChange");break;case "option":sc.validateProps(a,c);break;case "select":uc.initWrapperState(a,c);M.trapBubbledEvent("topInvalid","invalid",a);Rc(e,"onChange");break;case "textarea":wc.initWrapperState(a,c),M.trapBubbledEvent("topInvalid","invalid",a),Rc(e,"onChange")}yc(b,c,Kc);d=null;for(var g in c)c.hasOwnProperty(g)&&(f=c[g],"children"===g?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):Oc.hasOwnProperty(g)&&
null!=f&&Rc(e,g));switch(b){case "input":Bc.track(a);qc.postMountWrapper(a,c);break;case "textarea":Bc.track(a);wc.postMountWrapper(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&(a.onclick=ca)}return d},diffHydratedText:function(a,b){return a.nodeValue!==b},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,
b,c){switch(b){case "input":qc.restoreControlledState(a,c);break;case "textarea":wc.restoreControlledState(a,c);break;case "select":uc.restoreControlledState(a,c)}}},Tc=void 0;
if(l.canUseDOM)if("function"!==typeof requestIdleCallback){var Uc=null,Vc=null,Wc=!1,Xc=!1,Yc=0,Zc=33,$c=33,ad={timeRemaining:"object"===typeof performance&&"function"===typeof performance.now?function(){return Yc-performance.now()}:function(){return Yc-Date.now()}},bd="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){a.source===window&&a.data===bd&&(Wc=!1,a=Vc,Vc=null,null!==a&&a(ad))},!1);var cd=function(a){Xc=!1;var b=a-Yc+$c;b<$c&&Zc<$c?(8>
b&&(b=8),$c=b<Zc?Zc:b):Zc=b;Yc=a+$c;Wc||(Wc=!0,window.postMessage(bd,"*"));b=Uc;Uc=null;null!==b&&b(a)};Tc=function(a){Vc=a;Xc||(Xc=!0,requestAnimationFrame(cd));return 0}}else Tc=requestIdleCallback;else Tc=function(a){setTimeout(function(){a({timeRemaining:function(){return Infinity}})});return 0};
var dd={rIC:Tc},ed={enableAsyncSubtreeAPI:!0},Q={NoWork:0,SynchronousPriority:1,TaskPriority:2,HighPriority:3,LowPriority:4,OffscreenPriority:5},fd=J.Callback,gd=Q.NoWork,hd=Q.SynchronousPriority,id=Q.TaskPriority,jd=E.ClassComponent,kd=E.HostRoot,md=void 0,nd=void 0;function od(a,b){return a!==id&&a!==hd||b!==id&&b!==hd?a===gd&&b!==gd?-255:a!==gd&&b===gd?255:a-b:0}function pd(){return{first:null,last:null,hasForceUpdate:!1,callbackList:null}}
function qd(a,b,c,d){null!==c?c.next=b:(b.next=a.first,a.first=b);null!==d?b.next=d:a.last=b}function rd(a,b){b=b.priorityLevel;var c=null;if(null!==a.last&&0>=od(a.last.priorityLevel,b))c=a.last;else for(a=a.first;null!==a&&0>=od(a.priorityLevel,b);)c=a,a=a.next;return c}
function sd(a,b){var c=a.alternate,d=a.updateQueue;null===d&&(d=a.updateQueue=pd());null!==c?(a=c.updateQueue,null===a&&(a=c.updateQueue=pd())):a=null;md=d;nd=a!==d?a:null;var e=md;c=nd;var f=rd(e,b),g=null!==f?f.next:e.first;if(null===c)return qd(e,b,f,g),null;d=rd(c,b);a=null!==d?d.next:c.first;qd(e,b,f,g);if(g===a&&null!==g||f===d&&null!==f)return null===d&&(c.first=b),null===a&&(c.last=null),null;b={priorityLevel:b.priorityLevel,partialState:b.partialState,callback:b.callback,isReplace:b.isReplace,
isForced:b.isForced,isTopLevelUnmount:b.isTopLevelUnmount,next:null};qd(c,b,d,a);return b}function td(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
var ud={addUpdate:function(a,b,c,d){sd(a,{priorityLevel:d,partialState:b,callback:c,isReplace:!1,isForced:!1,isTopLevelUnmount:!1,next:null})},addReplaceUpdate:function(a,b,c,d){sd(a,{priorityLevel:d,partialState:b,callback:c,isReplace:!0,isForced:!1,isTopLevelUnmount:!1,next:null})},addForceUpdate:function(a,b,c){sd(a,{priorityLevel:c,partialState:null,callback:b,isReplace:!1,isForced:!0,isTopLevelUnmount:!1,next:null})},getUpdatePriority:function(a){var b=a.updateQueue;return null===b||a.tag!==
jd&&a.tag!==kd?gd:null!==b.first?b.first.priorityLevel:gd},addTopLevelUpdate:function(a,b,c,d){var e=null===b.element;b={priorityLevel:d,partialState:b,callback:c,isReplace:!1,isForced:!1,isTopLevelUnmount:e,next:null};a=sd(a,b);e&&(e=md,c=nd,null!==e&&null!==b.next&&(b.next=null,e.last=b),null!==c&&null!==a&&null!==a.next&&(a.next=null,c.last=b))},beginUpdateQueue:function(a,b,c,d,e,f,g){null!==a&&a.updateQueue===c&&(c=b.updateQueue={first:c.first,last:c.last,callbackList:null,hasForceUpdate:!1});
a=c.callbackList;for(var h=c.hasForceUpdate,k=!0,p=c.first;null!==p&&0>=od(p.priorityLevel,g);){c.first=p.next;null===c.first&&(c.last=null);var x;if(p.isReplace)e=td(p,d,e,f),k=!0;else if(x=td(p,d,e,f))e=k?n({},e,x):n(e,x),k=!1;p.isForced&&(h=!0);null===p.callback||p.isTopLevelUnmount&&null!==p.next||(a=null!==a?a:[],a.push(p.callback),b.effectTag|=fd);p=p.next}c.callbackList=a;c.hasForceUpdate=h;null!==c.first||null!==a||h||(b.updateQueue=null);return e},commitCallbacks:function(a,b,c){a=b.callbackList;
if(null!==a)for(b.callbackList=null,b=0;b<a.length;b++){var d=a[b];"function"!==typeof d?w("191",d):void 0;d.call(c)}}},vd=[],wd=-1,xd={createCursor:function(a){return{current:a}},isEmpty:function(){return-1===wd},pop:function(a){0>wd||(a.current=vd[wd],vd[wd]=null,wd--)},push:function(a,b){wd++;vd[wd]=a.current;a.current=b},reset:function(){for(;-1<wd;)vd[wd]=null,wd--}},yd=bb.isFiberMounted,zd=E.ClassComponent,Ad=E.HostRoot,Bd=xd.createCursor,Cd=xd.pop,Dd=xd.push,Ed=Bd(da),Fd=Bd(!1),Ld=da;
function Md(a,b,c){a=a.stateNode;a.__reactInternalMemoizedUnmaskedChildContext=b;a.__reactInternalMemoizedMaskedChildContext=c}function Nd(a){return a.tag===zd&&null!=a.type.childContextTypes}function Od(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:w("108",Ra(a)||"Unknown",e);return n({},b,c)}
var R={getUnmaskedContext:function(a){return Nd(a)?Ld:Ed.current},cacheContext:Md,getMaskedContext:function(a,b){var c=a.type.contextTypes;if(!c)return da;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&Md(a,b,e);return e},hasContextChanged:function(){return Fd.current},isContextConsumer:function(a){return a.tag===zd&&null!=a.type.contextTypes},isContextProvider:Nd,popContextProvider:function(a){Nd(a)&&
(Cd(Fd,a),Cd(Ed,a))},popTopLevelContextObject:function(a){Cd(Fd,a);Cd(Ed,a)},pushTopLevelContextObject:function(a,b,c){null!=Ed.cursor?w("168"):void 0;Dd(Ed,b,a);Dd(Fd,c,a)},processChildContext:Od,pushContextProvider:function(a){if(!Nd(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||da;Ld=Ed.current;Dd(Ed,b,a);Dd(Fd,Fd.current,a);return!0},invalidateContextProvider:function(a,b){var c=a.stateNode;c?void 0:w("169");if(b){var d=Od(a,Ld,!0);c.__reactInternalMemoizedMergedChildContext=
d;Cd(Fd,a);Cd(Ed,a);Dd(Ed,d,a)}else Cd(Fd,a);Dd(Fd,b,a)},resetContext:function(){Ld=da;Ed.current=da;Fd.current=!1},findCurrentUnmaskedContext:function(a){for(yd(a)&&a.tag===zd?void 0:w("170");a.tag!==Ad;){if(Nd(a))return a.stateNode.__reactInternalMemoizedMergedChildContext;(a=a["return"])?void 0:w("171")}return a.stateNode.context}},Pd={NoContext:0,AsyncUpdates:1},Qd=E.IndeterminateComponent,Rd=E.ClassComponent,Sd=E.HostRoot,Td=E.HostComponent,Ud=E.HostText,Vd=E.HostPortal,Wd=E.CoroutineComponent,
Xd=E.YieldComponent,Yd=E.Fragment,Zd=Q.NoWork,$d=Pd.NoContext,ae=J.NoEffect;function be(a,b,c){this.tag=a;this.key=b;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null;this.internalContextTag=c;this.effectTag=ae;this.lastEffect=this.firstEffect=this.nextEffect=null;this.pendingWorkPriority=Zd;this.alternate=null}
function ce(a,b,c){var d=void 0;"function"===typeof a?(d=a.prototype&&a.prototype.isReactComponent?new be(Rd,b,c):new be(Qd,b,c),d.type=a):"string"===typeof a?(d=new be(Td,b,c),d.type=a):"object"===typeof a&&null!==a&&"number"===typeof a.tag?d=a:w("130",null==a?a:typeof a,"");return d}
var de={createWorkInProgress:function(a,b){var c=a.alternate;null===c?(c=new be(a.tag,a.key,a.internalContextTag),c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.effectTag=ae,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.pendingWorkPriority=b;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c},createHostRootFiber:function(){return new be(Sd,null,$d)},
createFiberFromElement:function(a,b,c){b=ce(a.type,a.key,b,null);b.pendingProps=a.props;b.pendingWorkPriority=c;return b},createFiberFromFragment:function(a,b,c){b=new be(Yd,null,b);b.pendingProps=a;b.pendingWorkPriority=c;return b},createFiberFromText:function(a,b,c){b=new be(Ud,null,b);b.pendingProps=a;b.pendingWorkPriority=c;return b},createFiberFromElementType:ce,createFiberFromHostInstanceForDeletion:function(){var a=new be(Td,null,$d);a.type="DELETED";return a},createFiberFromCoroutine:function(a,
b,c){b=new be(Wd,a.key,b);b.type=a.handler;b.pendingProps=a;b.pendingWorkPriority=c;return b},createFiberFromYield:function(a,b){return new be(Xd,null,b)},createFiberFromPortal:function(a,b,c){b=new be(Vd,a.key,b);b.pendingProps=a.children||[];b.pendingWorkPriority=c;b.stateNode={containerInfo:a.containerInfo,implementation:a.implementation};return b},largerPriority:function(a,b){return a!==Zd&&(b===Zd||b>a)?a:b}},ee=de.createHostRootFiber,fe=E.IndeterminateComponent,ge=E.FunctionalComponent,he=E.ClassComponent,
ie=E.HostComponent,je,ke;"function"===typeof Symbol&&Symbol["for"]?(je=Symbol["for"]("react.coroutine"),ke=Symbol["for"]("react.yield")):(je=60104,ke=60105);
var le={createCoroutine:function(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:je,key:null==d?null:""+d,children:a,handler:b,props:c}},createYield:function(a){return{$$typeof:ke,value:a}},isCoroutine:function(a){return"object"===typeof a&&null!==a&&a.$$typeof===je},isYield:function(a){return"object"===typeof a&&null!==a&&a.$$typeof===ke},REACT_YIELD_TYPE:ke,REACT_COROUTINE_TYPE:je},me="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.portal")||
60106,ne={createPortal:function(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:me,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}},isPortal:function(a){return"object"===typeof a&&null!==a&&a.$$typeof===me},REACT_PORTAL_TYPE:me},oe=le.REACT_COROUTINE_TYPE,pe=le.REACT_YIELD_TYPE,qe=ne.REACT_PORTAL_TYPE,re=de.createWorkInProgress,se=de.createFiberFromElement,te=de.createFiberFromFragment,ue=de.createFiberFromText,ve=de.createFiberFromCoroutine,
we=de.createFiberFromYield,xe=de.createFiberFromPortal,ye=Array.isArray,ze=E.FunctionalComponent,Ae=E.ClassComponent,Be=E.HostText,Ce=E.HostPortal,De=E.CoroutineComponent,Ee=E.YieldComponent,Fe=E.Fragment,Ge=J.NoEffect,He=J.Placement,Ie=J.Deletion,Je="function"===typeof Symbol&&Symbol.iterator,Ke="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.element")||60103;
function Le(a){if(null===a||"undefined"===typeof a)return null;a=Je&&a[Je]||a["@@iterator"];return"function"===typeof a?a:null}
function Me(a,b){var c=b.ref;if(null!==c&&"function"!==typeof c){if(b._owner){b=b._owner;var d=void 0;b&&("number"===typeof b.tag?(b.tag!==Ae?w("110"):void 0,d=b.stateNode):d=b.getPublicInstance());d?void 0:w("147",c);var e=""+c;if(null!==a&&null!==a.ref&&a.ref._stringRef===e)return a.ref;a=function(a){var b=d.refs===da?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};a._stringRef=e;return a}"string"!==typeof c?w("148"):void 0;b._owner?void 0:w("149",c)}return c}
function Ne(a,b){"textarea"!==a.type&&w("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Oe(a,b){function c(c,d){if(b){if(!a){if(null===d.alternate)return;d=d.alternate}var m=c.lastEffect;null!==m?(m.nextEffect=d,c.lastEffect=d):c.firstEffect=c.lastEffect=d;d.nextEffect=null;d.effectTag=Ie}}function d(a,d){if(!b)return null;for(;null!==d;)c(a,d),d=d.sibling;return null}function e(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function f(b,c){if(a)return b=re(b,c),b.index=0,b.sibling=null,b;b.pendingWorkPriority=c;b.effectTag=Ge;
b.index=0;b.sibling=null;return b}function g(a,c,d){a.index=d;if(!b)return c;d=a.alternate;if(null!==d)return d=d.index,d<c?(a.effectTag=He,c):d;a.effectTag=He;return c}function h(a){b&&null===a.alternate&&(a.effectTag=He);return a}function k(a,b,c,d){if(null===b||b.tag!==Be)return c=ue(c,a.internalContextTag,d),c["return"]=a,c;b=f(b,d);b.pendingProps=c;b["return"]=a;return b}function p(a,b,c,d){if(null===b||b.type!==c.type)return d=se(c,a.internalContextTag,d),d.ref=Me(b,c),d["return"]=a,d;d=f(b,
d);d.ref=Me(b,c);d.pendingProps=c.props;d["return"]=a;return d}function x(a,b,c,d){if(null===b||b.tag!==De)return c=ve(c,a.internalContextTag,d),c["return"]=a,c;b=f(b,d);b.pendingProps=c;b["return"]=a;return b}function S(a,b,c,d){if(null===b||b.tag!==Ee)return b=we(c,a.internalContextTag,d),b.type=c.value,b["return"]=a,b;b=f(b,d);b.type=c.value;b["return"]=a;return b}function D(a,b,c,d){if(null===b||b.tag!==Ce||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return c=
xe(c,a.internalContextTag,d),c["return"]=a,c;b=f(b,d);b.pendingProps=c.children||[];b["return"]=a;return b}function y(a,b,c,d){if(null===b||b.tag!==Fe)return c=te(c,a.internalContextTag,d),c["return"]=a,c;b=f(b,d);b.pendingProps=c;b["return"]=a;return b}function B(a,b,c){if("string"===typeof b||"number"===typeof b)return b=ue(""+b,a.internalContextTag,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Ke:return c=se(b,a.internalContextTag,c),c.ref=Me(null,b),c["return"]=
a,c;case oe:return b=ve(b,a.internalContextTag,c),b["return"]=a,b;case pe:return c=we(b,a.internalContextTag,c),c.type=b.value,c["return"]=a,c;case qe:return b=xe(b,a.internalContextTag,c),b["return"]=a,b}if(ye(b)||Le(b))return b=te(b,a.internalContextTag,c),b["return"]=a,b;Ne(a,b)}return null}function H(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:k(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Ke:return c.key===e?p(a,
b,c,d):null;case oe:return c.key===e?x(a,b,c,d):null;case pe:return null===e?S(a,b,c,d):null;case qe:return c.key===e?D(a,b,c,d):null}if(ye(c)||Le(c))return null!==e?null:y(a,b,c,d);Ne(a,c)}return null}function C(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,k(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Ke:return a=a.get(null===d.key?c:d.key)||null,p(b,a,d,e);case oe:return a=a.get(null===d.key?c:d.key)||null,x(b,a,d,e);case pe:return a=a.get(c)||
null,S(b,a,d,e);case qe:return a=a.get(null===d.key?c:d.key)||null,D(b,a,d,e)}if(ye(d)||Le(d))return a=a.get(c)||null,y(b,a,d,e);Ne(b,d)}return null}function Ca(a,f,h,k){for(var m=null,t=null,q=f,r=f=0,p=null;null!==q&&r<h.length;r++){q.index>r?(p=q,q=null):p=q.sibling;var v=H(a,q,h[r],k);if(null===v){null===q&&(q=p);break}b&&q&&null===v.alternate&&c(a,q);f=g(v,f,r);null===t?m=v:t.sibling=v;t=v;q=p}if(r===h.length)return d(a,q),m;if(null===q){for(;r<h.length;r++)if(q=B(a,h[r],k))f=g(q,f,r),null===
t?m=q:t.sibling=q,t=q;return m}for(q=e(a,q);r<h.length;r++)if(p=C(q,a,r,h[r],k)){if(b&&null!==p.alternate)q["delete"](null===p.key?r:p.key);f=g(p,f,r);null===t?m=p:t.sibling=p;t=p}b&&q.forEach(function(b){return c(a,b)});return m}function r(a,f,h,r){var m=Le(h);"function"!==typeof m?w("150"):void 0;h=m.call(h);null==h?w("151"):void 0;for(var t=m=null,q=f,k=f=0,p=null,v=h.next();null!==q&&!v.done;k++,v=h.next()){q.index>k?(p=q,q=null):p=q.sibling;var V=H(a,q,v.value,r);if(null===V){q||(q=p);break}b&&
q&&null===V.alternate&&c(a,q);f=g(V,f,k);null===t?m=V:t.sibling=V;t=V;q=p}if(v.done)return d(a,q),m;if(null===q){for(;!v.done;k++,v=h.next())v=B(a,v.value,r),null!==v&&(f=g(v,f,k),null===t?m=v:t.sibling=v,t=v);return m}for(q=e(a,q);!v.done;k++,v=h.next())if(v=C(q,a,k,v.value,r),null!==v){if(b&&null!==v.alternate)q["delete"](null===v.key?k:v.key);f=g(v,f,k);null===t?m=v:t.sibling=v;t=v}b&&q.forEach(function(b){return c(a,b)});return m}return function(a,b,e,g){var m="object"===typeof e&&null!==e;if(m)switch(e.$$typeof){case Ke:a:{var C=
e.key;for(m=b;null!==m;){if(m.key===C)if(m.type===e.type){d(a,m.sibling);b=f(m,g);b.ref=Me(m,e);b.pendingProps=e.props;b["return"]=a;a=b;break a}else{d(a,m);break}else c(a,m);m=m.sibling}g=se(e,a.internalContextTag,g);g.ref=Me(b,e);g["return"]=a;a=g}return h(a);case oe:a:{for(m=e.key;null!==b;){if(b.key===m)if(b.tag===De){d(a,b.sibling);b=f(b,g);b.pendingProps=e;b["return"]=a;a=b;break a}else{d(a,b);break}else c(a,b);b=b.sibling}e=ve(e,a.internalContextTag,g);e["return"]=a;a=e}return h(a);case pe:a:{if(null!==
b)if(b.tag===Ee){d(a,b.sibling);b=f(b,g);b.type=e.value;b["return"]=a;a=b;break a}else d(a,b);b=we(e,a.internalContextTag,g);b.type=e.value;b["return"]=a;a=b}return h(a);case qe:a:{for(m=e.key;null!==b;){if(b.key===m)if(b.tag===Ce&&b.stateNode.containerInfo===e.containerInfo&&b.stateNode.implementation===e.implementation){d(a,b.sibling);b=f(b,g);b.pendingProps=e.children||[];b["return"]=a;a=b;break a}else{d(a,b);break}else c(a,b);b=b.sibling}e=xe(e,a.internalContextTag,g);e["return"]=a;a=e}return h(a)}if("string"===
typeof e||"number"===typeof e)return e=""+e,null!==b&&b.tag===Be?(d(a,b.sibling),b=f(b,g),b.pendingProps=e,b["return"]=a,a=b):(d(a,b),e=ue(e,a.internalContextTag,g),e["return"]=a,a=e),h(a);if(ye(e))return Ca(a,b,e,g);if(Le(e))return r(a,b,e,g);m&&Ne(a,e);if("undefined"===typeof e)switch(a.tag){case Ae:case ze:e=a.type,w("152",e.displayName||e.name||"Component")}return d(a,b)}}
var Pe=Oe(!0,!0),Qe=Oe(!1,!0),Re=Oe(!1,!1),Se={reconcileChildFibers:Pe,reconcileChildFibersInPlace:Qe,mountChildFibersInPlace:Re,cloneChildFibers:function(a,b){null!==a&&b.child!==a.child?w("153"):void 0;if(null!==b.child){a=b.child;var c=re(a,a.pendingWorkPriority);c.pendingProps=a.pendingProps;b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=re(a,a.pendingWorkPriority),c.pendingProps=a.pendingProps,c["return"]=b;c.sibling=null}}},Te=J.Update,Ue=Pd.AsyncUpdates,Ve=R.cacheContext,
We=R.getMaskedContext,Xe=R.getUnmaskedContext,Ye=R.isContextConsumer,Ze=ud.addUpdate,$e=ud.addReplaceUpdate,af=ud.addForceUpdate,bf=ud.beginUpdateQueue,cf=R.hasContextChanged,df=bb.isMounted;
function ef(a,b,c,d){function e(a,b){b.updater=f;a.stateNode=b;Pa.set(b,a)}var f={isMounted:df,enqueueSetState:function(c,d,e){c=Pa.get(c);var f=b(c,!1);Ze(c,d,void 0===e?null:e,f);a(c,f)},enqueueReplaceState:function(c,d,e){c=Pa.get(c);var f=b(c,!1);$e(c,d,void 0===e?null:e,f);a(c,f)},enqueueForceUpdate:function(c,d){c=Pa.get(c);var e=b(c,!1);af(c,void 0===d?null:d,e);a(c,e)}};return{adoptClassInstance:e,constructClassInstance:function(a,b){var c=a.type,d=Xe(a),f=Ye(a),g=f?We(a,d):da;b=new c(b,g);
e(a,b);f&&Ve(a,d,g);return b},mountClassInstance:function(a,b){var c=a.alternate,d=a.stateNode,e=d.state||null,g=a.pendingProps;g?void 0:w("158");var h=Xe(a);d.props=g;d.state=e;d.refs=da;d.context=We(a,h);ed.enableAsyncSubtreeAPI&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent&&(a.internalContextTag|=Ue);"function"===typeof d.componentWillMount&&(h=d.state,d.componentWillMount(),h!==d.state&&f.enqueueReplaceState(d,d.state,null),h=a.updateQueue,null!==
h&&(d.state=bf(c,a,h,d,e,g,b)));"function"===typeof d.componentDidMount&&(a.effectTag|=Te)},updateClassInstance:function(a,b,e){var g=b.stateNode;g.props=b.memoizedProps;g.state=b.memoizedState;var h=b.memoizedProps,k=b.pendingProps;k||(k=h,null==k?w("159"):void 0);var D=g.context,y=Xe(b);y=We(b,y);"function"!==typeof g.componentWillReceiveProps||h===k&&D===y||(D=g.state,g.componentWillReceiveProps(k,y),g.state!==D&&f.enqueueReplaceState(g,g.state,null));D=b.memoizedState;e=null!==b.updateQueue?bf(a,
b,b.updateQueue,g,D,k,e):D;if(!(h!==k||D!==e||cf()||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&D===a.memoizedState||(b.effectTag|=Te),!1;var B=k;if(null===h||null!==b.updateQueue&&b.updateQueue.hasForceUpdate)B=!0;else{var H=b.stateNode,C=b.type;B="function"===typeof H.shouldComponentUpdate?H.shouldComponentUpdate(B,e,y):C.prototype&&C.prototype.isPureReactComponent?!ea(h,B)||!ea(D,e):!0}B?("function"===typeof g.componentWillUpdate&&
g.componentWillUpdate(k,e,y),"function"===typeof g.componentDidUpdate&&(b.effectTag|=Te)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&D===a.memoizedState||(b.effectTag|=Te),c(b,k),d(b,e));g.props=k;g.state=e;g.context=y;return B}}}
var ff=Se.mountChildFibersInPlace,gf=Se.reconcileChildFibers,hf=Se.reconcileChildFibersInPlace,jf=Se.cloneChildFibers,kf=ud.beginUpdateQueue,lf=R.getMaskedContext,mf=R.getUnmaskedContext,nf=R.hasContextChanged,of=R.pushContextProvider,pf=R.pushTopLevelContextObject,qf=R.invalidateContextProvider,rf=E.IndeterminateComponent,sf=E.FunctionalComponent,tf=E.ClassComponent,uf=E.HostRoot,wf=E.HostComponent,xf=E.HostText,yf=E.HostPortal,zf=E.CoroutineComponent,Af=E.CoroutineHandlerPhase,Bf=E.YieldComponent,
Cf=E.Fragment,Df=Q.NoWork,Ef=Q.OffscreenPriority,Ff=J.PerformedWork,Gf=J.Placement,Hf=J.ContentReset,If=J.Err,Jf=J.Ref,Kf=Qa.ReactCurrentOwner;
function Lf(a,b,c,d,e){function f(a,b,c){g(a,b,c,b.pendingWorkPriority)}function g(a,b,c,d){b.child=null===a?ff(b,b.child,c,d):a.child===b.child?gf(b,b.child,c,d):hf(b,b.child,c,d)}function h(a,b){var c=b.ref;null===c||a&&a.ref===c||(b.effectTag|=Jf)}function k(a,b,c,d){h(a,b);if(!c)return d&&qf(b,!1),x(a,b);c=b.stateNode;Kf.current=b;var e=c.render();b.effectTag|=Ff;f(a,b,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&qf(b,!0);return b.child}function p(a){var b=a.stateNode;b.pendingContext?
pf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&pf(a,b.context,!1);C(a,b.containerInfo)}function x(a,b){jf(a,b);return b.child}function S(a,b){switch(b.tag){case uf:p(b);break;case tf:of(b);break;case yf:C(b,b.stateNode.containerInfo)}return null}var D=a.shouldSetTextContent,y=a.useSyncScheduling,B=a.shouldDeprioritizeSubtree,H=b.pushHostContext,C=b.pushHostContainer,Ca=c.enterHydrationState,r=c.resetHydrationState,m=c.tryToClaimNextHydratableInstance;a=ef(d,e,function(a,b){a.memoizedProps=
b},function(a,b){a.memoizedState=b});var t=a.adoptClassInstance,v=a.constructClassInstance,V=a.mountClassInstance,ld=a.updateClassInstance;return{beginWork:function(a,b,c){if(b.pendingWorkPriority===Df||b.pendingWorkPriority>c)return S(a,b);switch(b.tag){case rf:null!==a?w("155"):void 0;var d=b.type,e=b.pendingProps,g=mf(b);g=lf(b,g);d=d(e,g);b.effectTag|=Ff;"object"===typeof d&&null!==d&&"function"===typeof d.render?(b.tag=tf,e=of(b),t(b,d),V(b,c),b=k(a,b,!0,e)):(b.tag=sf,f(a,b,d),b.memoizedProps=
e,b=b.child);return b;case sf:a:{e=b.type;c=b.pendingProps;d=b.memoizedProps;if(nf())null===c&&(c=d);else if(null===c||d===c){b=x(a,b);break a}d=mf(b);d=lf(b,d);e=e(c,d);b.effectTag|=Ff;f(a,b,e);b.memoizedProps=c;b=b.child}return b;case tf:return e=of(b),d=void 0,null===a?b.stateNode?w("153"):(v(b,b.pendingProps),V(b,c),d=!0):d=ld(a,b,c),k(a,b,d,e);case uf:return p(b),d=b.updateQueue,null!==d?(e=b.memoizedState,d=kf(a,b,d,null,e,null,c),e===d?(r(),b=x(a,b)):(e=d.element,null!==a&&null!==a.child||
!Ca(b)?(r(),f(a,b,e)):(b.effectTag|=Gf,b.child=ff(b,b.child,e,c)),b.memoizedState=d,b=b.child)):(r(),b=x(a,b)),b;case wf:H(b);null===a&&m(b);e=b.type;var q=b.memoizedProps;d=b.pendingProps;null===d&&(d=q,null===d?w("154"):void 0);g=null!==a?a.memoizedProps:null;nf()||null!==d&&q!==d?(q=d.children,D(e,d)?q=null:g&&D(e,g)&&(b.effectTag|=Hf),h(a,b),c!==Ef&&!y&&B(e,d)?(b.pendingWorkPriority=Ef,b=null):(f(a,b,q),b.memoizedProps=d,b=b.child)):b=x(a,b);return b;case xf:return null===a&&m(b),a=b.pendingProps,
null===a&&(a=b.memoizedProps),b.memoizedProps=a,null;case Af:b.tag=zf;case zf:c=b.pendingProps;if(nf())null===c&&(c=a&&a.memoizedProps,null===c?w("154"):void 0);else if(null===c||b.memoizedProps===c)c=b.memoizedProps;e=c.children;d=b.pendingWorkPriority;b.stateNode=null===a?ff(b,b.stateNode,e,d):a.child===b.child?gf(b,b.stateNode,e,d):hf(b,b.stateNode,e,d);b.memoizedProps=c;return b.stateNode;case Bf:return null;case yf:a:{C(b,b.stateNode.containerInfo);c=b.pendingWorkPriority;e=b.pendingProps;if(nf())null===
e&&(e=a&&a.memoizedProps,null==e?w("154"):void 0);else if(null===e||b.memoizedProps===e){b=x(a,b);break a}null===a?b.child=hf(b,b.child,e,c):f(a,b,e);b.memoizedProps=e;b=b.child}return b;case Cf:a:{c=b.pendingProps;if(nf())null===c&&(c=b.memoizedProps);else if(null===c||b.memoizedProps===c){b=x(a,b);break a}f(a,b,c);b.memoizedProps=c;b=b.child}return b;default:w("156")}},beginFailedWork:function(a,b,c){switch(b.tag){case tf:of(b);break;case uf:p(b);break;default:w("157")}b.effectTag|=If;null===a?
b.child=null:b.child!==a.child&&(b.child=a.child);if(b.pendingWorkPriority===Df||b.pendingWorkPriority>c)return S(a,b);b.firstEffect=null;b.lastEffect=null;g(a,b,null,c);b.tag===tf&&(a=b.stateNode,b.memoizedProps=a.props,b.memoizedState=a.state);return b.child}}}
var Mf=Se.reconcileChildFibers,Nf=R.popContextProvider,Of=R.popTopLevelContextObject,Pf=E.IndeterminateComponent,Qf=E.FunctionalComponent,Rf=E.ClassComponent,Sf=E.HostRoot,Tf=E.HostComponent,Uf=E.HostText,Vf=E.HostPortal,Wf=E.CoroutineComponent,Xf=E.CoroutineHandlerPhase,Yf=E.YieldComponent,Zf=E.Fragment,ag=J.Placement,bg=J.Ref,cg=J.Update,dg=Q.OffscreenPriority;
function eg(a,b,c){var d=a.createInstance,e=a.createTextInstance,f=a.appendInitialChild,g=a.finalizeInitialChildren,h=a.prepareUpdate,k=b.getRootHostContainer,p=b.popHostContext,x=b.getHostContext,S=b.popHostContainer,D=c.prepareToHydrateHostInstance,y=c.prepareToHydrateHostTextInstance,B=c.popHydrationState;return{completeWork:function(a,b,c){var r=b.pendingProps;if(null===r)r=b.memoizedProps;else if(b.pendingWorkPriority!==dg||c===dg)b.pendingProps=null;switch(b.tag){case Qf:return null;case Rf:return Nf(b),
null;case Sf:S(b);Of(b);r=b.stateNode;r.pendingContext&&(r.context=r.pendingContext,r.pendingContext=null);if(null===a||null===a.child)B(b),b.effectTag&=~ag;return null;case Tf:p(b);c=k();var m=b.type;if(null!==a&&null!=b.stateNode){var t=a.memoizedProps,C=b.stateNode,V=x();r=h(C,m,t,r,c,V);if(b.updateQueue=r)b.effectTag|=cg;a.ref!==b.ref&&(b.effectTag|=bg)}else{if(!r)return null===b.stateNode?w("166"):void 0,null;a=x();if(B(b))D(b,c,a)&&(b.effectTag|=cg);else{a=d(m,r,c,a,b);a:for(t=b.child;null!==
t;){if(t.tag===Tf||t.tag===Uf)f(a,t.stateNode);else if(t.tag!==Vf&&null!==t.child){t=t.child;continue}if(t===b)break a;for(;null===t.sibling;){if(null===t["return"]||t["return"]===b)break a;t=t["return"]}t=t.sibling}g(a,m,r,c)&&(b.effectTag|=cg);b.stateNode=a}null!==b.ref&&(b.effectTag|=bg)}return null;case Uf:if(a&&null!=b.stateNode)a.memoizedProps!==r&&(b.effectTag|=cg);else{if("string"!==typeof r)return null===b.stateNode?w("166"):void 0,null;a=k();c=x();B(b)?y(b)&&(b.effectTag|=cg):b.stateNode=
e(r,a,c,b)}return null;case Wf:(r=b.memoizedProps)?void 0:w("165");b.tag=Xf;c=[];a:for((m=b.stateNode)&&(m["return"]=b);null!==m;){if(m.tag===Tf||m.tag===Uf||m.tag===Vf)w("164");else if(m.tag===Yf)c.push(m.type);else if(null!==m.child){m.child["return"]=m;m=m.child;continue}for(;null===m.sibling;){if(null===m["return"]||m["return"]===b)break a;m=m["return"]}m.sibling["return"]=m["return"];m=m.sibling}m=r.handler;r=m(r.props,c);b.child=Mf(b,null!==a?a.child:null,r,b.pendingWorkPriority);return b.child;
case Xf:return b.tag=Wf,null;case Yf:return null;case Zf:return null;case Vf:return b.effectTag|=cg,S(b),null;case Pf:w("167");default:w("156")}}}}var fg=null,gg=null;function hg(a){return function(b){try{return a(b)}catch(c){}}}
var ig={injectInternals:function(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(!b.supportsFiber)return!0;try{var c=b.inject(a);fg=hg(function(a){return b.onCommitFiberRoot(c,a)});gg=hg(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0},onCommitRoot:function(a){"function"===typeof fg&&fg(a)},onCommitUnmount:function(a){"function"===typeof gg&&gg(a)}},jg=E.ClassComponent,kg=E.HostRoot,lg=E.HostComponent,mg=E.HostText,ng=
E.HostPortal,og=E.CoroutineComponent,pg=ud.commitCallbacks,qg=ig.onCommitUnmount,rg=J.Placement,sg=J.Update,tg=J.Callback,ug=J.ContentReset;
function vg(a,b){function c(a){var c=a.ref;if(null!==c)try{c(null)}catch(t){b(a,t)}}function d(a){return a.tag===lg||a.tag===kg||a.tag===ng}function e(a){for(var b=a;;)if(g(b),null!==b.child&&b.tag!==ng)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}function f(a){for(var b=a,c=!1,d=void 0,f=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?w("160"):void 0;switch(c.tag){case lg:d=
c.stateNode;f=!1;break a;case kg:d=c.stateNode.containerInfo;f=!0;break a;case ng:d=c.stateNode.containerInfo;f=!0;break a}c=c["return"]}c=!0}if(b.tag===lg||b.tag===mg)e(b),f?C(d,b.stateNode):H(d,b.stateNode);else if(b.tag===ng?d=b.stateNode.containerInfo:g(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];b.tag===ng&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}function g(a){"function"===
typeof qg&&qg(a);switch(a.tag){case jg:c(a);var d=a.stateNode;if("function"===typeof d.componentWillUnmount)try{d.props=a.memoizedProps,d.state=a.memoizedState,d.componentWillUnmount()}catch(t){b(a,t)}break;case lg:c(a);break;case og:e(a.stateNode);break;case ng:f(a)}}var h=a.commitMount,k=a.commitUpdate,p=a.resetTextContent,x=a.commitTextUpdate,S=a.appendChild,D=a.appendChildToContainer,y=a.insertBefore,B=a.insertInContainerBefore,H=a.removeChild,C=a.removeChildFromContainer,Ca=a.getPublicInstance;
return{commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(d(b)){var c=b;break a}b=b["return"]}w("160");c=void 0}var e=b=void 0;switch(c.tag){case lg:b=c.stateNode;e=!1;break;case kg:b=c.stateNode.containerInfo;e=!0;break;case ng:b=c.stateNode.containerInfo;e=!0;break;default:w("161")}c.effectTag&ug&&(p(b),c.effectTag&=~ug);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||d(c["return"])){c=null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;c.tag!==
lg&&c.tag!==mg;){if(c.effectTag&rg)continue b;if(null===c.child||c.tag===ng)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&rg)){c=c.stateNode;break a}}for(var f=a;;){if(f.tag===lg||f.tag===mg)c?e?B(b,f.stateNode,c):y(b,f.stateNode,c):e?D(b,f.stateNode):S(b,f.stateNode);else if(f.tag!==ng&&null!==f.child){f.child["return"]=f;f=f.child;continue}if(f===a)break;for(;null===f.sibling;){if(null===f["return"]||f["return"]===a)return;f=f["return"]}f.sibling["return"]=f["return"];f=f.sibling}},
commitDeletion:function(a){f(a);a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case jg:break;case lg:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&k(c,f,e,a,d,b)}break;case mg:null===b.stateNode?w("162"):void 0;c=b.memoizedProps;x(b.stateNode,null!==a?a.memoizedProps:c,c);break;case kg:break;case ng:break;default:w("163")}},
commitLifeCycles:function(a,b){switch(b.tag){case jg:var c=b.stateNode;if(b.effectTag&sg)if(null===a)c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidMount();else{var d=a.memoizedProps;a=a.memoizedState;c.props=b.memoizedProps;c.state=b.memoizedState;c.componentDidUpdate(d,a)}b.effectTag&tg&&null!==b.updateQueue&&pg(b,b.updateQueue,c);break;case kg:a=b.updateQueue;null!==a&&pg(b,a,b.child&&b.child.stateNode);break;case lg:c=b.stateNode;null===a&&b.effectTag&sg&&h(c,b.type,b.memoizedProps,
b);break;case mg:break;case ng:break;default:w("163")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case lg:b(Ca(c));break;default:b(c)}}},commitDetachRef:function(a){a=a.ref;null!==a&&a(null)}}}var wg=xd.createCursor,xg=xd.pop,yg=xd.push,zg={};
function Ag(a){function b(a){a===zg?w("174"):void 0;return a}var c=a.getChildHostContext,d=a.getRootHostContext,e=wg(zg),f=wg(zg),g=wg(zg);return{getHostContext:function(){return b(e.current)},getRootHostContainer:function(){return b(g.current)},popHostContainer:function(a){xg(e,a);xg(f,a);xg(g,a)},popHostContext:function(a){f.current===a&&(xg(e,a),xg(f,a))},pushHostContainer:function(a,b){yg(g,b,a);b=d(b);yg(f,a,a);yg(e,b,a)},pushHostContext:function(a){var d=b(g.current),h=b(e.current);d=c(h,a.type,
d);h!==d&&(yg(f,a,a),yg(e,d,a))},resetHostContainer:function(){e.current=zg;g.current=zg}}}var Bg=E.HostComponent,Cg=E.HostText,Dg=E.HostRoot,Eg=J.Deletion,Fg=J.Placement,Gg=de.createFiberFromHostInstanceForDeletion;
function Hg(a){function b(a,b){var c=Gg();c.stateNode=b;c["return"]=a;c.effectTag=Eg;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case Bg:return f(b,a.type,a.pendingProps);case Cg:return g(b,a.pendingProps);default:return!1}}function d(a){for(a=a["return"];null!==a&&a.tag!==Bg&&a.tag!==Dg;)a=a["return"];y=a}var e=a.shouldSetTextContent,f=a.canHydrateInstance,g=a.canHydrateTextInstance,h=a.getNextHydratableSibling,k=a.getFirstHydratableChild,
p=a.hydrateInstance,x=a.hydrateTextInstance,S=a.didNotHydrateInstance,D=a.didNotFindHydratableInstance;a=a.didNotFindHydratableTextInstance;if(!(f&&g&&h&&k&&p&&x&&S&&D&&a))return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){w("175")},prepareToHydrateHostTextInstance:function(){w("176")},popHydrationState:function(){return!1}};var y=null,B=null,H=!1;return{enterHydrationState:function(a){B=
k(a.stateNode.containerInfo);y=a;return H=!0},resetHydrationState:function(){B=y=null;H=!1},tryToClaimNextHydratableInstance:function(a){if(H){var d=B;if(d){if(!c(a,d)){d=h(d);if(!d||!c(a,d)){a.effectTag|=Fg;H=!1;y=a;return}b(y,B)}a.stateNode=d;y=a;B=k(d)}else a.effectTag|=Fg,H=!1,y=a}},prepareToHydrateHostInstance:function(a,b,c){b=p(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return x(a.stateNode,a.memoizedProps,a)},
popHydrationState:function(a){if(a!==y)return!1;if(!H)return d(a),H=!0,!1;var c=a.type;if(a.tag!==Bg||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=B;c;)b(a,c),c=h(c);d(a);B=y?h(a.stateNode):null;return!0}}}
var Ig=R.popContextProvider,Jg=xd.reset,Kg=Qa.ReactCurrentOwner,Lg=de.createWorkInProgress,Mg=de.largerPriority,Ng=ig.onCommitRoot,T=Q.NoWork,Og=Q.SynchronousPriority,U=Q.TaskPriority,Pg=Q.HighPriority,Qg=Q.LowPriority,Rg=Q.OffscreenPriority,Sg=Pd.AsyncUpdates,Tg=J.PerformedWork,Ug=J.Placement,Vg=J.Update,Wg=J.PlacementAndUpdate,Xg=J.Deletion,Yg=J.ContentReset,Zg=J.Callback,$g=J.Err,ah=J.Ref,bh=E.HostRoot,ch=E.HostComponent,dh=E.HostPortal,eh=E.ClassComponent,fh=ud.getUpdatePriority,gh=R.resetContext;
function hh(a){function b(){for(;null!==ma&&ma.current.pendingWorkPriority===T;){ma.isScheduled=!1;var a=ma.nextScheduledRoot;ma.nextScheduledRoot=null;if(ma===zb)return zb=ma=null,z=T,null;ma=a}a=ma;for(var b=null,c=T;null!==a;)a.current.pendingWorkPriority!==T&&(c===T||c>a.current.pendingWorkPriority)&&(c=a.current.pendingWorkPriority,b=a),a=a.nextScheduledRoot;null!==b?(z=c,Jg(),gh(),t(),I=Lg(b.current,c),b!==nc&&(oc=0,nc=b)):(z=T,nc=I=null)}function c(c){Hd=!0;na=null;var d=c.stateNode;d.current===
c?w("177"):void 0;z!==Og&&z!==U||oc++;Kg.current=null;if(c.effectTag>Tg)if(null!==c.lastEffect){c.lastEffect.nextEffect=c;var e=c.firstEffect}else e=c;else e=c.firstEffect;Ui();for(u=e;null!==u;){var f=!1,g=void 0;try{for(;null!==u;){var h=u.effectTag;h&Yg&&a.resetTextContent(u.stateNode);if(h&ah){var k=u.alternate;null!==k&&Ph(k)}switch(h&~(Zg|$g|Yg|ah|Tg)){case Ug:q(u);u.effectTag&=~Ug;break;case Wg:q(u);u.effectTag&=~Ug;vf(u.alternate,u);break;case Vg:vf(u.alternate,u);break;case Xg:Id=!0,Mh(u),
Id=!1}u=u.nextEffect}}catch(Jd){f=!0,g=Jd}f&&(null===u?w("178"):void 0,x(u,g),null!==u&&(u=u.nextEffect))}Vi();d.current=c;for(u=e;null!==u;){d=!1;e=void 0;try{for(;null!==u;){var Gd=u.effectTag;Gd&(Vg|Zg)&&Nh(u.alternate,u);Gd&ah&&Oh(u);if(Gd&$g)switch(f=u,g=void 0,null!==P&&(g=P.get(f),P["delete"](f),null==g&&null!==f.alternate&&(f=f.alternate,g=P.get(f),P["delete"](f))),null==g?w("184"):void 0,f.tag){case eh:f.stateNode.componentDidCatch(g.error,{componentStack:g.componentStack});break;case bh:null===
Ja&&(Ja=g.error);break;default:w("157")}var m=u.nextEffect;u.nextEffect=null;u=m}}catch(Jd){d=!0,e=Jd}d&&(null===u?w("178"):void 0,x(u,e),null!==u&&(u=u.nextEffect))}Hd=!1;"function"===typeof Ng&&Ng(c.stateNode);va&&(va.forEach(H),va=null);b()}function d(a){for(;;){var b=Lh(a.alternate,a,z),c=a["return"],d=a.sibling;var e=a;if(!(e.pendingWorkPriority!==T&&e.pendingWorkPriority>z)){for(var f=fh(e),g=e.child;null!==g;)f=Mg(f,g.pendingWorkPriority),g=g.sibling;e.pendingWorkPriority=f}if(null!==b)return b;
null!==c&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),a.effectTag>Tg&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{na=a;break}}return null}function e(a){var b=V(a.alternate,a,z);null===b&&(b=d(a));Kg.current=null;return b}function f(a){var b=ld(a.alternate,a,z);null===b&&(b=d(a));Kg.current=null;return b}
function g(a){p(Rg,a)}function h(){if(null!==P&&0<P.size&&z===U)for(;null!==I;){var a=I;I=null!==P&&(P.has(a)||null!==a.alternate&&P.has(a.alternate))?f(I):e(I);if(null===I&&(null===na?w("179"):void 0,O=U,c(na),O=z,null===P||0===P.size||z!==U))break}}function k(a,d){null!==na?(O=U,c(na),h()):null===I&&b();if(!(z===T||z>a)){O=z;a:do{if(z<=U)for(;null!==I&&!(I=e(I),null===I&&(null===na?w("179"):void 0,O=U,c(na),O=z,h(),z===T||z>a||z>U)););else if(null!==d)for(;null!==I&&!Ab;)if(1<d.timeRemaining()){if(I=
e(I),null===I)if(null===na?w("179"):void 0,1<d.timeRemaining()){if(O=U,c(na),O=z,h(),z===T||z>a||z<Pg)break}else Ab=!0}else Ab=!0;switch(z){case Og:case U:if(z<=a)continue a;break a;case Pg:case Qg:case Rg:if(null===d)break a;if(!Ab&&z<=a)continue a;break a;case T:break a;default:w("181")}}while(1)}}function p(a,b){Da?w("182"):void 0;Da=!0;var c=O,d=!1,e=null;try{k(a,b)}catch(Kd){d=!0,e=Kd}for(;d;){if(Ya){Ja=e;break}var h=I;if(null===h)Ya=!0;else{var p=x(h,e);null===p?w("183"):void 0;if(!Ya){try{d=
p;e=a;p=b;for(var q=d;null!==h;){switch(h.tag){case eh:Ig(h);break;case ch:m(h);break;case bh:r(h);break;case dh:r(h)}if(h===q||h.alternate===q)break;h=h["return"]}I=f(d);k(e,p)}catch(Kd){d=!0;e=Kd;continue}break}}}O=c;null!==b&&(Bb=!1);z>U&&!Bb&&($f(g),Bb=!0);a=Ja;Ya=Ab=Da=!1;nc=Ka=P=Ja=null;oc=0;if(null!==a)throw a;}function x(a,b){var c=Kg.current=null,d=!1,e=!1,f=null;if(a.tag===bh)c=a,S(a)&&(Ya=!0);else for(var g=a["return"];null!==g&&null===c;){g.tag===eh?"function"===typeof g.stateNode.componentDidCatch&&
(d=!0,f=Ra(g),c=g,e=!0):g.tag===bh&&(c=g);if(S(g)){if(Id||null!==va&&(va.has(g)||null!==g.alternate&&va.has(g.alternate)))return null;c=null;e=!1}g=g["return"]}if(null!==c){null===Ka&&(Ka=new Set);Ka.add(c);var h="";g=a;do{a:switch(g.tag){case fe:case ge:case he:case ie:var k=g._debugOwner,m=g._debugSource;var p=Ra(g);var q=null;k&&(q=Ra(k));k=m;p="\n    in "+(p||"Unknown")+(k?" (at "+k.fileName.replace(/^.*[\\\/]/,"")+":"+k.lineNumber+")":q?" (created by "+q+")":"");break a;default:p=""}h+=p;g=g["return"]}while(g);
g=h;a=Ra(a);null===P&&(P=new Map);b={componentName:a,componentStack:g,error:b,errorBoundary:d?c.stateNode:null,errorBoundaryFound:d,errorBoundaryName:f,willRetry:e};P.set(c,b);try{console.error(b.error)}catch(Wi){console.error(Wi)}Hd?(null===va&&(va=new Set),va.add(c)):H(c);return c}null===Ja&&(Ja=b);return null}function S(a){return null!==Ka&&(Ka.has(a)||null!==a.alternate&&Ka.has(a.alternate))}function D(a,b){return y(a,b,!1)}function y(a,b){oc>Xi&&(Ya=!0,w("185"));!Da&&b<=z&&(I=null);for(var c=
!0;null!==a&&c;){c=!1;if(a.pendingWorkPriority===T||a.pendingWorkPriority>b)c=!0,a.pendingWorkPriority=b;null!==a.alternate&&(a.alternate.pendingWorkPriority===T||a.alternate.pendingWorkPriority>b)&&(c=!0,a.alternate.pendingWorkPriority=b);if(null===a["return"])if(a.tag===bh){var d=a.stateNode;b===T||d.isScheduled||(d.isScheduled=!0,zb?zb.nextScheduledRoot=d:ma=d,zb=d);if(!Da)switch(b){case Og:pc?p(Og,null):p(U,null);break;case U:W?void 0:w("186");break;default:Bb||($f(g),Bb=!0)}}else break;a=a["return"]}}
function B(a,b){var c=O;c===T&&(c=!Yi||a.internalContextTag&Sg||b?Qg:Og);return c===Og&&(Da||W)?U:c}function H(a){y(a,U,!0)}var C=Ag(a),Ca=Hg(a),r=C.popHostContainer,m=C.popHostContext,t=C.resetHostContainer,v=Lf(a,C,Ca,D,B),V=v.beginWork,ld=v.beginFailedWork,Lh=eg(a,C,Ca).completeWork;C=vg(a,x);var q=C.commitPlacement,Mh=C.commitDeletion,vf=C.commitWork,Nh=C.commitLifeCycles,Oh=C.commitAttachRef,Ph=C.commitDetachRef,$f=a.scheduleDeferredCallback,Yi=a.useSyncScheduling,Ui=a.prepareForCommit,Vi=a.resetAfterCommit,
O=T,Da=!1,Ab=!1,W=!1,pc=!1,I=null,z=T,u=null,na=null,ma=null,zb=null,Bb=!1,P=null,Ka=null,va=null,Ja=null,Ya=!1,Hd=!1,Id=!1,Xi=1E3,oc=0,nc=null;return{scheduleUpdate:D,getPriorityContext:B,batchedUpdates:function(a,b){var c=W;W=!0;try{return a(b)}finally{W=c,Da||W||p(U,null)}},unbatchedUpdates:function(a){var b=pc,c=W;pc=W;W=!1;try{return a()}finally{W=c,pc=b}},flushSync:function(a){var b=W,c=O;W=!0;O=Og;try{return a()}finally{W=b,O=c,Da?w("187"):void 0,p(U,null)}},deferredUpdates:function(a){var b=
O;O=Qg;try{return a()}finally{O=b}}}}function ih(){w("196")}function jh(a){if(!a)return da;a=Pa.get(a);return"number"===typeof a.tag?ih(a):a._processChildContext(a._context)}jh._injectFiber=function(a){ih=a};var kh=ud.addTopLevelUpdate,lh=R.findCurrentUnmaskedContext,mh=R.isContextProvider,nh=R.processChildContext,oh=E.HostComponent,ph=bb.findCurrentHostFiber,qh=bb.findCurrentHostFiberWithNoPortals;jh._injectFiber(function(a){var b=lh(a);return mh(a)?nh(a,b,!1):b});var rh=F.TEXT_NODE;
function sh(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function th(a,b){var c=sh(a);a=0;for(var d;c;){if(c.nodeType===rh){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=sh(c)}}var uh=null;function vh(){!uh&&l.canUseDOM&&(uh="textContent"in document.documentElement?"textContent":"innerText");return uh}
var wh={getOffsets:function(a){var b=window.getSelection&&window.getSelection();if(!b||0===b.rangeCount)return null;var c=b.anchorNode,d=b.anchorOffset,e=b.focusNode,f=b.focusOffset,g=b.getRangeAt(0);try{g.startContainer.nodeType,g.endContainer.nodeType}catch(k){return null}b=b.anchorNode===b.focusNode&&b.anchorOffset===b.focusOffset?0:g.toString().length;var h=g.cloneRange();h.selectNodeContents(a);h.setEnd(g.startContainer,g.startOffset);a=h.startContainer===h.endContainer&&h.startOffset===h.endOffset?
0:h.toString().length;g=a+b;b=document.createRange();b.setStart(c,d);b.setEnd(e,f);c=b.collapsed;return{start:c?g:a,end:c?a:g}},setOffsets:function(a,b){if(window.getSelection){var c=window.getSelection(),d=a[vh()].length,e=Math.min(b.start,d);b=void 0===b.end?e:Math.min(b.end,d);!c.extend&&e>b&&(d=b,b=e,e=d);d=th(a,e);a=th(a,b);if(d&&a){var f=document.createRange();f.setStart(d.node,d.offset);c.removeAllRanges();e>b?(c.addRange(f),c.extend(a.node,a.offset)):(f.setEnd(a.node,a.offset),c.addRange(f))}}}},
xh=F.ELEMENT_NODE,yh={hasSelectionCapabilities:function(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)},getSelectionInformation:function(){var a=ia();return{focusedElem:a,selectionRange:yh.hasSelectionCapabilities(a)?yh.getSelection(a):null}},restoreSelection:function(a){var b=ia(),c=a.focusedElem;a=a.selectionRange;if(b!==c&&fa(document.documentElement,c)){yh.hasSelectionCapabilities(c)&&yh.setSelection(c,a);b=
[];for(a=c;a=a.parentNode;)a.nodeType===xh&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});ha(c);for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=a.top}},getSelection:function(a){return("selectionStart"in a?{start:a.selectionStart,end:a.selectionEnd}:wh.getOffsets(a))||{start:0,end:0}},setSelection:function(a,b){var c=b.start,d=b.end;void 0===d&&(d=c);"selectionStart"in a?(a.selectionStart=c,a.selectionEnd=Math.min(d,a.value.length)):wh.setOffsets(a,b)}},zh=yh,
Ah=F.ELEMENT_NODE;function Bh(){w("211")}function Ch(){w("212")}function Dh(a){if(null==a)return null;if(a.nodeType===Ah)return a;var b=Pa.get(a);if(b)return"number"===typeof b.tag?Bh(b):Ch(b);"function"===typeof a.render?w("188"):w("213",Object.keys(a))}Dh._injectFiber=function(a){Bh=a};Dh._injectStack=function(a){Ch=a};var Eh=E.HostComponent;function Fh(a){if(void 0!==a._hostParent)return a._hostParent;if("number"===typeof a.tag){do a=a["return"];while(a&&a.tag!==Eh);if(a)return a}return null}
function Gh(a,b){for(var c=0,d=a;d;d=Fh(d))c++;d=0;for(var e=b;e;e=Fh(e))d++;for(;0<c-d;)a=Fh(a),c--;for(;0<d-c;)b=Fh(b),d--;for(;c--;){if(a===b||a===b.alternate)return a;a=Fh(a);b=Fh(b)}return null}
var Hh={isAncestor:function(a,b){for(;b;){if(a===b||a===b.alternate)return!0;b=Fh(b)}return!1},getLowestCommonAncestor:Gh,getParentInstance:function(a){return Fh(a)},traverseTwoPhase:function(a,b,c){for(var d=[];a;)d.push(a),a=Fh(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)},traverseEnterLeave:function(a,b,c,d,e){for(var f=a&&b?Gh(a,b):null,g=[];a&&a!==f;)g.push(a),a=Fh(a);for(a=[];b&&b!==f;)a.push(b),b=Fh(b);for(b=0;b<g.length;b++)c(g[b],"bubbled",d);for(b=
a.length;0<b--;)c(a[b],"captured",e)}},Ih=Jb.getListener;function Jh(a,b,c){if(b=Ih(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Cb(c._dispatchListeners,b),c._dispatchInstances=Cb(c._dispatchInstances,a)}function Kh(a){a&&a.dispatchConfig.phasedRegistrationNames&&Hh.traverseTwoPhase(a._targetInst,Jh,a)}function Qh(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?Hh.getParentInstance(b):null;Hh.traverseTwoPhase(b,Jh,a)}}
function Rh(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ih(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Cb(c._dispatchListeners,b),c._dispatchInstances=Cb(c._dispatchInstances,a))}function Sh(a){a&&a.dispatchConfig.registrationName&&Rh(a._targetInst,null,a)}
var Th={accumulateTwoPhaseDispatches:function(a){Db(a,Kh)},accumulateTwoPhaseDispatchesSkipTarget:function(a){Db(a,Qh)},accumulateDirectDispatches:function(a){Db(a,Sh)},accumulateEnterLeaveDispatches:function(a,b,c,d){Hh.traverseEnterLeave(c,d,Rh,a,b)}},X={_root:null,_startText:null,_fallbackText:null},Uh={initialize:function(a){X._root=a;X._startText=Uh.getText();return!0},reset:function(){X._root=null;X._startText=null;X._fallbackText=null},getData:function(){if(X._fallbackText)return X._fallbackText;
var a,b=X._startText,c=b.length,d,e=Uh.getText(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);X._fallbackText=e.slice(a,1<d?1-d:void 0);return X._fallbackText},getText:function(){return"value"in X._root?X._root.value:X._root[vh()]}},Vh=Uh,Wh="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),Xh={type:null,target:null,currentTarget:ca.thatReturnsNull,eventPhase:null,bubbles:null,
cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function Y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?ca.thatReturnsTrue:ca.thatReturnsFalse;this.isPropagationStopped=ca.thatReturnsFalse;return this}
n(Y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=ca.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=ca.thatReturnsTrue)},persist:function(){this.isPersistent=ca.thatReturnsTrue},isPersistent:ca.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<Wh.length;a++)this[Wh[a]]=null}});Y.Interface=Xh;Y.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;n(d,a.prototype);a.prototype=d;a.prototype.constructor=a;a.Interface=n({},this.Interface,b);a.augmentClass=this.augmentClass;Yh(a)};Yh(Y);function Zh(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function $h(a){a instanceof this?void 0:w("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Yh(a){a.eventPool=[];a.getPooled=Zh;a.release=$h}function ai(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(ai,{data:null});function bi(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(bi,{data:null});var ci=[9,13,27,32],di=l.canUseDOM&&"CompositionEvent"in window,ei=null;l.canUseDOM&&"documentMode"in document&&(ei=document.documentMode);var fi;
if(fi=l.canUseDOM&&"TextEvent"in window&&!ei){var gi=window.opera;fi=!("object"===typeof gi&&"function"===typeof gi.version&&12>=parseInt(gi.version(),10))}
var hi=fi,ii=l.canUseDOM&&(!di||ei&&8<ei&&11>=ei),ji=String.fromCharCode(32),ki={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},li=!1;
function mi(a,b){switch(a){case "topKeyUp":return-1!==ci.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function ni(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var oi=!1;function pi(a,b){switch(a){case "topCompositionEnd":return ni(b);case "topKeyPress":if(32!==b.which)return null;li=!0;return ji;case "topTextInput":return a=b.data,a===ji&&li?null:a;default:return null}}
function qi(a,b){if(oi)return"topCompositionEnd"===a||!di&&mi(a,b)?(a=Vh.getData(),Vh.reset(),oi=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return ii?null:b.data;default:return null}}
var ri={eventTypes:ki,extractEvents:function(a,b,c,d){var e;if(di)b:{switch(a){case "topCompositionStart":var f=ki.compositionStart;break b;case "topCompositionEnd":f=ki.compositionEnd;break b;case "topCompositionUpdate":f=ki.compositionUpdate;break b}f=void 0}else oi?mi(a,c)&&(f=ki.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(f=ki.compositionStart);f?(ii&&(oi||f!==ki.compositionStart?f===ki.compositionEnd&&oi&&(e=Vh.getData()):oi=Vh.initialize(d)),f=ai.getPooled(f,b,c,d),e?f.data=e:(e=ni(c),
null!==e&&(f.data=e)),Th.accumulateTwoPhaseDispatches(f),e=f):e=null;(a=hi?pi(a,c):qi(a,c))?(b=bi.getPooled(ki.beforeInput,b,c,d),b.data=a,Th.accumulateTwoPhaseDispatches(b)):b=null;return[e,b]}},si={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function ti(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!si[a.type]:"textarea"===b?!0:!1}
var ui={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};function vi(a,b,c){a=Y.getPooled(ui.change,a,b,c);a.type="change";nb.enqueueStateRestore(c);Th.accumulateTwoPhaseDispatches(a);return a}var wi=null,xi=null;function yi(a){Jb.enqueueEvents(a);Jb.processEventQueue(!1)}
function zi(a){var b=G.getNodeFromInstance(a);if(Bc.updateValueIfChanged(b))return a}function Ai(a,b){if("topChange"===a)return b}var Bi=!1;l.canUseDOM&&(Bi=Lb("input")&&(!document.documentMode||9<document.documentMode));function Ci(){wi&&(wi.detachEvent("onpropertychange",Di),xi=wi=null)}function Di(a){"value"===a.propertyName&&zi(xi)&&(a=vi(xi,a,ub(a)),sb.batchedUpdates(yi,a))}function Ei(a,b,c){"topFocus"===a?(Ci(),wi=b,xi=c,wi.attachEvent("onpropertychange",Di)):"topBlur"===a&&Ci()}
function Fi(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return zi(xi)}function Gi(a,b){if("topClick"===a)return zi(b)}function Hi(a,b){if("topInput"===a||"topChange"===a)return zi(b)}
var Ii={eventTypes:ui,_isInputEventSupported:Bi,extractEvents:function(a,b,c,d){var e=b?G.getNodeFromInstance(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ai;else if(ti(e))if(Bi)g=Hi;else{g=Fi;var h=Ei}else f=e.nodeName,!f||"input"!==f.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(g=Gi);if(g&&(g=g(a,b)))return vi(g,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&(a=""+e.value,
e.getAttribute("value")!==a&&e.setAttribute("value",a))}};function Ji(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(Ji,{view:function(a){if(a.view)return a.view;a=ub(a);return a.window===a?a:(a=a.ownerDocument)?a.defaultView||a.parentWindow:window},detail:function(a){return a.detail||0}});var Ki={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Li(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Ki[a])?!!b[a]:!1}function Mi(){return Li}
function Ni(a,b,c,d){return Y.call(this,a,b,c,d)}Ji.augmentClass(Ni,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Mi,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}});
var Oi={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},Pi={eventTypes:Oi,extractEvents:function(a,b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?G.getClosestInstanceFromNode(b):
null):a=null;if(a===b)return null;var f=null==a?e:G.getNodeFromInstance(a);e=null==b?e:G.getNodeFromInstance(b);var g=Ni.getPooled(Oi.mouseLeave,a,c,d);g.type="mouseleave";g.target=f;g.relatedTarget=e;c=Ni.getPooled(Oi.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=f;Th.accumulateEnterLeaveDispatches(g,c,a,b);return[g,c]}},Qi=F.DOCUMENT_NODE,Ri=l.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Si={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},
dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},Ti=null,Zi=null,$i=null,aj=!1,bj=M.isListeningToAllDependencies;
function cj(a,b){if(aj||null==Ti||Ti!==ia())return null;var c=Ti;"selectionStart"in c&&zh.hasSelectionCapabilities(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return $i&&ea($i,c)?null:($i=c,a=Y.getPooled(Si.select,Zi,a,b),a.type="select",a.target=Ti,Th.accumulateTwoPhaseDispatches(a),a)}
var dj={eventTypes:Si,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:d.nodeType===Qi?d:d.ownerDocument;if(!e||!bj("onSelect",e))return null;e=b?G.getNodeFromInstance(b):window;switch(a){case "topFocus":if(ti(e)||"true"===e.contentEditable)Ti=e,Zi=b,$i=null;break;case "topBlur":$i=Zi=Ti=null;break;case "topMouseDown":aj=!0;break;case "topContextMenu":case "topMouseUp":return aj=!1,cj(c,d);case "topSelectionChange":if(Ri)break;case "topKeyDown":case "topKeyUp":return cj(c,d)}return null}};
function ej(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(ej,{animationName:null,elapsedTime:null,pseudoElement:null});function fj(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(fj,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}});function gj(a,b,c,d){return Y.call(this,a,b,c,d)}Ji.augmentClass(gj,{relatedTarget:null});function hj(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;return 32<=a||13===a?a:0}
var ij={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},jj={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};function kj(a,b,c,d){return Y.call(this,a,b,c,d)}
Ji.augmentClass(kj,{key:function(a){if(a.key){var b=ij[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=hj(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?jj[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Mi,charCode:function(a){return"keypress"===a.type?hj(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?hj(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}});function lj(a,b,c,d){return Y.call(this,a,b,c,d)}Ni.augmentClass(lj,{dataTransfer:null});function mj(a,b,c,d){return Y.call(this,a,b,c,d)}Ji.augmentClass(mj,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Mi});function nj(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(nj,{propertyName:null,elapsedTime:null,pseudoElement:null});
function oj(a,b,c,d){return Y.call(this,a,b,c,d)}Ni.augmentClass(oj,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null});var pj={},qj={};
"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(a){var b=a[0].toUpperCase()+
a.slice(1),c="on"+b;b="top"+b;c={phasedRegistrationNames:{bubbled:c,captured:c+"Capture"},dependencies:[b]};pj[a]=c;qj[b]=c});
var rj={eventTypes:pj,extractEvents:function(a,b,c,d){var e=qj[a];if(!e)return null;switch(a){case "topAbort":case "topCancel":case "topCanPlay":case "topCanPlayThrough":case "topClose":case "topDurationChange":case "topEmptied":case "topEncrypted":case "topEnded":case "topError":case "topInput":case "topInvalid":case "topLoad":case "topLoadedData":case "topLoadedMetadata":case "topLoadStart":case "topPause":case "topPlay":case "topPlaying":case "topProgress":case "topRateChange":case "topReset":case "topSeeked":case "topSeeking":case "topStalled":case "topSubmit":case "topSuspend":case "topTimeUpdate":case "topToggle":case "topVolumeChange":case "topWaiting":var f=Y;
break;case "topKeyPress":if(0===hj(c))return null;case "topKeyDown":case "topKeyUp":f=kj;break;case "topBlur":case "topFocus":f=gj;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":f=Ni;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":f=lj;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":f=
mj;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":f=ej;break;case "topTransitionEnd":f=nj;break;case "topScroll":f=Ji;break;case "topWheel":f=oj;break;case "topCopy":case "topCut":case "topPaste":f=fj}f?void 0:w("86",a);a=f.getPooled(e,b,c,d);Th.accumulateTwoPhaseDispatches(a);return a}};L.setHandleTopLevel(M.handleTopLevel);Jb.injection.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
ib.injection.injectComponentTree(G);Jb.injection.injectEventPluginsByName({SimpleEventPlugin:rj,EnterLeaveEventPlugin:Pi,ChangeEventPlugin:Ii,SelectEventPlugin:dj,BeforeInputEventPlugin:ri});
var sj=A.injection.MUST_USE_PROPERTY,Z=A.injection.HAS_BOOLEAN_VALUE,tj=A.injection.HAS_NUMERIC_VALUE,uj=A.injection.HAS_POSITIVE_NUMERIC_VALUE,vj=A.injection.HAS_STRING_BOOLEAN_VALUE,wj={Properties:{allowFullScreen:Z,allowTransparency:vj,async:Z,autoPlay:Z,capture:Z,checked:sj|Z,cols:uj,contentEditable:vj,controls:Z,"default":Z,defer:Z,disabled:Z,download:A.injection.HAS_OVERLOADED_BOOLEAN_VALUE,draggable:vj,formNoValidate:Z,hidden:Z,loop:Z,multiple:sj|Z,muted:sj|Z,noValidate:Z,open:Z,playsInline:Z,
readOnly:Z,required:Z,reversed:Z,rows:uj,rowSpan:tj,scoped:Z,seamless:Z,selected:sj|Z,size:uj,start:tj,span:uj,spellCheck:vj,style:0,itemScope:Z,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:vj},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(a,b){if(null==b)return a.removeAttribute("value");"number"!==a.type||!1===a.hasAttribute("value")?a.setAttribute("value",""+b):a.validity&&!a.validity.badInput&&
a.ownerDocument.activeElement!==a&&a.setAttribute("value",""+b)}}},xj=A.injection.HAS_STRING_BOOLEAN_VALUE,yj={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},zj={Properties:{autoReverse:xj,externalResourcesRequired:xj,preserveAlpha:xj},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:yj.xlink,xlinkArcrole:yj.xlink,xlinkHref:yj.xlink,xlinkRole:yj.xlink,
xlinkShow:yj.xlink,xlinkTitle:yj.xlink,xlinkType:yj.xlink,xmlBase:yj.xml,xmlLang:yj.xml,xmlSpace:yj.xml}},Aj=/[\-\:]([a-z])/g;function Bj(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(a){var b=a.replace(Aj,
Bj);zj.Properties[b]=0;zj.DOMAttributeNames[b]=a});A.injection.injectDOMPropertyConfig(wj);A.injection.injectDOMPropertyConfig(zj);
var Cj=ig.injectInternals,Dj=F.ELEMENT_NODE,Ej=F.TEXT_NODE,Fj=F.COMMENT_NODE,Gj=F.DOCUMENT_NODE,Hj=F.DOCUMENT_FRAGMENT_NODE,Ij=A.ROOT_ATTRIBUTE_NAME,Jj=ka.getChildNamespace,Kj=N.createElement,Lj=N.createTextNode,Mj=N.setInitialProperties,Nj=N.diffProperties,Oj=N.updateProperties,Pj=N.diffHydratedProperties,Qj=N.diffHydratedText,Rj=N.warnForDeletedHydratableElement,Sj=N.warnForDeletedHydratableText,Tj=N.warnForInsertedHydratedElement,Uj=N.warnForInsertedHydratedText,Vj=G.precacheFiberNode,Wj=G.updateFiberProps;
nb.injection.injectFiberControlledHostComponent(N);Dh._injectFiber(function(a){return Xj.findHostInstance(a)});var Yj=null,Zj=null;function ak(a){return!(!a||a.nodeType!==Dj&&a.nodeType!==Gj&&a.nodeType!==Hj&&(a.nodeType!==Fj||" react-mount-point-unstable "!==a.nodeValue))}function bk(a){a=a?a.nodeType===Gj?a.documentElement:a.firstChild:null;return!(!a||a.nodeType!==Dj||!a.hasAttribute(Ij))}
var Xj=function(a){var b=a.getPublicInstance;a=hh(a);var c=a.scheduleUpdate,d=a.getPriorityContext;return{createContainer:function(a){var b=ee();a={current:b,containerInfo:a,isScheduled:!1,nextScheduledRoot:null,context:null,pendingContext:null};return b.stateNode=a},updateContainer:function(a,b,g,h){var e=b.current;g=jh(g);null===b.context?b.context=g:b.pendingContext=g;b=h;h=d(e,ed.enableAsyncSubtreeAPI&&null!=a&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent);
a={element:a};kh(e,a,void 0===b?null:b,h);c(e,h)},batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case oh:return b(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:function(a){a=ph(a);return null===a?null:a.stateNode},findHostInstanceWithNoPortals:function(a){a=qh(a);return null===a?null:a.stateNode}}}({getRootHostContext:function(a){if(a.nodeType===
Gj)a=(a=a.documentElement)?a.namespaceURI:Jj(null,"");else{var b=a.nodeType===Fj?a.parentNode:a;a=b.namespaceURI||null;b=b.tagName;a=Jj(a,b)}return a},getChildHostContext:function(a,b){return Jj(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){Yj=M.isEnabled();Zj=zh.getSelectionInformation();M.setEnabled(!1)},resetAfterCommit:function(){zh.restoreSelection(Zj);Zj=null;M.setEnabled(Yj);Yj=null},createInstance:function(a,b,c,d,e){a=Kj(a,b,c,d);Vj(e,a);Wj(a,b);return a},appendInitialChild:function(a,
b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){Mj(a,b,c,d);a:{switch(b){case "button":case "input":case "select":case "textarea":a=!!c.autoFocus;break a}a=!1}return a},prepareUpdate:function(a,b,c,d,e){return Nj(a,b,c,d,e)},commitMount:function(a){a.focus()},commitUpdate:function(a,b,c,d,e){Wj(a,e);Oj(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&
"string"===typeof b.dangerouslySetInnerHTML.__html},resetTextContent:function(a){a.textContent=""},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=Lj(a,b);Vj(d,a);return a},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,b){a.nodeType===Fj?a.parentNode.insertBefore(b,a):a.appendChild(b)},insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,
b,c){a.nodeType===Fj?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){a.nodeType===Fj?a.parentNode.removeChild(b):a.removeChild(b)},canHydrateInstance:function(a,b){return a.nodeType===Dj&&b===a.nodeName.toLowerCase()},canHydrateTextInstance:function(a,b){return""===b?!1:a.nodeType===Ej},getNextHydratableSibling:function(a){for(a=a.nextSibling;a&&a.nodeType!==Dj&&a.nodeType!==Ej;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=
a.firstChild;a&&a.nodeType!==Dj&&a.nodeType!==Ej;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){Vj(f,a);Wj(a,c);return Pj(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){Vj(c,a);return Qj(a,b)},didNotHydrateInstance:function(a,b){1===b.nodeType?Rj(a,b):Sj(a,b)},didNotFindHydratableInstance:function(a,b,c){Tj(a,b,c)},didNotFindHydratableTextInstance:function(a,b){Uj(a,b)},scheduleDeferredCallback:dd.rIC,useSyncScheduling:!0});sb.injection.injectFiberBatchedUpdates(Xj.batchedUpdates);
function ck(a,b,c,d,e){ak(c)?void 0:w("200");var f=c._reactRootContainer;if(f)Xj.updateContainer(b,f,a,e);else{if(!d&&!bk(c))for(d=void 0;d=c.lastChild;)c.removeChild(d);var g=Xj.createContainer(c);f=c._reactRootContainer=g;Xj.unbatchedUpdates(function(){Xj.updateContainer(b,g,a,e)})}return Xj.getPublicRootInstance(f)}function dk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;ak(b)?void 0:w("200");return ne.createPortal(a,b,null,c)}
var ek={createPortal:dk,hydrate:function(a,b,c){return ck(null,a,b,!0,c)},render:function(a,b,c){return ck(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null!=a&&Pa.has(a)?void 0:w("38");return ck(a,b,c,!1,d)},unmountComponentAtNode:function(a){ak(a)?void 0:w("40");return a._reactRootContainer?(Xj.unbatchedUpdates(function(){ck(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},findDOMNode:Dh,unstable_createPortal:dk,unstable_batchedUpdates:sb.batchedUpdates,
unstable_deferredUpdates:Xj.deferredUpdates,flushSync:Xj.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Jb,EventPluginRegistry:sa,EventPropagators:Th,ReactControlledComponent:nb,ReactDOMComponentTree:G,ReactDOMEventListener:L}};Cj({findFiberByHostInstance:G.getClosestInstanceFromNode,findHostInstanceByFiber:Xj.findHostInstance,bundleType:0,version:"16.0.0",rendererPackageName:"react-dom"});module.exports=ek;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(8);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(31);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(32);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 35 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__IBMPC_css__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__IBMPC_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__IBMPC_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WIN_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ICONS__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IBMPC=function(_PureComponent){_inherits(IBMPC,_PureComponent);function IBMPC(){_classCallCheck(this,IBMPC);var _this=_possibleConstructorReturn(this,(IBMPC.__proto__||Object.getPrototypeOf(IBMPC)).call(this));_this.state={stage:'booting',// booting -> win -> shutoff
bootupImagesLoaded:0};_this.bootmsg=["AMIBIOS (C)1996 American Megatrends Inc.,<br><br>","Intel Celeron - 333 MHz<br>","Checking NVRAM",null,null,"..","Update OK!<br>","<br>","65587KB OK<br>","Hit DEL if you want to run SETUP<br>","<br>",null,null,"Starting Windows 95...","<br><br>","This driver is provided by Oak Technology, Inc..<br>","OTI-91X ATAP CD-ROM device driver, Rev D91XV352<br>","(C)Copyright Oak Technology Inc. 1987-1996<br>",null,null];_this.imagesLoaded=0;var scrollKeeper=function scrollKeeper(){window.scroll(0,0);setTimeout(scrollKeeper,1000);};setTimeout(scrollKeeper,1000);return _this;}_createClass(IBMPC,[{key:'playAnimation',value:function playAnimation(bootupDiv){var _this2=this;if(bootupDiv==null){return;}var totalIms=Object.keys(__WEBPACK_IMPORTED_MODULE_3__ICONS__["a" /* default */]).length;var i=0;var timeout=function timeout(){if(i>=_this2.bootmsg.length){if(_this2.imagesLoaded>=totalIms){_this2.setState({stage:'win'});}else{setTimeout(timeout,50);// Spin
}}else{if(_this2.imagesLoaded/totalIms>=i/_this2.bootmsg.length){if(_this2.bootmsg[i]){bootupDiv.innerHTML+=_this2.bootmsg[i];}i++;}setTimeout(timeout,40);}};console.log("playing anim");setTimeout(timeout,500);}},{key:'shutoff',value:function shutoff(){this.setState({stage:'shutoff'});}},{key:'render',value:function render(){var _this3=this;var stage;var bootupImageLoaded=function bootupImageLoaded(){return _this3.setState({bootupImagesLoaded:_this3.state.bootupImagesLoaded+1});};if(this.state.stage==="booting"){stage=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibmpc-bootup',ref:function ref(elm){return _this3.bootup=elm;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'images'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__ICONS__["a" /* default */].BIOS,className:'megatrends',onLoad:bootupImageLoaded}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__ICONS__["a" /* default */].ENERSTAR,className:'enerstar',onLoad:bootupImageLoaded})),this.state.bootupImagesLoaded>=2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:this.playAnimation.bind(this)}):null);}else if(this.state.stage==="win"){stage=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__WIN_js__["a" /* default */],{shutoff:this.shutoff.bind(this)});}else if(this.state.stage==="shutoff"){stage=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibmpc-shutoff'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/shutoff.png'}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibmpc'},stage,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image-loader'},Object.keys(__WEBPACK_IMPORTED_MODULE_3__ICONS__["a" /* default */]).map(function(i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:i,src:__WEBPACK_IMPORTED_MODULE_3__ICONS__["a" /* default */][i],onLoad:function onLoad(){return _this3.imagesLoaded+=1;}});})));}}]);return IBMPC;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (IBMPC);

/***/ }),
/* 37 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EXPLORE_TASKBAR_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WINAPI_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CURSOR_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ICONS_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__WIN_css__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__WIN_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__WIN_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BSOD__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EXPLORE_DESKTOP__ = __webpack_require__(137);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SHUTDOWN_VEIL=function(_PureComponent){_inherits(SHUTDOWN_VEIL,_PureComponent);function SHUTDOWN_VEIL(){_classCallCheck(this,SHUTDOWN_VEIL);return _possibleConstructorReturn(this,(SHUTDOWN_VEIL.__proto__||Object.getPrototypeOf(SHUTDOWN_VEIL)).apply(this,arguments));}_createClass(SHUTDOWN_VEIL,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'shutdown-veil'});}}]);return SHUTDOWN_VEIL;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);var numAnimationStages=4;var animationInterval=500;// a bit hacky, the WIN is the base component, it is also 
var WIN=function(_PureComponent2){_inherits(WIN,_PureComponent2);function WIN(){_classCallCheck(this,WIN);var _this2=_possibleConstructorReturn(this,(WIN.__proto__||Object.getPrototypeOf(WIN)).call(this));_this2.api=new __WEBPACK_IMPORTED_MODULE_2__WINAPI_js__["a" /* default */](_this2);window.WINAPI=_this2.api;_this2.wndElements=[];_this2.hwnds=[];_this2.wnds={};_this2.overlayElement=document.createElement("div");_this2.state={foregroundHwnd:-1,showBsod:false,showShutdownVeil:false,animationStage:0};return _this2;}_createClass(WIN,[{key:'overlayRef',value:function overlayRef(overlay){if(overlay){overlay.appendChild(this.overlayElement);}else{this.overlayElement.parentElement.removeChild(this.overlayElement);}}},{key:'playAnimation',value:function playAnimation(){window.WINAPI.CreateProcess("C:\\WINDOWS\\iexplore.exe");//window.WINAPI.CreateProcess("C:\\WINDOWS\\Explorer.exe");
//window.WINAPI.CreateProcess("C:\\WINDOWS\\Notepad.exe", "C:\\Scandisk.log");
setTimeout(this.advanceAnimation.bind(this,4),animationInterval);}},{key:'advanceAnimation',value:function advanceAnimation(direction){var newStage=this.state.animationStage+direction;this.setState({animationStage:newStage});if(newStage<numAnimationStages&&newStage>0){setTimeout(this.advanceAnimation.bind(this,direction),animationInterval);}else{if(newStage==0){setTimeout(this.props.shutoff,800);}}}},{key:'componentDidMount',value:function componentDidMount(){this.playAnimation();}},{key:'addWnd',value:function addWnd(hwnd,wndElement){this.wndElements[hwnd]=wndElement;this.forceUpdate();}},{key:'wndRef',value:function wndRef(hwnd,wnd){if(this.wnds[hwnd]===undefined){this.hwnds.push(hwnd);this.wnds[hwnd]=wnd;this.forceUpdate();}}},{key:'removeWnd',value:function removeWnd(hwnd){this.hwnds.splice(this.hwnds.indexOf(hwnd),1);this.wnds[hwnd]=null;// Terminated
delete this.wndElements[hwnd];this.forceUpdate();}},{key:'rootRef',value:function rootRef(rootElm){var _this3=this;if(rootElm){this.rootElm=rootElm;this.rootElmListener=function(event){_this3.api.lastMousePosition=[event.pageX,event.pageY];};this.rootElm.addEventListener("mousemove",this.rootElmListener);}else{this.rootElm.removeEventListener("mousemove",this.rootElmListener);}}},{key:'globalMouseDown',value:function globalMouseDown(event){window.WINAPI.TriggerEvent('dismiss');return false;}},{key:'shutoff',value:function shutoff(){setTimeout(this.advanceAnimation.bind(this,-1),animationInterval);}},{key:'render',value:function render(){var _this4=this;// todo - make sure it only happens once/twice in initial render
var elems=[];var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=Object.values(this.wndElements)[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var wndElement=_step.value;elems.push(wndElement);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}var animClasses=["win"];for(var i=this.state.animationStage;i<numAnimationStages;i++){animClasses.push("win-anim-"+i);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:animClasses.join(" "),ref:this.rootRef.bind(this),onMouseDown:this.globalMouseDown.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__EXPLORE_DESKTOP__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'win-hwnds'},elems),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__EXPLORE_TASKBAR_js__["a" /* default */],{hwnds:this.hwnds.slice()/*slice to force update*/,foregroundHwnd:this.state.foregroundHwnd}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:this.overlayRef.bind(this),className:'win-overlay'}),this.state.showShutdownVeil?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SHUTDOWN_VEIL,null):null,this.state.showBsod?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__BSOD__["a" /* default */],{dismiss:function dismiss(){return _this4.setState({showBsod:false});}}):null);}}]);return WIN;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (WIN);

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ICONS__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TOOLTIP__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TASKBAR_css__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TASKBAR_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TASKBAR_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BUTTON__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SYSTRAY__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__menus_MENU_js__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function buildPrograms(path,launcher){var items=[];var dirContents=window.WINAPI.FindFile(path);var _loop=function _loop(){var item=dirContents[i];var launchPath=path+"\\"+item.name;if(item.type=="directory"){items.push({"type":"menu","style":'start-menu-programs',"icon":__WEBPACK_IMPORTED_MODULE_1__ICONS__["a" /* default */].PROGMENU,"text":item.displayName||item.name,"items":buildPrograms(launchPath,launcher)});}else{items.push({"type":"item","icon":item.icon16,"text":item.displayName||item.name,"onclick":function onclick(){return launcher(launchPath);}});}};for(var i=0;i<dirContents.length;i+=1){_loop();}items.sort(function(a,b){if(a.type=="menu"&&b.type!="menu"){return-1;}if(a.type!="menu"&&b.type=="menu"){return 1;}return a["text"].localeCompare(b["text"]);});return items;}var TASKBAR=function(_PureComponent){_inherits(TASKBAR,_PureComponent);function TASKBAR(props){_classCallCheck(this,TASKBAR);var _this=_possibleConstructorReturn(this,(TASKBAR.__proto__||Object.getPrototypeOf(TASKBAR)).call(this,props));_this.state={startOpen:false};// saved for later
var startMenuContents={style:'start-menu',items:[{text:"Undo",accel:"U",shortcut:"Ctrl+Z",disabled:true},{type:"divider"},{text:"Cut",accel:"t",shortcut:"Ctrl+X",disabled:true},{text:"Copy",accel:"C",shortcut:"Ctrl+C",disabled:true},{text:"Paste",accel:"P",shortcut:"Ctrl+V",disabled:true},{text:"Paste Shortcut",accel:"S",disabled:true},{type:"divider"},{text:"Select All",accel:"A",shortcut:"Ctrl+A"},{text:"Invert Selection",accel:"I"}]};return _this;}_createClass(TASKBAR,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;this.globalDismissHandler=window.WINAPI.SetWinEventHook('dismiss',function(){if(_this2.state.startOpen==true){_this2.setState({startOpen:false});}});}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.WINAPI.UnhookWinEvent('dismiss',this.globalDismissHandler);}},{key:'render',value:function render(){var _this3=this;// Create list of open windows based on non-menu WNDs
var windows=[];this.props.hwnds.forEach(function(hwnd){var wnd=window.WINAPI.FindWindow(hwnd);if(wnd.appearOnTaskbar()){var icon=wnd.icon();var title=wnd.title();var inner=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app-btn-inner'},icon?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:icon}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,title));windows.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__BUTTON__["a" /* default */],{tooltip:title,key:hwnd,onPress:function onPress(e){return window.WINAPI.SetActiveWindow(hwnd);},selected:hwnd==_this3.props.foregroundHwnd},inner));}});// Create start menu (if open)
var startMenu=null;if(this.state.startOpen){var programs=buildPrograms("C:\\WINDOWS\\Start Menu\\Programs",function(p){return window.WINAPI.CreateProcess(p);});var documents=buildPrograms("C:\\WINDOWS\\Start Menu\\Documents",function(p){return window.WINAPI.ShellExecute(p);});var startMenuContents={style:'start-menu',items:[{type:"menu",style:'start-menu-programs',icon:__WEBPACK_IMPORTED_MODULE_1__ICONS__["a" /* default */].PROGRAMS,text:"Programs",accel:"P",items:programs},{type:"menu",style:'start-menu-programs',icon:__WEBPACK_IMPORTED_MODULE_1__ICONS__["a" /* default */].DOCS,text:"Documents",accel:"D",items:documents},{icon:__WEBPACK_IMPORTED_MODULE_1__ICONS__["a" /* default */].SETTINGS,text:"Settings",accel:"S",onclick:function onclick(){return window.WINAPI.SysCrashDump(1);}},{icon:__WEBPACK_IMPORTED_MODULE_1__ICONS__["a" /* default */].FIND,text:"Find",accel:"F",onclick:function onclick(){return window.WINAPI.SysCrashDump(1);}},{icon:__WEBPACK_IMPORTED_MODULE_1__ICONS__["a" /* default */].HELP,text:"Help",accel:"H",onclick:function onclick(){return window.WINAPI.SysCrashDump(1);}},{icon:__WEBPACK_IMPORTED_MODULE_1__ICONS__["a" /* default */].RUN,text:"Run...",accel:"R",onclick:function onclick(){return window.WINAPI.SysCrashDump(2);}},{type:"divider"},{icon:__WEBPACK_IMPORTED_MODULE_1__ICONS__["a" /* default */].SHUTDOWN,text:"Shut Down...",accel:"u",onclick:function onclick(){return window.WINAPI.InitiateShutdown();}}]};startMenu=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__menus_MENU_js__["a" /* default */],{menu:startMenuContents,direction:'up',bottom:24,left:2,onDismiss:function onDismiss(){_this3.setState({"startOpen":false});}});}// Render complete bar
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'win-taskbar',onClick:function onClick(){return window.WINAPI.SetActiveWindow(-1);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__BUTTON__["a" /* default */],{tooltip:this.state.startOpen?undefined:"Click here to begin",onDown:function onDown(){_this3.toggleStartMenu();},selected:this.state.startOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__ICONS__["a" /* default */].START,alt:'Start'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'win-taskbar-apps'},windows),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SYSTRAY__["a" /* default */],null),startMenu);}},{key:'toggleStartMenu',value:function toggleStartMenu(){this.setState({startOpen:!this.state.startOpen});}}]);return TASKBAR;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (TASKBAR);

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ADRIVE_16.png": 41,
	"./ADRIVE_32.png": 42,
	"./ASK.png": 43,
	"./BIOS.png": 44,
	"./CDRIVE_16.png": 45,
	"./CDRIVE_32.png": 46,
	"./CDROM_32.png": 47,
	"./CDSAMPLE_16.png": 48,
	"./CDSAMPLE_32.png": 49,
	"./CLOSE.png": 50,
	"./CUR_STD.png": 51,
	"./DIR_CLOSED_32.png": 52,
	"./DIR_OPEN.png": 53,
	"./DOCS.png": 54,
	"./ENERSTAR.png": 55,
	"./ERROR.png": 56,
	"./EXEC_16.png": 57,
	"./EXEC_32.png": 58,
	"./EXPLORER_16.png": 59,
	"./FIND.png": 60,
	"./GRIP.png": 61,
	"./HELP.png": 62,
	"./HTML.png": 63,
	"./IEBACK.png": 64,
	"./IEBACK_A.png": 65,
	"./IEFAVS.png": 66,
	"./IEFAVS_A.png": 67,
	"./IEFWD.png": 68,
	"./IEFWD_A.png": 69,
	"./IEHOME.png": 70,
	"./IEHOME_A.png": 71,
	"./IEICON.png": 72,
	"./IERFSH.png": 73,
	"./IERFSH_A.png": 74,
	"./IESRCH.png": 75,
	"./IESRCH_A.png": 76,
	"./IESTOP.png": 77,
	"./IESTOP_A.png": 78,
	"./IEXPLORE_16.png": 79,
	"./IEXPLORE_32.png": 80,
	"./IE_BG.png": 81,
	"./INETNEWS.png": 82,
	"./INFO.png": 83,
	"./MAXIMIZE.png": 84,
	"./MINIMIZE.png": 85,
	"./MY_PC_16.png": 86,
	"./MY_PC_32.png": 87,
	"./NOTEPAD_16.png": 88,
	"./NOTEPAD_32.png": 89,
	"./PROGMENU.png": 90,
	"./PROGRAMS.png": 91,
	"./RECYCLED_16.png": 92,
	"./RECYCLED_32.png": 93,
	"./RESTORE.png": 94,
	"./RUN.png": 95,
	"./SETTINGS.png": 96,
	"./SHORTCUT.png": 97,
	"./SHUTDOWN.png": 98,
	"./SHUTVEIL.png": 99,
	"./SND.png": 100,
	"./START.png": 101,
	"./STARTARA.png": 102,
	"./STARTARI.png": 103,
	"./STARTBAN.png": 104,
	"./TASKACTV.png": 105,
	"./TEXTFILE_16.png": 106,
	"./TEXTFILE_32.png": 107,
	"./WARNING.png": 108,
	"./WINFILE_32.png": 109
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40;

/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAhUlEQVQ4jdWTQQ5DIQhEZxruVW8G3AxPNl395mtMU2M3ZQXKmzAGKQkn8TiifyFgV5KZ217cnXbBrbUtuKpAUpaZcvctODPfuQFA7/0r8NkaetVwZqvGmpouezM8CNyhiBia7vX8Vra6mJfrk0VbjTzXq4gISCIlgeT2DkgiAPD//8KxwAuAiDytpR8ThQAAAABJRU5ErkJggg=="

/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABCUlEQVRYhe2XYQ6DIAxGi/FecjPam5WTffszCdYxEDQuiy9Z4ib6PbRFR/RwMw7A8ElEpOskIQRHAIY+zAwAUFW0oqpgZhARpuHpd+C9T9u3CKjqvQI5j8B/CcQYD4+ZzxRolbhUYCVvtZx8DdgJ9C6pn8KZmVQ1iazfl2XZXKUkICKwdq1hI0wj4d9YZ1xjFhGEELqDVJVEZBdeGmul0i04Wr0r3vtdYZWwYgDcKV1gZ7W8hWL2ez6GmQmAI/qBlbDpCtSKyd6CeKAzNgKloFJR1fa31MZGoNQNNYHScS2FvREoHVB7ce3toJ3AFQGWvAOSgF1IrsKGE73/FzjnTnkI1bDhDw9ERC/gZOl19wIRxAAAAABJRU5ErkJggg=="

/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAFdSURBVFhHtZYNsoMgDIS1h9Uz6WX7sjaxeZhAIPSbYQQVdhPiz7p0cBzHm7sm+753rQeaE7Totm3csznPk3txM+5NItwS9RAzI1m5xGfR2rYHM8UFWjZmIiJOa5mtBS2P5hMV12gD5TULkkF70hN5iZz3rpeQHNrNi49hVqpptAz/CjNadF6k3vkaJHs/HeEMXNMY6ZeZ0PdE6dqCT4yf/gxxZKG7BixGxIW0gYw4mJKBDMMGdD1kuEoJxdD71ZMi7DWx0kTS49FgBvQTUD4NvVwG8M3WPxO/ooweuncGMMANEXTao1tQiguWIr8t52GJy5+SF/I0EzVxUMv55WDUiGxnTRzUDGDymybwqG1G15C136U4qBoAMMFdLMC9pxmvyARLHDQNCNoIgBltwjPgCadgM6T/BWOcL422GHoTclQUdD644Y8RkzaRNQBSJmYYAKtVgBFmGRis9mX5A16qnZEviP7xAAAAAElFTkSuQmCC"

/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAc0lEQVQ4je2SMQ7AMAgD7SoP42eEn5GXuUOVSM0Utg71hJAObATwi5IAABGhKuzubBM2sxKcmSCpFhFy9xIcEatuADDGOAItDWn56l2VzTu8HABPpiMX263WgNM77HHb3H7qYKr3DkmkJJAs/4AkVpmP6gaJOjDeCiiLTwAAAABJRU5ErkJggg=="

/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAqUlEQVRYhe2UUQ4DIQhEh8Z7lZspN8OT0a/daLO6TVe6acL7UiQZxBEgCIIgCIKbITPbNyJik9xl5JyJiAAAqRVnZndxVQURGQACgMevxd9JImI5Z3dxETmM709Qa10mxk/e11p1mpump9/SXpZHSY4FKOvHuV0BRya5ypm5uwI8zHjmra6AkVOv8F8dWPkVR5RSYGb9KPZo/Uy8jZGZbbPZnVZ860BwOy+ElUEGEiHu4wAAAABJRU5ErkJggg=="

/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAJeSURBVHhe7ZoJcoQgEEUlF9ObgTfTkxnR/hlt7LBmmaJflYWORhP+o6WYmG3bhp75oLZbtAOo7RbtAGq7pfsOaP4anOc564bWWkO7RRhjsp63/72356kBpQZISVvraO/Oui60d2dZnj9PNUMNqCTZAClxZy3tnWzDc3CSARLTNNHeCU8OwIDY37Ffd7RqACNqAJJ3wdh+/rlWBnBgBE9QDahENEBOnpNmAjeAj/G/Qg3gBiB5ntA0SonVGSAZeBmzRytReh2OuzdA7IBpHI8NLHuCfgvxPXn2Zgk+iacNPJ27buDp3HUD/FhrAMbEq+rfZ3ZgWVfaOwlrwn0M/lQNuKZ3Jfc6nFcDuAFh9X/VAU+qCToPeBOMc+4xeQkYETPBzd/PIPfnHm1uDWiF1gAi2wAgmYAVHiT831EDSg0AMMHN89lGxjbAGMT1kjHSmiEHv//+3PvrJ0L3BlR3gK8BvA60wCefmn4NagC1QY/nHteC+7W+bww1gNqjivoNCeQevyvdG/A1DwA+VQ9SjR1bWj9Y6U2Az6X3OsB53K8W3EfnAZkEM8HS5EeaEXITJLDy1GoOoQYUIq4IlSYvMdJ6AVaGYitNqZQmD9QAbgBonTxATPiOodYENaAS8btBUJo8BybEDAAxE2qTB2qAZEDr5AGPq9QENaARgQFAMqEUXgNAzAAAE1olD9QAyQDAZ4i58BoAsk14fVPUJHmgBsQMANJMMZXUtwFmnnw9oXXyQA1INYCTakS0Bgi5/lTiHDWg1ACOyfy/ffBbSUuoAa0MeFe6N0A7gNpu6bwDhuETVXPhiCgq5yAAAAAASUVORK5CYII="

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABKElEQVQ4jW2TUa7sIAxDT0Z3X2RnNTsLK/P7oDBM+yKhQmVsE0PY5qyIMIA01+trO3hURBCLICK80AKuS4xRG5xVIP0QRQSftVkStxgCnnKVCdJ2uOqzFTLJzE3yrGxtkjzqs9SrahM9SbI1aozp7uFiOxAi66ugrtfmJfA+gsCX8QV1kFQV6n3P/1cBWHf3F/sPWHNkJpXFxUUQ2I6I4O9EtmbGGFzXRe8zh+uOeYwBgq7+cmHbripLOubYxlXlqtr/bzzr/nwWe2vt9juPkFn0Q2wcjXyl8I2wiIibZPajtaS13JhnM3eMS2ECtAG9wxhFZt4uf12E7X2Vz+ZlFlWJBDbHcSb5nVxsB1Ots3I7rfau+51pbfw+qqOjlmRJBl7jTohzAPwDGonmOJBV8sQAAAAASUVORK5CYII="

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAANUSURBVHhe7ZlRdoMgEEW1G9OdqTtLVmY9MA/D4OsA2v507keRqOjhXUaTjvu+D3/BOI5NFzrua5TNX+VL2n/L4wbQpOVTdrX3+yVbkXmeZSvnaTPcgLsGFIljvG0LzUuSnF8x4X1ZQwt08pp5mkL7er9Dq824a4Qb0GtASn6VRJcltpK87icTptjqqxY1QCdP+seNhKbXBDeg1YCUvJy3D3Hix63OhEFqAK7am/xTJrgBtQYg+ZdU80nW8ihZVpsgx+mrdtcAIX0utabWBDeg1QAcjsTaTXimBgB8DjNXeSq5AZWYBpxVP/w9ZjxPvtmEmzUA6OSx9ltNcANqDUgzLUn3m9BXA4CVPPq1TwM3gBlgJd9tguoDZgKoTb7VBDfAMgCLlSVfawL6SHbFe4GQEnsoefStp4Eb0FoD1NItwPFF8kgk/D2TAikxeV+4mzz6aN0AgmnALkVglOjL4/OJla/lKQmYsMl7ABKZ1Fp/k8Tv4gYYPGAAuDYB529rrPq1Biwrvjvk4D4Axmd83Hd+ouAGWAbgOYpEmAmbeq4vUs2PcUKLcYBe4yz5InG5LsZ1A25SbQD4eLMK7Uk+waj6lgmAfc7uD1gmuAEGzQYs8n0+VXkjoZN4As7DuNyoOrRZrIa4AQTTAA0OZwawpwFIa5YGTncEMD5MxPHahA+zLpMHboBlwLkfExn724YZD01hAo7XT4PyvNhi3PI6PxuF43+oLRjwEjeAGXDMfNjBZhwJnWv6ehwN3vnPb2mhScAYcF5fB3l9PdwPcAMMCgOw9gFPNk4sliirBWwN19cCcD2uNkQJ4AZYUAP0LzOWCZj58rg8AP3LEKsFLHFQW5vSG+Ky5DciuAH9BuQzbr8XAOu82NY+DfR7BvbX1gI3gCXVawLWngWGSf83KGoBNvLxuBnXWLXADbhvAMhNwNpmlGs+tr214DQGxP1WLXADeKIR2wRMaFtfJ16OH5qDtCHo8RjxOFaSYIIbcN8AoJOp62sTdFvenh4vRyeO6g/07wRugGUAaDWBrz3ZMEwA7PbY+CxxjRsgPGbAsT+0gM08TyS2zARNa9IMN6DWAMBMYAnUUmtMb9IMN+CuAQD9uyZY9CbNcANaDQAwQfN0Qr/NPzdgGL4BV6kqLs6wckIAAAAASUVORK5CYII="

/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAKCAYAAACALL/6AAAAUElEQVQYlZWPUQ4AIAhCqZNxdG5WXzVTWosvp48JTdLAh/oaSIJkAfJ+GyRtIMLxBgAtR8pfInx8cECGrcFFuhpiZtfpMLiCzlRKv1Q6vDQB7OUnz0f2FD0AAAAASUVORK5CYII="

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAsElEQVRoge2Wyw7CMAwEdxH//8vLhaAIOJDUj1bsnHJpvFOrtQFjjDHGGGOMMcYY84+woIYk/VSHXI9zW35iA5LKurtEQFKaRIkAkCdRJgDkSJQKAPES5QJArESLABAn0SYAxEi0CgDHJaom8Wfh71N3Oc99I9A2JDHLvK8Yp10lgFd4jpCX+ohH+Iy7q3YhzufILqQLZL35QdckDutC+xw4SulvdObZBY1zVw5jTDMPfcpUIhOcQKYAAAAASUVORK5CYII="

/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAoklEQVRYhe2XUQrDMAxD5Z0sN4tyM+dk2se6lrKVtpnXn1pgDMHB4jkfMXB3maTVQWtNG7Wzaq0W5kDSHCR1RFMdIuJLc8jdd3OUiaHmkSaMpEopwyN096F7JCHJDs89WgAEQI/Fk6H3flkmFxSSdGr2EZl8ERh+gL/mDwNJIAkkgSSQBJJAErgtASMp4P0/ulbktBmZ2e429A9JituwUqN6Ah2IrH+E5yfcAAAAAElFTkSuQmCC"

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAApklEQVQ4jcWTUQ7DIAxDX3ax9mZJbhZO5n2srUpLq1X7mCVkgcA2CcCPMEnbJDN13ODudqsgCUlEhEZY1rkaJonMlLvTWmOaZlqrHU9k5tDc3e3gjqpqwONkgF57xd55zw2wAy9FXJQewT3IDCKCy+Ldxa6q8xXGMXt2DwCqqm/jmmJcwJ5X55W/7ELPJ4GnItth0PaUR8/4DhGfenR/wcwet/T/eAPPfW2GJWxq0gAAAABJRU5ErkJggg=="

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABA0lEQVRIibVVURKFIAhc3sX0ZuHN6GT7PiwqtXqWjxnHsQmWXVCAfxvJrqWq7Pn/05NMSokxRogIhzNYMidJmhmz672fkHUyKaXq4zRNh/M8z4gxgqR0MdhnSpLlOSf+O5NmcDMjidPgLRBV9XUL8EvwNhMsvhurZhelpAfNRQCyvQNACAFm5ufskztNSHpRY4yX9bqyEIIXXhVQRW6AUoqnthTb5VqL/wFyywHycj/K5ZYZwDvn6a6qzuLAZOue9yClTGuzQVVfBzczvwf7GgxlsF26AmC0TKcAo2SqJPqHTBXAaJlOAUbKRBYDJ79J+vg92tv6FlUTrWveXhjvJt0o+wK8D4fV+xvgmgAAAABJRU5ErkJggg=="

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAFsSURBVFhHvZZdcoMwDIRNbpXbtE+ciaf2Nj1WyxJvqhr9OkO/GY8D2Nq1FIOXVuCtte/+U+WztVI8EE6Qoh+9t3jvPZgxcwLiu/pUi7JFVJecHK04ghkpZeOVVVstm41LxNksE7fe/wvbtqkmDtzVA+2+1pyx0FBNhOJEey6bRHu+t7EUfgkwRTJeSwpjZRZ8A4uye7TA2j1troAmbkiJu98jE0VxaH2t6+NiJ7cLLBMTKx/Jb8NM4KI4ylB7D3gCRXFSM3ABNQNazYn3zCFvICMwYSJnwPq3a3UvmjgiuO8CS1ySGdPBGeG+bY+LHT8D2cAvZMI3MAY2VnVQGdtZ13U5DODIJA+Uf2CgRMBo7Jh+8MxAykSGgjjI7YILQPrRn+yGX8cJxtVTHJwywFKY5SjAOFrqiVlcfKnw3Z7NhiUsVw9MA4AmSGRGZi0jDlwDhMcnaUbDSrUmTFIGAE1U8cRB2oAkMhOJ/tLaD9itZqBwp/GjAAAAAElFTkSuQmCC"

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAB2SURBVDhPY/z//z8DJYBx0qRJFJkANsDK0grKJR4cO36MIS8vj4EFymdwMz0LZREHGiZBaCYIhRu8/pvC8I4hHYOGAbgXQE4iFYC8wAAy4MzpM////v1LEoYG/n+CXiAERg2gggEU5QVQOmAE0pRlJsqyMwMDAAXOYlXb0guMAAAAAElFTkSuQmCC"

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACMSURBVFhH7ZcxDoAwCEWpJ8ObcTQ8GUJbBocODgVjeIlSWXhp/2CbiEAmx6xpNCJK2wKdPQQQcbbiYOanAGLsRhBdXWBLBphbfwDO5dpJD+EWgXGkI1ertfOdEFojCp9nAvYS/RCrUfg8dZF/hvANJVACJVACJVACJZAu8I1/wtkLpwtoTb0eJ1/PAW782LsCUkzTOQAAAABJRU5ErkJggg=="

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAD0SURBVDhPlVMBksQgCNOd/Zf+rPoz+zIuAXG1dW+6mWEQhBixjSISHLXWT9BxHEfsyz1IQCulSGtNw9kz7zU7UwU8OeccUsrhPNvNg6gft0LVkaCf8hNKCbyuvIzLEXHiSUVqMUb1np/9AMiGgunOekH1KLHcdTamYCG4NcNYvCP5cgUTxx36Brk5JaaBsgzWcSO4NtM75tdxLAR8Sg5tbmYO8nWf87wqeHevMOb+7mhkxGaS5ExtRMT7Z9RYNAhq9acxef1QgAQIBLNACWaJnNcCfdi6/N/QqYVujHRp+Se2IxmbT20lCbL8zk+BT1ybRCT+AdDVkezzBom5AAAAAElFTkSuQmCC"

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABgUlEQVRIiZ2Wa47FIAiFD5O7L9kZsDNcGfPD6lWrrTMnISb1AR8qliICK5nZuuNBIkLzt8/LhOPFzQxEFBExOPk5XuFAqgoiGshvBH1qzAzMjJTSkYNK3JM0B3VhEUHOGSklUOkAmLHbq1cnEQFVDUQRIsLdhxaqAdQRawFYWtuDAEBXCwCeMzgleM7AFZWZIec8WJtfYmvm7qVDVVvkVTOBuzeKOv5N7v4loI4ACwI+3OSVPqv0ABgW95zBXV+fmlnzifvMBP0euDvUHf6yyCOBiBDMgkSaE68EVwszQBWqCmb+O0GNmFJCAMgTgf4z+uZARMjMQt1BIiOBe4tetbhi5mOC2/nF4rK4e6hqAHF8VOsxvdWiWkNq6bjXooAqbUleCarVKFvkDTGOSLYEs0rxMijJN2k0kjy+G28EVcDfSIZScaKIQtLqSbv2AVWFmS3nPaZovlDuDGYDNulaHt9dirCp78VW6dqM3Tl4s8HJ5WA1juLwKVypf+Bj+puo+gUaaIsZUXl1hwAAAABJRU5ErkJggg=="

/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAcklEQVQ4ja3TwQ2AIBBE0cHY11IadDZUpieNIbjsiHMjJO/wk00kDwRnZmit3W+SKKVgU4Ba6/AvhHhACHkCOWcd6QEz05ARIDVRgCHiAaEmM2DaJAK4TVYAANgU4K1JUm6nn3w73n5BdpLLSALwucm1E4OwUFkPaBMWAAAAAElFTkSuQmCC"

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABMUlEQVRIiZ2WYY6FIAwGp5u9l97MrzfTk3V/CDz1idQlMSjCDC2N0SKCbHPzABAiIiyz5ucVXPu9EGYWZjbcnWUiaHB9v1MZ7EU0FDzBM6JHQRcusSxlju/PPVFX0IMvcbXV+efxKro95Ke0uAn30h+hOk/uClI5rzD1J9VS/v0PvOa/reucA0ATvIW7f8auO5f2C8ohZ0vxBLxJT4XP88w8z3uK3DyEGlx3lrLzayp68GNrKaohtT4VzjPczMKEQoh1XQFanxXdwdd1ZU+KPhEATNPENE1nwINoBP8q02NbLrV4FWXgACb0+VboHg7gpS6PZzWCQynT+l1vaUiIMvAmaA8vRNu2DeFfgjeibduG8K4gI3L3IXwoeBQl4ABERPoCAohSeZFZk4rgLqLsb8sfV4NOYXpzG7EAAAAASUVORK5CYII="

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA10lEQVQ4jaWSUZLEIAhEn1tzL7mZeLP2ZOyHyWiiqZmt7S8paOhG4J9IAO4e3xSXUtKbmNJIuHsMEFf0WFIcdUSMeT83MUA8xFBKodZ6Ufsaz0FsTZgcqADIDDO7KD4nLAo6WUQpZzkmIYmIQNJlL1ODruAkt9bAC+CAL8RNg7RmPR38wH3LXxV0G21MfCCemJaYgMABswxkcD9s1McG6w7MBsH9eDuSfacg54wEZmMnksjZmG1uGow7yHm+ttTtbMg3C58ucfNLs4LWBLQp9Snej/kLEsAvTb2G96VarLwAAAAASUVORK5CYII="

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAmCAYAAACCjRgBAAABAElEQVRYhe2YQQ7EIAhFYTL3vzKzaRNqmKr4kZjwki5qo/ILKEpUFMXRsKeTiPQHZhYRcY3PPN7t45lgwIC+QhBwAdefRw/7F6iA3cYTEX1RA1nG90LJmyMaiADL+J4nZhL1jeUQyggbzbIAEWHU3/QACaFLxMMTu0TBktgSgUjSHtBlNCOc4BvZbhEhpcSO0LkJEUC0T0SYgF2UgGxKQDbHC/AudY/yc2XJtM7OMxuhuxbSk64c4Fc5PoRg1ahGHyVbT1nt+vusJ90C3oyxwqs1rvc+SkgOjNwLoXIo6l6I72ekz+0hz3xpSdwa7BURsg9YxrXtus0Iv7xbgqI4jB/b+6g3ouzViQAAAABJRU5ErkJggg=="

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAmCAYAAACCjRgBAAABAUlEQVRYhe2Y0Q7DIAhFYdn///LdUxfmSKV41Zhwkj7URuUWUFGkKIqj0UwnAP2BVQEgNb5qvNsrM0HAgL5CEnQBqgoJeIgFVcBq40VE3qyBPON7oZTNEQtFgPvne554kKh3DIfQjrCxDAsAoKy/mYESQgD0zxOLRNGS2BPBSNIe1GV0RzjRN7LVIqYcJVaEzsUUASLrREwTsIoSsJsSsJvjBWSXup/j58iS6dXOT2ri9FnITjpSwI9yfAjRTqMWW0q2nvLa7fennkwLuDPGC6/WuN57lCk5ELkXYuXQlHshAHo9kT7fYijBtiRuDc6KmLIPeMa17bbNCb99twRFcRgfNYagOoO+K9gAAAAASUVORK5CYII="

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAmCAYAAACCjRgBAAABT0lEQVRYhe1Y7Q7DIAiEZe//yuxHpWHUDyjUrpmXNGlR9E5RtAALC/8N1AYi6jsgNisQ0aG9q4C4dfV2OlFPYCmfJgIA4GWtOCIPsM1eb4augCmEskllzJI7hEaj7+04C+YQ+lWkCcgeWSvCAjTx2UJc22gNZecBgI28d61E80poBhBxJ8/Epc2CFknrThUSQERfxLXN0Q72vntIWQNMWIaTF0zamyPCAvRoR/LFmQSXto1mJTovViK7G+Y8cFemHcEkYPYZ34PHh9AScDdqsX3Y0K9aA5E79H6ArJRNv5ifEcICHh9CLgGISPxIm64zqs/frXZqftqXUc0DspKcWvk+mnZdLr9rfmxr+Ul74YdNAS1itduTbDzrx9aon/IOAL6jxGFkokRb6N3SNI+URZw5+hp6vXBfXO75sYWeUdf1e+Iq4XHwk3YZQgsL/44Pv1b+VJfsqlYAAAAASUVORK5CYII="

/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAmCAYAAACCjRgBAAABOklEQVRYhe1YUQ7DIAh9LLv/mbgZ+9hcGIMqU9ea+BJCtSAgYFoJAEQEq+J2tgO92AGcjXtWgYjChhER6nMnj1QGiEhEAGaGx4+CmwoRqVIRY+ZD/pSrrzeKqHh2hNE7O7LUmksoKpssn4JR5dPCMbjEmgOo176c0iPdGQDE5UtlAJA3ZTMAPOc8mp4B7bg3bs3Ar85fIgNeEFNK6B898Et/7FMoyy95CmX4zoCh5T/mmgK4Mpb/pdwBnI2vn3qvYUc2nbXVu7Z7KzHL4chOTyDLl1D6WqWQnrMyNfkyjtbx9KxugVtCWkinVj/X0m7f6zEzf8lH5VTGev7j+aUcGo4C84xGRmoydq41OCBxteg51KqbRbSBNlhgUBN7C4+C7Zdiq7xvzoBVzMofBac3INLT8/865jc2VsAD/OxQEL/sCrMAAAAASUVORK5CYII="

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAmCAYAAACCjRgBAAABA0lEQVRYhe2XyQ7DIAxEx1X//5fdS5EcmrB5Qah+p5JG9gwYYoAkSY6GWn8ysz4BETNzM89kvMv4ZRW4k1Q/Ew+EGGBmNxMhBgA/E29tgBlRxYTlnlAbAOY2u7WJsBKSWJbTFgNEBKsVMCmh+myukSVmKR4wMNATI0vFWjwQWEIe4oG4L7GLeCDuS+wiHggw4Cke2HSMWpIGdpMGdnO8gd4R99Mxeh+LLb5tySV/txfaKXiE40touRuVXWZZpfKMmUneulq/WzHqd5YMPCWRpSXHMyXXi3GXZ9qAdg8UEXf3YItrpcmNbIWR2R3BbRPXs/60ClqWVqCIkWNtjNV3kuTf+QA4M7M+UiQfEwAAAABJRU5ErkJggg=="

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAmCAYAAACCjRgBAAABAElEQVRYhe1Xyw7EIAgcNv3/X2YvNaHdqlUexixzqm0DMzIaABKJxNag1kdm1icgYmZu5hmMd1l/rAJ3kup3ooIQAWB2ExEjAHATcWgDDJE6RVieCbUAAMDIYTcWEWchCUM7rRFABKsK2FiIOlykxQzJAwYCemQuVjEmD0RayIE8ECXAiTwQJMCLPBAgwJM8sOoaNUQKWI0UsBrbC+hdcT8do/e12MLZllzyd3uhlYTfYHsLTXejssssVSrvmJnk1NV6bsW4/zMloJZEWkuuRyzXi/GUZ1iA9gwUEk9zsMVYaTORTeDN7r6B2yG+73qtClpMVaCQkWttjNl/Eol/xxfcJqw/9KgVswAAAABJRU5ErkJggg=="

/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAmCAYAAACCjRgBAAABL0lEQVRYhe2YXRKDIAyEN50ezKN5NG8WnzITKfITkqoj31OxA+waAhFgci3U24GZ2wcnYmYm3VbjVOcmqsv7NKvphIh427aDaABY19V1nhADIh4AciY8cTegxS/LAiDWhKuBVDwzH0xE4JbEOfHqP6RRuVUSl8QDCI3EsIGaeCE14ZUTQwZaxQsRJswGesUL3ibMSZycqv0TqwQ9S+jQJJZJLeJ1v5bdqERYKfEvvhGD5kJvjVSNEAPAcb+XpI3g8UtoGriaxxsYqkY9SoHSOdBykA3tQqOHkAePX0LvM5Bb95Ef7TXeF4G7EVXM/dzApc+kPXJzBxgNlNZ87jpRfTtQ+kx+n1xDVk2YDKRvxyuJLeOEldMWMi+m2ue2SdwaDfcI6ASVtrVfSwQmk7ezA5nu180WvHx1AAAAAElFTkSuQmCC"

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAmCAYAAACCjRgBAAABJ0lEQVRYhe2Y2xKDIAxEl07//5fTBydTQDCQS9XKeSrMQHdNIhFgcS5pdgERjW+eEhFRysfZPuJ/pyTLew2rmWQTX4oGgHH7Y4QYYPEA0DLhibuBXDxnQKQJVwO1eCIqTETgZqAlHtibmH5rCLgY6IlnIiNhNiCJZ3aRcKoJk4FR8UyECbWBWfGMt4m3ZfFXyJyGzYRPOasjwK3ArPhsfbGPlrBW4leYUqhHKz20kZIIMQCU73undG9y+xRaBs7m9gbMRdw7kOppr4OrxmTAegh5cPsUep6BVvcY+dEu8bwIXI2oZm53A1fP8dhycwcoDRzlfOs6Mft2SPUc/+5cQ4omVAbqp+NVxJp9wtppDY0HI665bBGPRsM9AnmB8li7Lqp/Wiz+iQ/BwrpPbhe43gAAAABJRU5ErkJggg=="

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAoCAYAAACSN4jeAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAANISURBVFhH7ZhNbhMxFMdfJhVHQAhxAiDSAFFUIcQFOAMSKCi0AbHgBD0BC1QlUDVixYIFK27AApEohaoBLoCQyhUQTHj/Z09qe+yJJ2naLvqT3LHnw/Of92WnNSKacjtzJPp45jgXVpWTi7E0Jfr7lOi2HoPRNtH+vh7YrFRYUr9KWfs5UfMWj1gYsYjxHgsaUyNLaLJ+k9JRjbW15X4XCFu6sQi739md0s5UtfZkyhaz7p+1dEM15/ziFjNd08QXwyWwikNvky+90oMAnV2inUd6oKgu7DpP8ix3TQy5+8Lx5BMWn5XpBj/8lUXBOrGiAN8Li3b5WQgIgHg0iROGCbt97jiCxgPlKnFjBBDIH+eKANm/H7qnmC8MoiSGDETQDUoGL1jwYz5RzYJZ/+1MnE8kKBcG91mi2DIsKI+HrP+d/1YRlcPiHryTXta+Q43PX6RvUue2pboOyLruBz1gYKWte0SHh0qweQ0Mv/E1PncZ33pJnSvjykWin78p/dWig9p7Na9BOCsNFza2n9DkoCd9JfgNOmoMQXv37Yxz7wkCDzz0ZqtfmEzMWQTguvxB87zA5zt83QNiR7l6DoE654+xFhdOYIiSILVEMb3XulNEsgzun4ckT5Fw8JuWYpBJISDazTIcfUFdJJ09Y+J1JW606oqvZBwnjhGA12KWqELJWAXr+nhEaR0TE0vFXzGtTHeOKBUme6mTYFSUEa5jUkTnWItTPZl8pKxxQYbJ5M+sD/Jx1NFZK8PCsJOYVyBj9loL4hcme66IgEedcvZRFpHZnGxei9xdyEYwArwULveBVSImm/njXFGgKExeNG+NM0Acdjp2kZT4xFoZAXa2HoquXKqYokhW+KiSUChaTH5qAX4JKnIlKojCrqQkPi1hyh168uGaWiYqi4uB5x00dN+PJQw1ZUZ9qI4sDlmj3HQMwH2BrZKJPysdJGsw2UtsYxYVCOtz3SsrLwZW8MuuYra544lCXxazKuTAQqMxT1etEJdnJU+KX0J5nRHhjbu86DZlLC8Esgi3VJ/BPmyS8LklVoWCMGU1bArNDDPcp/8psqqlKMe/JAG4K7fMJ25rY15secH2VOlVEBZ2ykRl5WlwLqwaRP8Bog5T0jubaBAAAAAASUVORK5CYII="

/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAmCAYAAACCjRgBAAABS0lEQVRYhe2Y0Q7DIAhFcdl/t/1y9rCaUUVFAbcunqRJayl6BdkUYLFQEWovEbHtIIS2Ue632m+lr6ztOeIoRSKUDiKEgKMiUh4WTnpBxKHIcXxFAICdCHcBx3FkbWcaxXuViCkRoCIQ8XJpMalCnB0389u2cd+LqxJXhaqks8Vdb7Mr+75f7ulzyvm9tK+MKSnEzbwV7gI8B99kNIVKcKkEv55C3GK2xFWA9+AB/qCMugkA+IioLWStANcUmlGBXCMgGsAvR2AGJhua7v8ohqgFSMPvxe1T6PYCWuHPyktHxUBNenHfD51KME6aA7M8dWhx+xRSVyG6KaezHqMQ38d3Nfu0rdYuBdOL2Qtkz7S9dN+yT/sDZj0CGKyB3mMRzj5GChED9S2Z9ek/ZCV7KqLHn+kiHo0GzfNeH6oIpB22Zq9kzy32xWIh4wWINwKlUUO1lgAAAABJRU5ErkJggg=="

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAmCAYAAACCjRgBAAABQElEQVRYhe1Y0Q6DMAiEZf9t/HL2sJHVSltaiqjxEpNaEbnCoRXg4kAeEFFkHMN4RQdgxdvqABG7U0dE2LbSwUwAoK/8EBEQkWaRCCkhIhrKnIQwDcwi4U4A132l/MqIxyYSh2QgJUFEm8PsO3U85OAryP28sPK0CHaIpq7kkgFcEWihTcBS8DNwSAl5BQ9wAAHP4AGcCJSClnRhRUgbnQlXAt7BA9ygjboRAPiTqAn5lO8BhncHAnDOgPL+82bgCEzZ0PCXZQSeTX00Lk+gqgFpt6TtGNaNu/b+pohzJxrHM/86tHDvEtIgLbN01TkLfJ2v1ezzudq8mkCuAylI6TydT4MvkZRsSuMuAi0N9P4WKTUG9isRr8FcQr1iLdnnmdBiqohHs5HWea8PUwbyB7ZWr2QviV2L51soGg+BaHwAjfIGvIw5OpAAAAAASUVORK5CYII="

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAmCAYAAACCjRgBAAAB5klEQVRYhe1XW27EIAwcV70XHM1Hc07mfnQdOQQSA0l3pWakiOVlZtY2D+DBe0GRQaoaN0jUHKyqofUadqvt36MGKwsoAIgIUkoAgGVZICK7MTNChqCqhx8AFRH1EBFl5k3d2n5NHtusrHGPgJK8J10DM6uIdIu4RcAZeesrvcPM3Z64TYARPCPvy5FQamE4iYlILUFTSmviGkQEvt//NjAziEj17qQ+C58yRCxMAOw+y4HeXLhFQCtkjJiR9GFWinirgFZ8G8kSNRGzAr5mhKWUsCzLpjTknA/n5pw3h9wopgTUyJdlCyJyKjKCKQEishEBYFcayvpVHhjeRlWVXlsgAGxEAKiS820iAmbG7BY6dRslImXmNRR8WOScwcy7OS/S6+0yKqB1G52+TtuBZuRLEUe2iGhawPR12kKpJsK849tfpFcxsyfxZQ8au+vXwsbg+3o9cfuDxghEX2R+A5jB5U/KrsU7Xmi3e2AEV9xCpw6yT8D/EUBEat+dhGyt6NhQDpR79Z+8ooIYCqFPIQ9ctAt5l5eeKtvLrbM1tza2unaEoB35LZKR8LJ239+a2xBZ5Rr2wBnp2pzehPc2o2F6SQgd/eO+fsVaJUJJ3LP4DNGRuSEP+Li0+llf2d5r98GDBzH8AJFm8pHLqwkyAAAAAElFTkSuQmCC"

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAmCAYAAACCjRgBAAAB6UlEQVRYhe1YW27DMAyjht2rvdnUm7kn4z5iZ7LyqBMJyIaVhRskfoi0JTmxkMRfxsfVBKL4zB5QRDaXlKRk20tbARGhiLCUApIgiVIKAM6ltcmyCQCzsUgBwFIKLUopBEi0H2gKmGGXJCQaxCLCiScgqH/WUx6ugzZ7kuJSIQHNZW63W0/ek/ZIFBEWQHJJ/guDIuICTgdxm33BFKLdzD8qwVZmwh66m7WGEAlc1IAFSWgNVq2lBuuizHWaEtAhAc3ydLXkJmKq2olU1SpEjYgLBbwi77Eu4lIB6F3HCGjiLHmy7Q9IW4HYTryTcWxktkDv003rHENMwE66FHOluQ51PoDTAkgKBH2qNNDHY0H++XzW9yOg5tppnADCG5mfV1MLVcX9fp+flFKgqp07RQWcDp4umOfgNUVX9gDXCAkvdWEBSxG6slm5vJ8oIkXAjwi/SS3JZ69E+HXaY/SLTERmy+LqDtnLFnDIeBUbCeRLBWTgz59K/B8B7UQh/VRhw9Zo26FzofrpKFv3V+KUC/0W8kDSyZxdcr9S/rlPnVt919qu2h5No3skR9yrPbf1W33XRG6JGF6BV6TX+hwNeDvmqJumuNDejNv7DFseQ0F8xHiE6Jm+Qytg/bLdv6rzz4+O+8Ybb4zhG5Gq/ITRwOfsAAAAAElFTkSuQmCC"

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAmCAYAAACCjRgBAAABSElEQVRYhe1Y7Q6DIAy8Lntv8cm7HwZHkPHVQ1z0kiVTQe7ohy3AgwcmSO9EVU2/UCT9YJtTXE+kjdK7aXR+YQUA51xxTI2QWlAEiIjmiHv4MSKiLBEv6wtqyYdwzmVdrQUmAT3kPVgizBaYDYsfHnZ/WZb9/7quxfvAZokwHlqzENUCKdI58gzQXah251kYEgMx2VHkgUECwp1PXTNBF1ATyExQBaTIjxZhKuYsHzLgmEKByWl0BkwCVFUspQSjoDNboEcEizxAKqdVVWr6Af/scv0A8CVl7chaQRPgMYJkDvfOQleA2YVCnz/bfQBCS6mq4n+hGFbPWwLVhWZYgJ6FQoTHJylXi63UswEmAbHbxARColHfu1/H99FYYJot8IvYWfj7NGrOQiwi3Rx6J/rT6VwM9ARxa0NDP15vWjwRM7fryB7Mxgc/E87JllOorgAAAABJRU5ErkJggg=="

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAmCAYAAACCjRgBAAABK0lEQVRYheVYWw7CMAxzEPe/cvhZUFSVbqtdSoQlJMhQZjePJTMAcHdUxWM3ARblBTzVDs3sYz66u8nvdzjmHR3ER56CvVKIJIXMzB1j8jiuO8ZRugtaQJC/A6UISsAM+YBKRPkuNF3E3dPPFrNz+0GAKWptBHqkB+QV0KfQxZNXYU0NtGQXkQdWCWirY+GwqBdwpZCF0ArokV8sgpqFmAdZ3Jydi8o/yCgB7j7dXxSnDwgiMCNCRR4QpVCIOGMU/1HuA7KF5u2w6ka2C//dhX4B9FuJnPMrcvwM/ErpbvHJYpSL+wjSFNoRAfmLrYyIUHwPe8+W7XdACWjTpiWQieZr+fcn+1XQEWAJsCjfRukupCIyzQHgRolRDXyjiLfOQoqaKV8D5afR8ngB+8q8KSlCkVgAAAAASUVORK5CYII="

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABE0lEQVQ4jXWT0Y3FIAwEx6f0hTvDdGYq2/sAkhD0LKEIx17YAUwS32itHclaqx2FgL0FVqO7U0rBDIgGQPwSkoQkIkKSlJmSJJAIzkFo9UgaO2itqdZK7x3PfK33IwIkGcC1cr13SimQPoteGMKm6Cl8tda0PPfeUdXwDsTyf/QKM5Mku72vWN5XnskFGP+QiNDAJ4iIG1xmKjPP5kPkEbgAPJP8eDMge8dLub8j2lb39564l3kKZ3P2PqvqDnHiwn1Sj4pnJ+eubhF3IgJoA+rNU8POuCR6gRogh+8HqkAx/U/mYkDROeIFLWI0sovcV3IXCT3z2HJfke0xmZ2v8IlYlq2Zqc6T2gQeITuS6+5/a/4B1WdLKOGVz1MAAAAASUVORK5CYII="

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACzElEQVRYha2XW47sIAxEy6PZF+yMYmdmZXU/eIQkkE6PLhIijQg+LhuHNkl423LOHxenlOz1hgDsDUA3nFKC5QwAUH9mApjHWn4J8ggwGy6lIHqEkmAGgPP+bCA2zfAVyBYg56yUUl00e92340ulCUjaLl4CdOOlFIQQjsUGABlAeg/wAeJnZxwAQgiwXN+r8bbvjTcCM1tKfQLoxi1nWDaUUqpxa24AfzAOgNxC/K6Me4yIUQgCFATDH4xeAVo3M83hOClQSoFSQggB7s37vDFO1Q5OzzjmNgC3JgkkJUnurlUDUTt077d5HvPXDrYRkgRJRwiuGd/PfXPh4lRuHnWvryotPD2pwHmezUs+eu3uawVuanQF+KAAhwpGUkQtMnMrpSDG0MJ0yYXu+eQ9J69qqOf9ptoxlKi1YQB4jKcQ9LZNwm6sGY4xIoYALwXuDg6p0+UFG2GQZCMHrsZ7vVfSFoIgYgM3AAJgIcC7DLwC5HZibKTBD5r3vd735l6+Nw7AS6lKxNgA+vv5osAEEN1PEGZVkVoX9l/LrfEZYrS03OO3KzAgGvA4hr73vhvHyngbaygMIx943uukQHQfFTDGAI8OjwsCADGE4Xn/vYI4K5Bv+4wcGBDxSMYYwwCp6Ae+l/Isf1dgtLtxAEcpHkWH/FxsCI0C1gtXK+XzWPeaitPx0Ril+Hwf+PJTazlvFcDpVK3lHwrcVHihQFcB5Nrz5j1PKpy9l3RcyXLOIlAvl5/arBT7yGmuPrs73L1NET2P5vvA6U74CoIZt7OE8xR5FKnSSjNYi/btbjjLMULxGILNV+5yH2ALTc1QiK3jEoIbwAGxA+nxnXOGy5GkBFSQDcQS4A6xGDkn1r6zke8gHv8ZHbdYYXzTd8dpkxSSLJspjX1s7EC8/G94gPArw/PsCoJt4eve3n7sT+9zSia29a8U+J9t/nMiyf4BSjSwOW2o6GgAAAAASUVORK5CYII="

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA4ElEQVQ4ja2SW3LEIAwEW6k9mG6GuJk42eSDx2Lj3Z9EVS4D1rRGRvDHMEmPH2qtAiil2FeCpOOJiLGUIkJ9f+ZJOgEjWRGhzFQPPoIexas6KGADnY4OMaDe2TuuoGtrl57fwr7eBQu0XI5ie+VJzUzt53tb9wIvgNYaEpgFABGBuwOGJGqtRMC8cbOek5n9JjNz/ajdNhfLPW+ezfUPQGaSmbTWxhDFmBFwd2qtgHD35c7dkWQmCTPTtA5dNO2VUoZtO8THKD+B5vtJDPC6jbU9gSbkLj4c3GOC7gX+NX4BM9ycUEesdPgAAAAASUVORK5CYII="

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEySURBVFhH7ZVrEoMgDISxh9Uz6WVt1gkWIyEQ6ONHv5mM0CnsJrym0MC6rjs3syzL0jQfMAekovM8cyvPtm3cqjej/ikKW6Ia0YynKof4KKxlu1EjHsI1LGhahI1HPIYFTY/QqS27FI5RA8kg7rSuuUc8QnKIkwd/m5AWWrlszNbsR0Cy5+loqsBEJ1oLL00GvCXXQBVce2AkfwPfN4DXKn1G381ER4Y2H/d+ZQk+VQWZPXTlFcIXVZ6aC0cbLsVBzgAomvCgieOr5TTMREkclIp6OPAagTAoiYOSAQzeaQD3bDNRFEhhIMVB0QCACW5iAm7dzeRKnZITB6aBSGoEwExqQjOgCXfBZkj/Bfr4XRq1cN2EnBUl3Z9c71XcbWLEW9BlYtRjNOU2YA2jDDh3ewhPOwGelnvg0EoAAAAASUVORK5CYII="

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAKCAYAAACALL/6AAAAOElEQVQYlWM8cODAfwcHBwZC4MCBAwwMDAwMTARVogEWdBOwAWQXkGzDcNAADyVi4gKuAV+QogMAqw4MWRUlAkAAAAAASUVORK5CYII="

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAKCAYAAACALL/6AAAAKElEQVQYlWM8cODAfwYSABMpikesBhYYw8HBAauCAwcOUMkGdJNwAQAB6AiXLlrmxgAAAABJRU5ErkJggg=="

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAArUlEQVQ4jaWTawrDMAyDP48dzDeLfTP3ZNqP0dI2DzomCAE/JFsh8CcMQFKXyMw+eEJrzQDeo2Rmyt2nzVWFmUmSdQSZqdbasHHbNqrqEnvNVMysOyMMVzggQSYAMSmZTgAczSssJ5ipPiK4m3UhjiAiyEwNCWaGnQncHXe/TrC//0q9qjjXdCbuydkdEb2AJCJCgKrq0f1t07GTnmInkIQkdreWH+cOSWuXf8EHgX+btxulnsAAAAAASUVORK5CYII="

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABa0lEQVRYhbWXa66EMAiFDzezL7uzws5wZdwfivHRt/UkTTQde76CFobMDDWJSP1HDYox0vmeiPBrMQ8hvDJelgUiAiIyM7tAFAFExGKMr8z3dbJzWQA3X9f1NUBJ1RQAgKoOLd6ygSYAZu42b32mCWBfsRtiLgAAxAgQpecGAf96H2BmmNllvFFfBE6fE5EA8E/UAAYA6o5EdwRczIDZdYxoKAWUew8G1JeCjWCaOfAqBVskzmNE4wfRpEg0AcwoSK8AZhYk7y28N6iV42nGzHykMoQAIjIAlAUYKUA1ADc/V9cHgIdoNkDK/AEwqwPKKZXSZAq+7oKqAK1q7ZRKTW0RICzbg7qmjVrfkxJoOQKestC3sKoWd90MoCFtUFPX/4hzZ8PM5mObsmnXAO5rXwGYearh/drv3dwByMyO719ELkfmrGvX3k8edZuIcOz8K6nqJex2a2Z/wLcHj6o+dn4WmZlXps+UNSfCP+KvvCAx/Hb6AAAAAElFTkSuQmCC"

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAC0SURBVDhPnZMNEoQgCIVlp3vpzaKb6clYH0qbPzVr3wwDqcDDikTE9RDRuNiR8wh+KIBkZnZcn+GHOO8DLYICZlhrFu4sn4sxqt+QdVIru+Movmffh71zBJ27xtMCSAZELnfXMISgcxRVzK3MmeFMlW8jqIKm+xOX7gAKPhrZ7E/c3Ave5avuoCh40d17XyNT8Ad9dwAF0y9xdnjG7xIXgPzrCMsFUkpqxnIBw8Z8/TsDEaEvib2kgJXKg78AAAAASUVORK5CYII="

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABaElEQVRYhcVXW47EIAxzVnMvOBpHc0+W/ShUkOG1A8xaqqAVISZO0hb4ZwgAqOp4oYjGtbIyN3vOERARVVWI3PYr85yIiOBn6uRpA1WQhIiAJP78PIQimjmj5gVASSpU18YQNO0V4nxIYJtz1c8J7HZuCbxG2vO64J27R+8BAD6uaY7WrpNj3SQsNnHuSbDhmNvF5CNZ9VGNgIgoycI5RMYnB/Bm13Bc4LT2IYTnGibhLue29EiqxudDAiectwgUOVDT/tMxaZ8nH8mnkqo5sFt7e/quBCe17xEoJFgNe173wdR+mlcl2JZ4g/A3JTip/YiAPATiu3oZMfwteO9BMq2RF1B+Nq3C9nznXHF/XVdx/yShmu+1HKk/nEDzdWzxKQFrZ6tgmkCrfHqw4QfeJRh+lJ7GUQlqNl+RoBb6hGYVrGw6C+t8mkDqEztK0e4x/W8I3P2g1+VmEUJIh5qXANjXMXtN7+v4BdJQg3+vviKoAAAAAElFTkSuQmCC"

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADZSURBVDhPlZPtEYMgDIaTXodqf5Ut2m2EzeJkNG8giNUqPndcIpJPAuecCaSUitIxTRNX9T9wEGPMIgJ1JbFvHweLcSiEQK9XoHmWjVRHNdSall2NcgnYqClUupkXgzXiPCR7rARNx34i7ZRi/XWO2tK96q1mIiH0ZJTmwBsnUjIIYb95jkgJ0nqwZHARvwW//9FbwXk1zycZMH2eS9d5Zy7NgY6xdb8fGjP8NdCYGyeajQlffQnvhw2LEamMOyTwEtpM+7rag/YaHbzK0TnAuY0DZl5vHEL0BavKUQ509W5nAAAAAElFTkSuQmCC"

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABVElEQVRIibWVfZKDIAzFf9npveBmhJuFk739A22xFqvt7pthoiHmST6ISQKg1tofJiil2NH+FJJwd3UwXYvN3GCyzN2Vcz71MxFx+YQ3gJTSKYIjOzOTpB3Jz2BCa+1j6d5Jdsxr/CNCEh9LdwTs8rRJ8DckMwJzd5VSaK2RUqa1OEzmFbh7TzJwd55SJsI5W1nvcCdYnbcWQACQc7x1IBXMrIdjkGsU7lU0nuAKzOylPHWCiDNkcbg7zUHXnWvAV+g9MoRoe4K/w7kcmFGH2NrkXrW637iBU6svr5ldC5iBgPFbPUj0dDlYNVQG5TIPNC53X7pU8u6jy7Xnu+puI0k4Qmg1iwgB+llIbFzjH+UIKlDWwWSViIZTiec+qYBPynSGlBJpiENR6XptK2wTlisEtdaH81Iu6TrzizE35uBTbHLwnzgM0dqN38D0XMhMRt+H+AX0+QzB1KpIvAAAAABJRU5ErkJggg=="

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA1ElEQVQ4jZWRUW7EMAhEH1XuFd/M+GbkZNOPLlnsZKPtSBY2hmEAA5BExRhjcvTejSdIQhLuLneXpNPm/fVmPQBTYiYAighFxCPRVmSm/FNZRNBa4ziONUbZmqWC1hoA+74DYGa4OwD5l6gxGwuyWvZXFdXk9G8pZYyhWsnG3+DVLxua3hcFAC0a0WIiihZExCX25y652k9wdyTZhSArV5v3O5wEvXdbJX6j5qIgq37bisF7ZWYm4BxWHWb1Z/+wbCGdK9ETbtf4H6KphY9BL6K1AMAvfIfL2S4v6yAAAAAASUVORK5CYII="

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABkElEQVRYhbWWW7aDIAxFD3c5L5kZYWZxZNwPDStqMKD0/LQVSTZ50QAApRR4yjnXl1JKwd3gKITdxDLgFDln+SyzQG4AV6fqOYjo9HwGSAVQxk5OLW3bNg1kEQPKmLuJmRFjnAJySkGPc0tfQP70Dx1+T8xsgmzbhpRSLVZdU5YWvVlDvI1Gw1YzIrcuGAGRWvgCEoB9EOWci2VsXdcKQkS1FUVPAC1bxxAKwKUGWqeQvFoT06qFET1OwisIYKfmKRVy6uueYYAekF6nWrUGjpfNOhAxMwi0f498c9bjlIhQSgldl5FW5Hj7zZERcqgwb+qhCXB1KE702vWdN2p2gXY4svYJIKUUJIxPp3t7csm/fubWAEd+TMdXuYPIc/i1DroAZjp0AaQOrNa6pWKg7az8A04NSP4Z5zqYGQU3BRIJmYCt9bdqRqC24zGaY4wgJhBoahec7oLTQggFQL3/BeTp5mvVhJV/9y6QDS2QWXIH0a9Bum/DX4EM/yEZAZE1q/9fA3ggvY4/A7RAeh2L/gFTzza7iNkggwAAAABJRU5ErkJggg=="

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAKCAYAAACALL/6AAAARElEQVQYlWM8cODAfwYocHBwYMAGDhw4AGczYVWBB7DgMw2brSzogshsdM2UOQmbU7AFAoYfkAF1nYQrDrBqwGY1LgAAIkQWH/yy2t0AAAAASUVORK5CYII="

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABPUlEQVRIibWVW67DIAxEx1fZF+wMe2fDyuZ+JJDQPNqm7UiIBIQP2MYAP5ZJ2g1GxH7whtwd09lkzvkbjHPADOFTA1KBmUHS0JPz2r9Pd2hmh33T5QnI/AKCl7OXgJTSC4Bj1VpnQJgdZgyx7s0BHGXbS3JAAkRSJKXlf9tm+7M2n4Pg4wRJAVDbma7aYEgr+xGwhQwAdx8mWnP3PWAxTnI0LgzQBngrTcMCZIUjwMc7EgDcdmt6FtVaQRI5Z+Sc+0XZqqgAAJLG7FI5T4AJAEopFhHaGicJd99lT0SswFJOx1b6ErdtLI58/65uxeCOegyaiyICOWe4+1C07sokdeMppX7FAfQ4fKLuolZ3jt4BSXa3DTFoLvnWYwMsLrKTgrc9wV3AFGYSgLoEMx3s3sx0F2KYC9pTfXKKn+ofZ8e98UJ7DG0AAAAASUVORK5CYII="

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABfUlEQVRIia2VW5aEIAxEb81xYe6MsDNYWeYjjYKi3fZMfvAAqcqrUGbm/MHMDHfX1fkCsK7rV+CllLd3lidOKSVqrY+COBFApP2E+DEBgPvemqdR9/bz7kKt9esewU0GkiilsK4r7k6tlZzz/xG4O5K2UpVSSClt559mdkmQszAb63+XQc7ZAVJKgyZOBBGlEcFGFhCT1cb0OFGSXon663sX3qnJe8QORIkmU7uZGTRwOAt6OkVmUaLmlNL1a9IyBTGr4IngLKi9TDOLoxbMDUEpK6WsgGHWImOYpJnFtAVJy1SSS3I4NLlPt++BpOnzsQfAcL/5S/KNYPfXtkZE9yQ9uARmGnAudRBYI0mf2XG9ksjlFLmzgUtRigAJ0Jz3fXBSYjrSMjNvkm9ru5QSr7R3h570uN/U38zdtVw1bwb+iomZqEI3IzjAMvuf5qxhLhtJCLCRjPszcPjgfxD9cM0Caft3T4muRNSE0gNL8j7q49nx/i3BHWmfwTufX2vZ9wa3O9J+AAAAAElFTkSuQmCC"

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABXSURBVChTY6yvqP/PQARo7GhkYAAp/v/jP0EMVP+fCaIPARg5GFEwMsBQDDQFysIEWE3GBVAUIyvEZgOGySAAU4iugXw3gxQS7WYQwGcyyBjcsiiAgQEA3idBIpD76IEAAAAASUVORK5CYII="

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABHElEQVRIia3WWxKDIAwF0KTjvmRnN+wsriz9KLG8i9r81AG8RxCcsplRXTHGohEAN4MWi3PAg0MIxSBVvQ2xmZ3BAOg4juFgh3o1wllEDEDTsQLlMx3NchsF7vs+hDw4h7wtWw0uAB8oIn+DAPBW3+T5InoZCiGQqp4gM1sDECEBcRnKX369ETrAOhRjHN+e6jXtNYdAIp/l8yec7bLfQHu4iewLXak+wB/kdCy13ajxDDhJD8LHAPuPPQrvAEJEnZ3ReydXAN9uqoFUQ0Li9+mfLpGIFCewgW6UiJCZ8QaAARAzm3cQ+bEP6dqR9qs7CyfKTrI3rEFr4QVwBZpVHt4FVqArNfnY/Qfi3r+K6Q0VlF/Xy3MLqKFRsNcbqd3SL4a0+60AAAAASUVORK5CYII="

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAYAAABytg0kAAAAFklEQVQImQXBAQEAAACAEP9PF1BFBQ1Hygf56Pxj3AAAAABJRU5ErkJggg=="

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAwUlEQVQ4jaVTbQ6FMAgrxnuv3Iyb9f1g6nTDmDwSEsz4aKGaJFRmZgIASVblbNWDu4lkj72eImlyMkMAiojTV7llMUmRPApFUve8/F4W5wvO4meDMd4PvgDQGgAIQLkzuLtaa1dCTtUw7UKQK5oRjN6vcDS0G4KIgFmNBkBSGG5yaxIRSwrTJUl0iDhpfKWwS7JUHJGLfEfwtA05xiQZCbiPO5ltojApa6DUYb/qYCnlowkGKX9SYtWkWqAkmP78nX8w/aAz0SwsYAAAAABJRU5ErkJggg=="

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/START.6f33bba2.png";

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAALCAYAAACzkJeoAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABASURBVChTY2RgaPjPgAMwQWmsAC75/389lIUAKDrRFWAYi6wAq50wBVglGRkbwTSGJEwCBFAkkSVAgNxAYGAAAKTfDpAJdDeCAAAAAElFTkSuQmCC"

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAALCAYAAACzkJeoAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABESURBVChTdY9bEgAgBEXVyizdzipFeXV+mDkXoxHRgA9dasmViCjdw03GQFprA+VNDZRyfbBrkioYJ61groyCKW8eACZwgA9V1J0QUAAAAABJRU5ErkJggg=="

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAB9CAYAAABNsCihAAACQUlEQVRoge1ZUXbDIAyje7sX3IzmZuRk2xd7lMpGNiRZ3qa/plS4yDKGPJ7P51dYjI/VhIeRfloGp5RePpdSONKUUogxhm3b4HOEnpyKVJoo5xz2fX8bT60pIgwhhG3bQozxbVnuo/51pPu+h5yz+H2vPkVaSoHEkvpiSmmRtYTIAI8jCoqa/JqLpChVUomwmiDnHGKMkBySarZMKYVSygs5pf7IligIlbQfgNCOQRPd2KZSmljGwEglryNbomcwpWokPXGfk1UwejtBf7F/JqXeId6/ft+vaJMfLdMw0pTSC0nvOORAlZQhQHCvKUqtKdJKKDmL3vgsuC6lJIGk5+5ItVxVSRn/I0yvKZpkuKZSZFrEw2aCITGReie4pkoxE5i8X0oxW3RI6iWfsqmLdERm7k89ZBUu9ZHiLdRIa0RM6Wuj/yPqu0gZuOopS+QiXSaU1oVoEw0j1cSSOunzjzzoHgoZwd2g9USacDc+8UmwdNXDPNX6/XZci2v6U61QT+9RU9731lDzdmLFfUjf1lSqoUioqdOJtUWnSK3nKFd7PsL56nu66CEpC/Mbid9bUHqwqtMFxVuxblxQJFiEOiT56fbcclC7j1Dnq79MqLbltjjqX6gfqPv+su1kdEHAQH0dV2GN2HzeZyYwn6KZCabO+9IEqvr9D1mYLmXZCc69mPHs9yIpQ7b0ppc1gamgsBYWU4q5O2nHq6RosPVy5poLxCWOmq2lkNSCZVVqWT1dVvm9mx4knSGruE8z8U+6Ht9z0GBu8ZdCjwAAAABJRU5ErkJggg=="

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAYAAABytg0kAAAAGklEQVQImQXBAQEAAAgCIPt/SpcRpC042JYHgI4NfJCqNDgAAAAASUVORK5CYII="

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAcElEQVQ4je1SQQ6AIAxrjQ+Hp/GyemEqI7LFeLSXFsK6sgwAIAmSuoy5awDAZoKkJKHWumSSV7WhlKLeIs1TAvtKxK21oflg8Aa7vyA5JLLzfXBLA//wqTCVIGMUJojwJ/hykfyKZkHg3Lh0dkm0WR0B3pDX/1h3rAAAAABJRU5ErkJggg=="

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADVSURBVFhH7ZdhDoMgDIXLdjE4mexkcDPWx8Q4BRXXoEv4ktKHJVBb/kAhhJUxGFjKavilPa21CE7wPHjvo2ZvJTXvbY0xcK8YAPNshmFgx+KTbURKY2/MnXPpOwZ68ORSsgkgs4SU1lqP6pt7VqAlxQSUUlnbIsWPrgfFBNC/nG2R4kfXA9EKnEG0Ame47yVsRb8D/9eCWtujugW1tkevQK9Ar0AxgVZUt0Ca6hZI0ytw+SVUy7/C47T0ivkFfpQSvwuj5zOnXq4SANxr+VqPzA8nInoDupc0ICQUq2wAAAAASUVORK5CYII="

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABOUlEQVRYhb2XUY7DIAxETdV7hZth38w5mfdjS5YSQjM23ZGsEik1zIsxSTIzQiWSjj+VYglO0MrMoGD+u1RV+02B5WjDPXm/CGZ2LeQRwkdE25aPsYjgzzPifkQBJREm0FP4CoGZ+yiFJQRCFFa4j1CACey7Ukp0xL5rjALqnugcEQrLaqAKpoA++979KAVCYTkBIpACWvm9+4sUtynABJjn1zAFdN9XZzVUNdQXYAK9s5nTWxQ8XY+ZXs7i3dG1C3LWt9+ZPlJA3be74e69MwruPmDAu8+Ugsd9uxNmu+AOBWcN5OHYRQF1P+qGkVpwEVDV4dhD4elZwLblpgjPSe9KROwrp+GV2renqkcplkT+Z/KcM3F3eiV7sRRJdnWyrVI/+dsCqlyfV06VUtKpBkopsc9tYHIioh8y2r2jCTCoDgAAAABJRU5ErkJggg=="

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABM0lEQVRYhe2XXRKCMAyEs473gps13AxOFl+gjW2wqbTy4s4wMIGyn82PClJiZqGOCiHAigMp/DQWdTFfloUAiIiYEIceXdxOxMwE4OOuDgWY57kKUaSgp6ZpIqK0E1Y6hgJ4IIYC6GpXMSGieGNYDYQQSETejnVdi+eGFqFHtwN0qYE81yL+gXoJwCoyHfeAVFNQMyEiija8H5W1TQD5ywDY5lpsBb8E0NtY5Nrvc6p6DQBEex+/hxNMvOLs7JC/DQ9DIF4v2lyrK4D+5FkKko/ERxs60AcQPY+3Fy6lYwtEQxekc9qI62Xo6IISohTifUfrtwGkqWZlwC7DFgj3KAZAIpLNAt7hzlv0MsDHQXRSbUfcA+LegZZvuJY1t/8e+AP8AYou2LbtpwB5o3b9e+7xfQELe3md15VQhwAAAABJRU5ErkJggg=="

/***/ }),
/* 110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ICONS__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TOOLTIP__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SYSTRAY=function(_PureComponent){_inherits(SYSTRAY,_PureComponent);function SYSTRAY(props){_classCallCheck(this,SYSTRAY);var _this=_possibleConstructorReturn(this,(SYSTRAY.__proto__||Object.getPrototypeOf(SYSTRAY)).call(this,props));_this.state={date:new Date()};return _this;}_createClass(SYSTRAY,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.timerID=setInterval(function(){return _this2.tick();},1000);}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearInterval(this.timerID);}},{key:'tick',value:function tick(){this.setState({date:new Date()});}},{key:'render',value:function render(){//let fakeYear = (this.state.date.getFullYear() - 5) % 10 + 1995;
var fakeYear=this.state.date.getFullYear();var timeText=__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.state.date).format('dddd, MMMM D')+', '+fakeYear;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'win-sys-tray'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__ICONS__["a" /* default */].SND}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TOOLTIP__["a" /* default */],{text:'Volume'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'win-sys-tray-time'},__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.state.date).format('h:mm A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TOOLTIP__["a" /* default */],{text:timeText})));}}]);return SYSTRAY;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (SYSTRAY);

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FAT32_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MSGBOX__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ICONS__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function getFileOrFolder(path){var parts=path==""?[]:path.split("\\");var currentObj=__WEBPACK_IMPORTED_MODULE_1__FAT32_js__["a" /* default */];var path="";for(var i=0;i<parts.length;i++){if(currentObj.type!="directory"){throw"File is not directory";}else if(currentObj.children.hasOwnProperty(parts[i])){currentObj=currentObj.children[parts[i]];if(currentObj.type=="link"){// Follow the link recursively
currentObj=getFileOrFolder(currentObj.destination);}path=path+parts[i]+"\\";}else{if(i==0){throw new Error("Specified drive does not exist: "+path);}else{throw"File not found: "+path+parts[i];}}}return currentObj;}// the winapi is where applications make windows API calls
// most of the time it does this by changing WIN.
var WINAPI=function(){function WINAPI(win){_classCallCheck(this,WINAPI);this.win=win;this.hwnd=7466;this.foregroundHwnd=-1;this.hwndLayers={};this.topLayer=0;this.lastMousePosition=[0,0];this.eventHooks={};}_createClass(WINAPI,[{key:'GetFileInfo',value:function GetFileInfo(lpFileName){var info=getFileOrFolder(lpFileName);if(info.type=="link"){return this.GetFileInfo(info.destination);}else{return Object.assign({name:info.displayName||lpFileName.split("\\").pop()},info,{children:undefined});}}},{key:'FindFile',value:function FindFile(lpFileName){var obj=getFileOrFolder(lpFileName);if(obj.type!="directory"){throw"Not directory";}var result=[];for(var key in obj.children){if(obj.children.hasOwnProperty(key)){var orig=obj.children[key];var item=Object.assign({name:key},orig,{children:undefined});if(item.type=="link"){item.destination=obj.children[key].destination;// Copy icon from destination
var destFile=this.GetFileInfo(item.destination);item.icon16=destFile.icon16;item.icon32=destFile.icon32;}result.push(item);}}return result;}},{key:'OpenFile',value:function OpenFile(lpFileName){var obj=this.GetFileInfo(lpFileName);if(obj.type!="file"){throw"Cannot open filesystem object of type "+obj.type;}return obj.contents;}},{key:'CreateProcess',value:function CreateProcess(lpApplicationName,lpCommandLine){try{this.OpenFile(lpApplicationName)(lpCommandLine);}catch(e){throw lpApplicationName+" is not a valid win32 application.";}}},{key:'CreateWindow',value:function CreateWindow(wndClass,extraProps){var _this=this;var hwnd=this.hwnd;this.hwnd++;var props=Object.assign(extraProps||{},{key:"window-"+hwnd,hwnd:hwnd,ref:function ref(wnd){_this.win.wndRef(hwnd,wnd);}});this.hwndLayers[hwnd]=this.topLayer;this.topLayer+=1;this.ResetWindowLayers();props.initialPositionX=props.initialPositionY=(hwnd%5+1)*10;if(hwnd==7466){// First window
if(window.innerWidth<800){// On mobile, starts maximized
props.initialIsMaximized=true;}else{// On desktop, starts offset
props.initialPositionX=window.innerWidth-800-Math.min(100,(window.innerWidth-800)/2);props.initialPositionY=window.innerHeight-600-100;}}var wnd=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(wndClass,props,"");this.win.addWnd(hwnd,wnd);this.win.setState({foregroundHwnd:hwnd});this.foregroundHwnd=hwnd;this.TriggerEvent("focus");}},{key:'FindWindow',value:function FindWindow(hwnd){return this.win.wnds[hwnd];}},{key:'GetActiveWindow',value:function GetActiveWindow(){return this.foregroundHwnd;}},{key:'SetCursorVisible',value:function SetCursorVisible(visible){if(this.cursor){this.cursor.setCursorVisible(visible);}}},{key:'SetActiveWindow',value:function SetActiveWindow(hwnd){this.win.setState({foregroundHwnd:hwnd});this.foregroundHwnd=hwnd;// bring to top
if(hwnd!=-1){this.hwndLayers[hwnd]=this.topLayer;this.topLayer+=1;this.ResetWindowLayers();}this.TriggerEvent("focus");}},{key:'CloseWindow',value:function CloseWindow(hwnd){delete this.hwndLayers[hwnd];this.win.removeWnd(hwnd);if(this.foregroundHwnd==hwnd){var newForeground=-1;for(var hwnd2 in this.hwndLayers){if(newForeground==-1||this.hwndLayers[newForeground]<this.hwndLayers[hwnd2]){newForeground=hwnd2;}}if(newForeground!=-1){this.SetActiveWindow(newForeground);}}}},{key:'GetDesktopWindow',value:function GetDesktopWindow(){// menus and tooltips live in the overlay element
return this.win.overlayElement;}},{key:'GetCursorPos',value:function GetCursorPos(){return this.lastMousePosition;}},{key:'SetWinEventHook',value:function SetWinEventHook(event,handler){if(!this.eventHooks[event]){this.eventHooks[event]=[];}this.eventHooks[event].push(handler);return handler;}},{key:'UnhookWinEvent',value:function UnhookWinEvent(event,handler){var arr=this.eventHooks[event];arr.splice(arr.indexOf(handler),1);}},{key:'TriggerEvent',value:function TriggerEvent(event){if(this.eventHooks[event]){this.eventHooks[event].forEach(function(h){h();});}}},{key:'GetTopLayer',value:function GetTopLayer(){return this.topLayer;}},{key:'SetWindowLayer',value:function SetWindowLayer(hwnd,layer){this.hwndLayers[hwnd]=layer;}},{key:'GetWindowLayer',value:function GetWindowLayer(hwnd){return this.hwndLayers[hwnd];}},{key:'ClaimTopLayer',value:function ClaimTopLayer(){this.topLayer+=1;}},{key:'ResetWindowLayers',value:function ResetWindowLayers(){// todo lower z-indexes so smallest is 0
}},{key:'SysCrashDump',value:function SysCrashDump(idx){var _this2=this;var errbox=function errbox(title,msg){return _this2.MessageBox(title,msg,{"OK":function OK(){}},__WEBPACK_IMPORTED_MODULE_3__ICONS__["a" /* default */].ERROR);};var errors=[function(){return _this2.win.setState({showBsod:true});},function(){return errbox("Insert Disk","Please insert the disk labeled 'Windows 95 Disk4', and then click OK.");},function(){return errbox("Windows Update",'An error occurred loading "C:\\WINDOWS\\SYSTEM\\USER32.DLL". The file may not have been installed or it has been corrupted.');}];errors[idx||Math.floor(Math.random()*errors.length)]();}// opens a file / directory with its assigned program
},{key:'ShellExecute',value:function ShellExecute(lpFile){if(lpFile=="A:"){// Not formatted
window.WINAPI.MessageBox("3½ Floppy (A:)","The disk in drive A is not formatted.\n\nDo you want to format it now?",{"Yes":function Yes(){return window.WINAPI.SysCrashDump(0);},"No":function No(){return null;}});return;}var info=this.GetFileInfo(lpFile);if(info.type=="directory"){// Open in Windows Explorer
window.WINAPI.CreateProcess("C:\\WINDOWS\\Explorer.exe",lpFile);}else if(info.type=="file"){var extension=lpFile.split(".").pop();if(extension=="exe"){window.WINAPI.CreateProcess(lpFile);}else if(extension=="log"||extension=="txt"){window.WINAPI.CreateProcess("C:\\WINDOWS\\Notepad.exe",lpFile);}else{this.SysCrashDump();// TODO MsgBox
}}else{console.log("bad type "+info.type);this.SysCrashDump();}}// show shut down dialog
},{key:'InitiateShutdown',value:function InitiateShutdown(){//this.win.setState({ showShutdownVeil: true });
setTimeout(function(){window.WINAPI.CreateProcess("C:\\WINDOWS\\Shutdown.exe");},500);}},{key:'AbortShutdown',value:function AbortShutdown(){this.win.setState({showShutdownVeil:false});}},{key:'InitiateSystemShutdown',value:function InitiateSystemShutdown(){this.win.shutoff();}},{key:'MessageBox',value:function MessageBox(title,message,buttons,icon){this.CreateWindow(__WEBPACK_IMPORTED_MODULE_2__MSGBOX__["a" /* default */],{title:title,message:message,buttons:buttons,icon:icon});}}]);return WINAPI;}();/* harmony default export */ __webpack_exports__["a"] = (WINAPI);

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ICONS__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__IEXPLORE_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CDSAMPLE__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SHUTDOWN__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EXPLORE_EXPLORER__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NOTEPAD__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TRUISMS_js__ = __webpack_require__(127);
var defaultDirectoryIcon_16=__WEBPACK_IMPORTED_MODULE_0__ICONS__["a" /* default */].DIR_OPEN;var defaultDirectoryIcon_32=__WEBPACK_IMPORTED_MODULE_0__ICONS__["a" /* default */].DIR_CLOSED_32;var defaultFileIcon_16=__WEBPACK_IMPORTED_MODULE_0__ICONS__["a" /* default */].WINFILE_32;var defaultFileIcon_32=__WEBPACK_IMPORTED_MODULE_0__ICONS__["a" /* default */].WINFILE_32;function Directory(children,icon16,icon32,displayName){var node={type:"directory",children:children||[],icon16:icon16||defaultDirectoryIcon_16,icon32:icon32||defaultDirectoryIcon_32,displayName:displayName};return node;}function File(contents,icon16,icon32){return{type:"file",icon16:icon16||defaultFileIcon_16,icon32:icon32||defaultFileIcon_32,contents:contents};}function Link(destination,isSoft){return{type:"link",destination:destination,isSoft:isSoft};}function exe(wndClass){return function(lpCommandLine){window.WINAPI.CreateWindow(wndClass,{commandLine:lpCommandLine});};}// Scandisk.log
var time=__WEBPACK_IMPORTED_MODULE_5_moment___default()(new Date()).format('h:mmA');var date=__WEBPACK_IMPORTED_MODULE_5_moment___default()(new Date()).format('dddd, MMMM DD, YYYY');var scandiskLog="Microsoft ScanDisk\n\n\nLog file generated at "+time+" on "+date+"."+"\n\nScanDisk checked drive C for problems, with the following results:\n\nDirectory structure"+"\n\n\tScanDisk did not find any problems.\n\nFile allocation table\n\n\tScanDisk did not find any problems."+"\n\nFile system\n\n\tScanDisk did not find any problems.\n\nSurface scan\n\n\tScanDisk did not perform any tests.\n";// Thanks.txt
var thanks="ATTRIBUTIONS\n------------\n\nBIOS font from https://int10h.org/oldschool-pc-fonts/\nLicence: https://creativecommons.org/licenses/by-sa/4.0/\n\n"+"MSSansSerif converted using https://github.com/kreativekorp/bitsnpicas\n\n"+"Fixedsys font from https://github.com/kika/fixedsys/releases";// the main C: drive
var CDRIVE=Directory({"WINDOWS":Directory({"DESKTOP":Directory({"My Computer":Link(""),"Recycle Bin":Link("C:\\RECYCLED"),"The Internet":Link("C:\\WINDOWS\\iexplore.exe"),"Truisms":Link("C:\\WINDOWS\\Truisms.exe",true),"Cdsample":Link("C:\\WINDOWS\\Cdsample.exe",true)}),"Start Menu":Directory({"Programs":Directory({"Windows Explorer":Link("C:\\WINDOWS\\Explorer.exe",true),"Internet Explorer":Link("C:\\WINDOWS\\iexplore.exe",true),"Truisms":Link("C:\\WINDOWS\\Truisms.exe",true),"Accessories":Directory({"Notepad":Link("C:\\WINDOWS\\Notepad.exe",true),"Interactive CD Sampler":Link("C:\\WINDOWS\\Cdsample.exe",true)}),"StartUp":Directory({"Iexplore":Link("C:\\WINDOWS\\iexplore.exe",true)})}),"Documents":Directory({"Thanks.txt":Link("C:\\WINDOWS\\Thanks.txt",true)})}),"iexplore.exe":File(exe(__WEBPACK_IMPORTED_MODULE_1__IEXPLORE_js__["a" /* default */]),__WEBPACK_IMPORTED_MODULE_0__ICONS__["a" /* default */].IEXPLORE_16,__WEBPACK_IMPORTED_MODULE_0__ICONS__["a" /* default */].IEXPLORE_32),"Cdsample.exe":File(exe(__WEBPACK_IMPORTED_MODULE_2__CDSAMPLE__["a" /* default */]),__WEBPACK_IMPORTED_MODULE_0__ICONS__["a" /* default */].CDSAMPLE_16,__WEBPACK_IMPORTED_MODULE_0__ICONS__["a" /* default */].CDSAMPLE_32),"Explorer.exe":File(exe(__WEBPACK_IMPORTED_MODULE_4__EXPLORE_EXPLORER__["a" /* default */]),__WEBPACK_IMPORTED_MODULE_0__ICONS__["a" /* default */].EXPLORER_16,__WEBPACK_IMPORTED_MODULE_0__ICONS__["a" /* default */].MY_PC_32),"Shutdown.exe":File(function(){return window.WINAPI.InitiateSystemShutdown();},__WEBPACK_IMPORTED_MODULE_0__ICONS__["a" /* default */].EXEC_16,__WEBPACK_IMPORTED_MODULE_0__ICONS__["a" /* default */].EXEC_32),//File(exe(SHUTDOWN)),
"Notepad.exe":File(exe(__WEBPACK_IMPORTED_MODULE_6__NOTEPAD__["a" /* default */]),__WEBPACK_IMPORTED_MODULE_0__ICONS__["a" /* default */].NOTEPAD_16,__WEBPACK_IMPORTED_MODULE_0__ICONS__["a" /* default */].NOTEPAD_32),"Truisms.exe":File(__WEBPACK_IMPORTED_MODULE_7__TRUISMS_js__["a" /* default */].exe,__WEBPACK_IMPORTED_MODULE_0__ICONS__["a" /* default */].EXEC_16,__WEBPACK_IMPORTED_MODULE_0__ICONS__["a" /* default */].EXEC_32),"Thanks.txt":File(thanks,__WEBPACK_IMPORTED_MODULE_0__ICONS__["a" /* default */].TEXTFILE_16,__WEBPACK_IMPORTED_MODULE_0__ICONS__["a" /* default */].TEXTFILE_32)}),"RECYCLED":Directory({},__WEBPACK_IMPORTED_MODULE_0__ICONS__["a" /* default */].RECYCLED_16,__WEBPACK_IMPORTED_MODULE_0__ICONS__["a" /* default */].RECYCLED_32,"Recycle Bin"),"Scandisk.log":File(scandiskLog,__WEBPACK_IMPORTED_MODULE_0__ICONS__["a" /* default */].TEXTFILE_16,__WEBPACK_IMPORTED_MODULE_0__ICONS__["a" /* default */].TEXTFILE_32)},__WEBPACK_IMPORTED_MODULE_0__ICONS__["a" /* default */].CDRIVE_16,__WEBPACK_IMPORTED_MODULE_0__ICONS__["a" /* default */].CDRIVE_32,"(C:)");// "My Computer"
var FAT32=Directory({"A:":Directory({},__WEBPACK_IMPORTED_MODULE_0__ICONS__["a" /* default */].ADRIVE_16,__WEBPACK_IMPORTED_MODULE_0__ICONS__["a" /* default */].ADRIVE_32,"3½ Floppy (A:)"),"C:":CDRIVE},__WEBPACK_IMPORTED_MODULE_0__ICONS__["a" /* default */].MY_PC_16,__WEBPACK_IMPORTED_MODULE_0__ICONS__["a" /* default */].MY_PC_32,"My Computer");/* harmony default export */ __webpack_exports__["a"] = (FAT32);

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WND_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ICONS__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__menus_MENUBAR__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IEXPLORE_css__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IEXPLORE_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__IEXPLORE_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__STATUSBAR_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BUTTON_js__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var menu=[{text:"File",accel:"F"},{text:"Edit",accel:"E"},{text:"View",accel:"V"},{text:"Go",accel:"G"},{text:"Favorites",accel:"a"},{text:"Help",accel:"H"}];var homeUrl="https://waller.is/";var IEXPLORE=function(_WND){_inherits(IEXPLORE,_WND);function IEXPLORE(props){_classCallCheck(this,IEXPLORE);var _this=_possibleConstructorReturn(this,(IEXPLORE.__proto__||Object.getPrototypeOf(IEXPLORE)).call(this,props));_this.state.currentUrl=null;return _this;}_createClass(IEXPLORE,[{key:'applicationContent',value:function applicationContent(){var _this2=this;var statusBarParts=["","",""];var toolbarButtons=["BACK","FWD","STOP","RFSH","HOME","SRCH"/*, "FAVS"*/];var grabber=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ie-grabber'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null));var clickHandlers={HOME:function HOME(){return _this2.frame.src="/wwwroot/index.html";},SRCH:function SRCH(){return _this2.frame.src="http://web.archive.org/web/19961223150621/http://www8.yahoo.com/";}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__STATUSBAR_js__["a" /* default */],{parts:statusBarParts},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'iexplore'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__menus_MENUBAR__["a" /* default */],{menu:menu}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ie-toolbar',style:{backgroundImage:"url("+__WEBPACK_IMPORTED_MODULE_2__ICONS__["a" /* default */].IE_BG+")"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ie-toolbar-part ie-btns'},grabber,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ie-btns-container'},toolbarButtons.map(function(name,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__BUTTON_js__["a" /* default */],{key:i,onPress:clickHandlers[name]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__ICONS__["a" /* default */]["IE"+name],className:'inactive'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__ICONS__["a" /* default */]["IE"+name+"_A"],className:'active'}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__ICONS__["a" /* default */].IEICON})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ie-toolbar-part ie-address'},grabber,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ie-address-text'},'Address'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ie-address-field'},'https://waller.is/'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ie-frame'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{src:'/wwwroot/index.html',ref:function ref(r){return _this2.frame=r;},className:'web-frame',onMouseEnter:function onMouseEnter(){window.WINAPI.SetCursorVisible(false);},onMouseLeave:function onMouseLeave(){window.WINAPI.SetCursorVisible(true);}}))));}},{key:'icon',value:function icon(){return __WEBPACK_IMPORTED_MODULE_2__ICONS__["a" /* default */].HTML;}},{key:'title',value:function title(){return"Microsoft Internet Explorer";// todo web page title
}}]);return IEXPLORE;}(__WEBPACK_IMPORTED_MODULE_1__WND_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (IEXPLORE);

/***/ }),
/* 119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WND_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ICONS__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CDSAMPLE=function(_WND){_inherits(CDSAMPLE,_WND);function CDSAMPLE(){_classCallCheck(this,CDSAMPLE);return _possibleConstructorReturn(this,(CDSAMPLE.__proto__||Object.getPrototypeOf(CDSAMPLE)).apply(this,arguments));}_createClass(CDSAMPLE,[{key:'applicationContent',value:function applicationContent(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cd-sampler',style:{"backgroundColor":"black","height":"100%","width":"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{src:'/Cdsample.mp4',style:{"padding":"30px","boxSizing":"border-box","width":"100%","height":"100%"},autoPlay:true,playsInline:true,onEnded:function onEnded(){// TODO MsgBox
window.WINAPI.CloseWindow(_this2.props.hwnd);}}));}},{key:'icon',value:function icon(){return __WEBPACK_IMPORTED_MODULE_2__ICONS__["a" /* default */].CDSAMPLE_16;}},{key:'title',value:function title(){return"Microsoft Interactive CD Sampler";}}]);return CDSAMPLE;}(__WEBPACK_IMPORTED_MODULE_1__WND_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (CDSAMPLE);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WND_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ICONS__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__menus_MENUBAR__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__STATUSBAR__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BUTTON__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SHUTDOWN=function(_WND){_inherits(SHUTDOWN,_WND);function SHUTDOWN(props){_classCallCheck(this,SHUTDOWN);var _this=_possibleConstructorReturn(this,(SHUTDOWN.__proto__||Object.getPrototypeOf(SHUTDOWN)).call(this,props));window.WINAPI.SetWindowLayer(_this.props.hwnd,1012);// Custom layer above shutdown veil
return _this;}_createClass(SHUTDOWN,[{key:'applicationContent',value:function applicationContent(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__ICONS__["a" /* default */].SHUTDOWN}),'Are you sure you want to:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__BUTTON__["a" /* default */],{onPress:function onPress(){window.WINAPI.CloseWindow(_this2.props.hwnd);window.WINAPI.InitiateSystemShutdown();}},'Yes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__BUTTON__["a" /* default */],null,'No'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__BUTTON__["a" /* default */],null,'Help')));}},{key:'icon',value:function icon(){return null;}},{key:'title',value:function title(){return"Shut Down Windows";}},{key:'defaultSize',value:function defaultSize(){return{h:200,w:350};}},{key:'defaultPosition',value:function defaultPosition(){return'center';}},{key:'appearOnTaskbar',value:function appearOnTaskbar(){return false;}},{key:'componentWillUnmount',value:function componentWillUnmount(){_get(SHUTDOWN.prototype.__proto__||Object.getPrototypeOf(SHUTDOWN.prototype),'componentWillUnmount',this).call(this);window.WINAPI.AbortShutdown();}}]);return SHUTDOWN;}(__WEBPACK_IMPORTED_MODULE_1__WND_js__["a" /* default */]);/* unused harmony default export */ var _unused_webpack_default_export = (SHUTDOWN);

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WND_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ICONS__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__menus_MENUBAR__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__STATUSBAR__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EXPLORER_css__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EXPLORER_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__EXPLORER_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EXPLCTRL_js__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EXPLORE=function(_WND){_inherits(EXPLORE,_WND);function EXPLORE(props){_classCallCheck(this,EXPLORE);var _this=_possibleConstructorReturn(this,(EXPLORE.__proto__||Object.getPrototypeOf(EXPLORE)).call(this,props));var initialPath=props.commandLine||"";// Default to "My Computer"
_this.state.currentPath=initialPath;_this.state.currentInfo=window.WINAPI.GetFileInfo(_this.state.currentPath);_this.state.currentDirectory=window.WINAPI.FindFile(_this.state.currentPath);return _this;}_createClass(EXPLORE,[{key:'applicationContent',value:function applicationContent(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__EXPLCTRL_js__["a" /* default */],{path:this.state.currentPath,directory:this.state.currentDirectory,showChrome:true,ref:function ref(c){_this2.explctrl=c;}});}},{key:'icon',value:function icon(){return this.state.currentInfo.icon16;}},{key:'title',value:function title(){return this.state.currentInfo.displayName||this.state.currentInfo.name;}},{key:'defaultSize',value:function defaultSize(){return{h:219,w:265};}},{key:'onFocusLost',value:function onFocusLost(){if(this.explctrl){this.explctrl.onFocusLost();}}}]);return EXPLORE;}(__WEBPACK_IMPORTED_MODULE_1__WND_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (EXPLORE);

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WND_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ICONS__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__menus_MENUBAR__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NOTEPAD_css__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NOTEPAD_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__NOTEPAD_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var menu=[{text:"File",accel:"F"},{text:"Edit",accel:"E"},{text:"Search",accel:"S"},{text:"Help",accel:"H"}];var NOTEPAD=function(_WND){_inherits(NOTEPAD,_WND);function NOTEPAD(props){_classCallCheck(this,NOTEPAD);var _this=_possibleConstructorReturn(this,(NOTEPAD.__proto__||Object.getPrototypeOf(NOTEPAD)).call(this,props));if(_this.props.commandLine){_this.state.info=window.WINAPI.GetFileInfo(_this.props.commandLine);_this.state.contents=window.WINAPI.OpenFile(_this.props.commandLine);}else{_this.state.info=null;_this.state.contents="";}_this.state.dirty=false;return _this;}_createClass(NOTEPAD,[{key:'applicationContent',value:function applicationContent(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notepad'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__menus_MENUBAR__["a" /* default */],{menu:menu}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{value:this.state.contents,spellCheck:'false',onChange:function onChange(e){_this2.setState({contents:e.target.value,dirty:true});}}));}},{key:'icon',value:function icon(){return __WEBPACK_IMPORTED_MODULE_2__ICONS__["a" /* default */].TEXTFILE_16;}},{key:'title',value:function title(){return(this.state.info?this.state.info.name:"Untitled")+" - Notepad";}}]);return NOTEPAD;}(__WEBPACK_IMPORTED_MODULE_1__WND_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (NOTEPAD);

/***/ }),
/* 126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__truisms_json__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__truisms_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__truisms_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ICONS__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var TRUISMS=function(){function TRUISMS(){_classCallCheck(this,TRUISMS);}_createClass(TRUISMS,null,[{key:'exe',value:function exe(){window.WINAPI.MessageBox("Truism",__WEBPACK_IMPORTED_MODULE_0__truisms_json___default.a[Math.floor(Math.random()*__WEBPACK_IMPORTED_MODULE_0__truisms_json___default.a.length)]+"\n\nJenny Holzer",{"Yes":function Yes(){TRUISMS.exe();},"No":function No(){TRUISMS.exe();}},__WEBPACK_IMPORTED_MODULE_1__ICONS__["a" /* default */].ASK);}}]);return TRUISMS;}();/* harmony default export */ __webpack_exports__["a"] = (TRUISMS);

/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports = ["A LITTLE KNOWLEDGE CAN GO A LONG WAY","A LOT OF PROFESSIONALS ARE CRACKPOTS","A MAN CAN'T KNOW WHAT IT IS TO BE A MOTHER","A NAME MEANS A LOT JUST BY ITSELF","A POSITIVE ATTITUDE MEANS ALL THE DIFFERENCE IN THE WORLD","A RELAXED MAN IS NOT NECESSARILY A BETTER MAN","A SENSE OF TIMING IS THE MARK OF GENIUS","A SINCERE EFFORT IS ALL YOU CAN ASK","A SINGLE EVENT CAN HAVE INFINITELY MANY INTERPRETATIONS","A SOLID HOME BASE BUILDS A SENSE OF SELF","A STRONG SENSE OF DUTY IMPRISONS YOU","ABSOLUTE SUBMISSION CAN BE A FORM OF FREEDOM","ABSTRACTION IS A TYPE OF DECADENCE","ABUSE OF POWER COMES AS NO SURPRISE","ACTION CAUSES MORE TROUBLE THAN THOUGHT","ALIENATION PRODUCES ECCENTRICS OR REVOLUTIONARIES","ALL THINGS ARE DELICATELY INTERCONNECTED","AMBITION IS JUST AS DANGEROUS AS COMPLACENCY","AMBIVALENCE CAN RUIN YOUR LIFE","AN ELITE IS INEVITABLE","ANGER OR HATE CAN BE A USEFUL MOTIVATING FORCE","ANIMALISM IS PERFECTLY HEALTHY","ANY SURPLUS IS IMMORAL","ANYTHING IS A LEGITIMATE AREA OF INVESTIGATION","ARTIFICIAL DESIRES ARE DESPOILING THE EARTH","AT TIMES INACTIVITY IS PREFERABLE TO MINDLESS FUNCTIONING","AT TIMES YOUR UNCONSCIOUSNESS IS TRUER THAN YOUR CONSCIOUS MIND","AUTOMATION IS DEADLY","AWFUL PUNISHMENT AWAITS REALLY BAD PEOPLE","BAD INTENTIONS CAN YIELD GOOD RESULTS","BEING ALONE WITH YOURSELF IS INCREASINGLY UNPOPULAR","BEING HAPPY IS MORE IMPORTANT THAN ANYTHING ELSE","BEING JUDGMENTAL IS A SIGN OF LIFE","BEING SURE OF YOURSELF MEANS YOU'RE A FOOL","BELIEVING IN REBIRTH IS THE SAME AS ADMITTING DEFEAT","BOREDOM MAKES YOU DO CRAZY THINGS","CALM IS MORE CONDUCTIVE TO CREATIVITY THAN IS ANXIETY","CATEGORIZING FEAR IS CALMING","CHANGE IS VALUABLE WHEN THE OPPRESSED BECOME TYRANTS","CHASING THE NEW IS DANGEROUS TO SOCIETY","CHILDREN ARE THE MOST CRUEL OF ALL","CHILDREN ARE THE HOPE OF THE FUTURE","CLASS ACTION IS A NICE IDEA WITH NO SUBSTANCE","CLASS STRUCTURE IS AS ARTIFICIAL AS PLASTIC","CONFUSING YOURSELF IS A WAY TO STAY HONEST","CRIME AGAINST PROPERTY IS RELATIVELY UNIMPORTANT","DECADENCE CAN BE AN END IN ITSELF","DECENCY IS A RELATIVE THING","DEPENDENCE CAN BE A MEAL TICKET","DESCRIPTION IS MORE IMPORTANT THAN METAPHOR","DEVIANTS ARE SACRIFICED TO INCREASE GROUP SOLIDARITY","DISGUST IS THE APPROPRIATE RESPONSE TO MOST SITUATIONS","DISORGANIZATION IS A KIND OF ANESTHESIA","DON'T PLACE TOO MUCH TRUST IN EXPERTS","DRAMA OFTEN OBSCURES THE REAL ISSUES","DREAMING WHILE AWAKE IS A FRIGHTENING CONTRADICTION","DYING AND COMING BACK GIVES YOU CONSIDERABLE PERSPECTIVE","DYING SHOULD BE AS EASY AS FALLING OFF A LOG","EATING TOO MUCH IS CRIMINAL","ELABORATION IS A FORM OF POLLUTION","EMOTIONAL RESPONSES ARE AS VALUABLE AS INTELLECTUAL RESPONSES","ENJOY YOURSELF BECAUSE YOU CAN'T CHANGE ANYTHING ANYWAY","ENSURE THAT YOUR LIFE STAYS IN FLUX","EVEN YOUR FAMILY CAN BETRAY YOU","EVERY ACHIEVEMENT REQUIRES A SACRIFICE","EVERYONE'S WORK IS EQUALLY IMPORTANT","EVERYTHING THAT'S INTERESTING IS NEW","EXCEPTIONAL PEOPLE DESERVE SPECIAL CONCESSIONS","EXPIRING FOR LOVE IS BEAUTIFUL BUT STUPID","EXPRESSING ANGER IS NECESSARY","EXTREME BEHAVIOR HAS ITS BASIS IN PATHOLOGICAL PSYCHOLOGY","EXTREME SELF-CONSCIOUSNESS LEADS TO PERVERSION","FAITHFULNESS IS A SOCIAL NOT A BIOLOGICAL LAW","FAKE OR REAL INDIFFERENCE IS A POWERFUL PERSONAL WEAPON","FATHERS OFTEN USE TOO MUCH FORCE","FEAR IS THE GREATEST INCAPACITATOR","FREEDOM IS A LUXURY NOT A NECESSITY","GIVING FREE REIN TO YOUR EMOTIONS IS AN HONEST WAY TO LIVE","GO ALL OUT IN ROMANCE AND LET THE CHIPS FALL WHERE THEY MAY","GOING WITH THE FLOW IS SOOTHING BUT RISKY","GOOD DEEDS EVENTUALLY ARE REWARDED","GOVERNMENT IS A BURDEN ON THE PEOPLE","GRASS ROOTS AGITATION IS THE ONLY HOPE","GUILT AND SELF-LACERATION ARE INDULGENCES","HABITUAL CONTEMPT DOESN'T REFLECT A FINER SENSIBILITY","HIDING YOUR EMOTIONS IS DESPICABLE","HOLDING BACK PROTECTS YOUR VITAL ENERGIES","HUMANISM IS OBSOLETE","HUMOR IS A RELEASE","IDEALS ARE REPLACED BY CONVENTIONAL GOALS AT A CERTAIN AGE","IF YOU AREN'T POLITICAL YOUR PERSONAL LIFE SHOULD BE EXEMPLARY","IF YOU CAN'T LEAVE YOUR MARK GIVE UP","IF YOU HAVE MANY DESIRES YOUR LIFE WILL BE INTERESTING","IF YOU LIVE SIMPLY THERE IS NOTHING TO WORRY ABOUT","IGNORING ENEMIES IS THE BEST WAY TO FIGHT","ILLNESS IS A STATE OF MIND","IMPOSING ORDER IS MAN'S VOCATION FOR CHAOS IS HELL","IN SOME INSTANCES IT'S BETTER TO DIE THAN TO CONTINUE","INHERITANCE MUST BE ABOLISHED","IT CAN BE HELPFUL TO KEEP GOING NO MATTER WHAT","IT IS HEROIC TO TRY TO STOP TIME","IT IS MAN'S FATE TO OUTSMART HIMSELF","IT IS A GIFT TO THE WORLD NOT TO HAVE BABIES","IT'S BETTER TO BE A GOOD PERSON THAN A FAMOUS PERSON","IT'S BETTER TO BE LONELY THAN TO BE WITH INFERIOR PEOPLE","IT'S BETTER TO BE NAIVE THAN JADED","IT'S BETTER TO STUDY THE LIVING FACT THAN TO ANALYZE HISTORY","IT'S CRUCIAL TO HAVE AN ACTIVE FANTASY LIFE","IT'S GOOD TO GIVE EXTRA MONEY TO CHARITY","IT'S IMPORTANT TO STAY CLEAN ON ALL LEVELS","IT'S JUST AN ACCIDENT THAT YOUR PARENTS ARE YOUR PARENTS","IT'S NOT GOOD TO HOLD TOO MANY ABSOLUTES","IT'S NOT GOOD TO OPERATE ON CREDIT","IT'S VITAL TO LIVE IN HARMONY WITH NATURE","JUST BELIEVING SOMETHING CAN MAKE IT HAPPEN","KEEP SOMETHING IN RESERVE FOR EMERGENCIES","KILLING IS UNAVOIDABLE BUT NOTHING TO BE PROUD OF","KNOWING YOURSELF LETS YOU UNDERSTAND OTHERS","KNOWLEDGE SHOULD BE ADVANCED AT ALL COSTS","LABOR IS A LIFE-DESTROYING ACTIVITY","LACK OF CHARISMA CAN BE FATAL","LEISURE TIME IS A GIGANTIC SMOKE SCREEN","LISTEN WHEN YOUR BODY TALKS","LOOKING BACK IS THE FIRST SIGN OF AGING AND DECAY","LOVING ANIMALS IS A SUBSTITUTE ACTIVITY","LOW EXPECTATIONS ARE GOOD PROTECTION","MANUAL LABOR CAN BE REFRESHING AND WHOLESOME","MEN ARE NOT MONOGAMOUS BY NATURE","MODERATION KILLS THE SPIRIT","MONEY CREATES TASTE","MONOMANIA IS A PREREQUISITE OF SUCCESS","MORALS ARE FOR LITTLE PEOPLE","MOST PEOPLE ARE NOT FIT TO RULE THEMSELVES","MOSTLY YOU SHOULD MIND YOUR OWN BUSINESS","MOTHERS SHOULDN'T MAKE TOO MANY SACRIFICES","MUCH WAS DECIDED BEFORE YOU WERE BORN","MURDER HAS ITS SEXUAL SIDE","MYTH CAN MAKE REALITY MORE INTELLIGIBLE","NOISE CAN BE HOSTILE","NOTHING UPSETS THE BALANCE OF GOOD AND EVIL","OCCASIONALLY PRINCIPLES ARE MORE VALUABLE THAN PEOPLE","OFFER VERY LITTLE INFORMATION ABOUT YOURSELF","OFTEN YOU SHOULD ACT LIKE YOU ARE SEXLESS","OLD FRIENDS ARE BETTER LEFT IN THE PAST","OPACITY IS AN IRRESISTIBLE CHALLENGE","PAIN CAN BE A VERY POSITIVE THING","PEOPLE ARE BORING UNLESS THEY ARE EXTREMISTS","PEOPLE ARE NUTS IF THEY THINK THEY ARE IMPORTANT","PEOPLE ARE RESPONSIBLE FOR WHAT THEY DO UNLESS THEY ARE INSANE","PEOPLE WHO DON'T WORK WITH THEIR HANDS ARE PARASITES","PEOPLE WHO GO CRAZY ARE TOO SENSITIVE","PEOPLE WON'T BEHAVE IF THEY HAVE NOTHING TO LOSE","PHYSICAL CULTURE IS SECOND BEST","PLANNING FOR THE FUTURE IS ESCAPISM","PLAYING IT SAFE CAN CAUSE A LOT OF DAMAGE IN THE LONG RUN","POLITICS IS USED FOR PERSONAL GAIN","POTENTIAL COUNTS FOR NOTHING UNTIL IT'S REALIZED","PRIVATE PROPERTY CREATED CRIME","PURSUING PLEASURE FOR THE SAKE OF PLEASURE WILL RUIN YOU","PUSH YOURSELF TO THE LIMIT AS OFTEN AS POSSIBLE","RAISE BOYS AND GIRLS THE SAME WAY","RANDOM MATING IS GOOD FOR DEBUNKING SEX MYTHS","RECHANNELING DESTRUCTIVE IMPULSES IS A SIGN OF MATURITY","RECLUSES ALWAYS GET WEAK","REDISTRIBUTING WEALTH IS IMPERATIVE","RELATIVITY IS NO BOON TO MANKIND","RELIGION CAUSES AS MANY PROBLEMS AS IT SOLVES","REMEMBER YOU ALWAYS HAVE FREEDOM OF CHOICE","REPETITION IS THE BEST WAY TO LEARN","RESOLUTIONS SERVE TO EASE OUR CONSCIENCE","REVOLUTION BEGINS WITH CHANGES IN THE INDIVIDUAL","ROMANTIC LOVE WAS INVENTED TO MANIPULATE WOMEN","ROUTINE IS A LINK WITH THE PAST","ROUTINE SMALL EXCESSES ARE WORSE THAN THEN THE OCCASIONAL DEBAUCH","SACRIFICING YOURSELF FOR A BAD CAUSE IS NOT A MORAL ACT","SALVATION CAN'T BE BOUGHT AND SOLD","SELF-AWARENESS CAN BE CRIPPLING","SELF-CONTEMPT CAN DO MORE HARM THAN GOOD","SELFISHNESS IS THE MOST BASIC MOTIVATION","SELFLESSNESS IS THE HIGHEST ACHIEVEMENT","SEPARATISM IS THE WAY TO A NEW BEGINNING","SEX DIFFERENCES ARE HERE TO STAY","SIN IS A MEANS OF SOCIAL CONTROL","SLIPPING INTO MADNESS IS GOOD FOR THE SAKE OF COMPARISON","SLOPPY THINKING GETS WORSE OVER TIME","SOLITUDE IS ENRICHING","SOMETIMES SCIENCE ADVANCES FASTER THAN IT SHOULD","SOMETIMES THINGS SEEM TO HAPPEN OF THEIR OWN ACCORD","SPENDING TOO MUCH TIME ON SELF-IMPROVEMENT IS ANTISOCIAL","STARVATION IS NATURE'S WAY","STASIS IS A DREAM STATE","STERILIZATION IS A WEAPON OF THE RULERS","STRONG EMOTIONAL ATTACHMENT STEMS FROM BASIC INSECURITY","STUPID PEOPLE SHOULDN'T BREED","SURVIVAL OF THE FITTEST APPLIES TO MEN AND ANIMALS","SYMBOLS ARE MORE MEANINGFUL THAN THINGS THEMSELVES","TAKING A STRONG STAND PUBLICIZES THE OPPOSITE POSITION","TALKING IS USED TO HIDE ONE'S INABILITY TO ACT","TEASING PEOPLE SEXUALLY CAN HAVE UGLY CONSEQUENCES","TECHNOLOGY WILL MAKE OR BREAK US","THE CRUELEST DISAPPOINTMENT IS WHEN YOU LET YOURSELF DOWN","THE DESIRE TO REPRODUCE IS A DEATH WISH","THE FAMILY IS LIVING ON BORROWED TIME","THE IDEA OF REVOLUTION IS AN ADOLESCENT FANTASY","THE IDEA OF TRANSCENDENCE IS USED TO OBSCURE OPPRESSION","THE IDIOSYNCRATIC HAS LOST ITS AUTHORITY","THE MOST PROFOUND THINGS ARE INEXPRESSIBLE","THE MUNDANE IS TO BE CHERISHED","THE NEW IS NOTHING BUT A RESTATEMENT OF THE OLD","THE ONLY WAY TO BE PURE IS TO STAY BY YOURSELF","THE SUM OF YOUR ACTIONS DETERMINES WHAT YOU ARE","THE UNATTAINABLE IS INVARIABLE ATTRACTIVE","THE WORLD OPERATES ACCORDING TO DISCOVERABLE LAWS","THERE ARE TOO FEW IMMUTABLE TRUTHS TODAY","THERE'S NOTHING EXCEPT WHAT YOU SENSE","THERE'S NOTHING REDEEMING IN TOIL","THINKING TOO MUCH CAN ONLY CAUSE PROBLEMS","THREATENING SOMEONE SEXUALLY IS A HORRIBLE ACT","TIMIDITY IS LAUGHABLE","TO DISAGREE PRESUPPOSES MORAL INTEGRITY","TO VOLUNTEER IS REACTIONARY","TORTURE IS BARBARIC","TRADING A LIFE FOR A LIFE IS FAIR ENOUGH","TRUE FREEDOM IS FRIGHTFUL","UNIQUE THINGS MUST BE THE MOST VALUABLE","UNQUESTIONING LOVE DEMONSTRATES LARGESSE OF SPIRIT","USING FORCE TO STOP FORCE IS ABSURD","VIOLENCE IS PERMISSIBLE EVEN DESIRABLE OCCASIONALLY","WAR IS A PURIFICATION RITE","WE MUST MAKE SACRIFICES TO MAINTAIN OUR QUALITY OF LIFE","WHEN SOMETHING TERRIBLE HAPPENS PEOPLE WAKE UP","WISHING THINGS AWAY IS NOT EFFECTIVE","WITH PERSEVERANCE YOU CAN DISCOVER ANY TRUTH","WORDS TEND TO BE INADEQUATE","WORRYING CAN HELP YOU PREPARE","YOU ARE A VICTIM OF THE RULES YOU LIVE BY","YOU ARE GUILELESS IN YOUR DREAMS","YOU ARE RESPONSIBLE FOR CONSTITUTING THE MEANING OF THINGS","YOU ARE THE PAST PRESENT AND FUTURE","YOU CAN LIVE ON THROUGH YOUR DESCENDANTS","YOU CAN'T EXPECT PEOPLE TO BE SOMETHING THEY'RE NOT","YOU CAN'T FOOL OTHERS IF YOU'RE FOOLING YOURSELF","YOU DON'T KNOW WHAT'S WHAT UNTIL YOU SUPPORT YOURSELF","YOU HAVE TO HURT OTHERS TO BE EXTRAORDINARY","YOU MUST BE INTIMATE WITH A TOKEN FEW","YOU MUST DISAGREE WITH AUTHORITY FIGURES","YOU MUST HAVE ONE GRAND PASSION","YOU MUST KNOW WHERE YOU STOP AND THE WORLD BEGINS","YOU CAN UNDERSTAND SOMEONE OF YOUR SEX ONLY","YOU OWE THE WORLD NOT THE OTHER WAY AROUND","YOU SHOULD STUDY AS MUCH AS POSSIBLE","YOUR ACTIONS AE POINTLESS IF NO ONE NOTICES","YOUR OLDEST FEARS ARE THE WORST ONES"]

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WND_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ICONS__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BTNGROUP_js__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MSGBOX_css__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MSGBOX_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MSGBOX_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MSGBOX=function(_WND){_inherits(MSGBOX,_WND);function MSGBOX(){_classCallCheck(this,MSGBOX);return _possibleConstructorReturn(this,(MSGBOX.__proto__||Object.getPrototypeOf(MSGBOX)).apply(this,arguments));}_createClass(MSGBOX,[{key:'applicationContent',value:function applicationContent(){var _this2=this;var buttons={};var _loop=function _loop(){var original=_this2.props.buttons[b];buttons[b]=function(){_this2.dismiss();original();};};for(var b in this.props.buttons){_loop();}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contents'},this.props.icon?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon',style:{backgroundImage:"url("+this.props.icon+")"}}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message'},this.shortenedText?this.shortenedText:this.props.message)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__BTNGROUP_js__["a" /* default */],{buttons:buttons}));}},{key:'shortenText',value:function shortenText(n){var lines=this.props.message.split("\n");var maxLineLen=Math.max.apply(null,lines.map(function(l){return l.length;}));var splitLine=function splitLine(line){var split=1;for(var i=0;i<line.length;i+=1){if(i>=maxLineLen*(split/n)&&line[i]==" "){line=line.slice(0,i+1)+"\n"+line.slice(i+1);split+=1;i+=1;}}return line;};return lines.map(splitLine).join("\n");}},{key:'dismiss',value:function dismiss(){window.WINAPI.CloseWindow(this.props.hwnd);}},{key:'icon',value:function icon(){return null;}},{key:'title',value:function title(){return this.props.title;}},{key:'appearOnTaskbar',value:function appearOnTaskbar(){return false;}},{key:'defaultPosition',value:function defaultPosition(){return'center';}},{key:'defaultSize',value:function defaultSize(){var hasIcon=this.props.icon;var xAdd=12+12;var yAdd=26+12+15+23+12;var computeSize=function computeSize(text){var e=document.getElementsByClassName("message-box-fake-elm");if(e.length>0){e[0].remove();}var fakeElem=document.createElement("div");fakeElem.className="message-box-fake-elm";fakeElem.innerHTML=text;document.body.appendChild(fakeElem);console.log(fakeElem.clientWidth+" x "+fakeElem.clientHeight);var dimens={w:fakeElem.clientWidth+(hasIcon?xAdd+32+15:xAdd),h:fakeElem.clientHeight+yAdd};fakeElem.parentNode.removeChild(fakeElem);dimens.w=Math.max(dimens.w,190);// fit 2 buttons
return dimens;};var dimens=computeSize(this.props.message);var n=0;this.shortenedText=null;while(dimens.w>window.innerWidth-100){n+=1;if(n>3){break;}this.shortenedText=this.shortenText(n);dimens=computeSize(this.shortenedText);}if(hasIcon){dimens.h=Math.max(dimens.h,32+yAdd);}return dimens;}},{key:'resizable',value:function resizable(){return false;}},{key:'canMinimize',value:function canMinimize(){return false;}}]);return MSGBOX;}(__WEBPACK_IMPORTED_MODULE_1__WND_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (MSGBOX);

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BUTTON__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BTNGROUP=function(_PureComponent){_inherits(BTNGROUP,_PureComponent);function BTNGROUP(props){_classCallCheck(this,BTNGROUP);return _possibleConstructorReturn(this,(BTNGROUP.__proto__||Object.getPrototypeOf(BTNGROUP)).call(this,props));}_createClass(BTNGROUP,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-group'},Object.keys(this.props.buttons).map(function(b){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__BUTTON__["a" /* default */],{key:b,onPress:_this2.props.buttons[b]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'center'},b));}));}}]);return BTNGROUP;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (BTNGROUP);

/***/ }),
/* 131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CURSOR_css__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CURSOR_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CURSOR_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var offsetX=24;var offsetY=24;// Displays the system cursor.
var CURSOR=function(_PureComponent){_inherits(CURSOR,_PureComponent);function CURSOR(props){_classCallCheck(this,CURSOR);var _this=_possibleConstructorReturn(this,(CURSOR.__proto__||Object.getPrototypeOf(CURSOR)).call(this,props));window.WINAPI.cursor=_this;return _this;}_createClass(CURSOR,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;this.mouseMoveHandler=window.addEventListener('mousemove',function(e){if(_this2.cursorElm){_this2.cursorElm.style.transform="translateX("+(e.clientX-offsetX)+"px) "+"translateY("+(e.clientY-offsetY)+"px)";}});this.mouseLeaveHandler=document.body.addEventListener('mouseleave',function(e){if(_this2.cursorElm){_this2.cursorElm.style.display='none';}});this.mouseEnterHandler=document.body.addEventListener('mouseenter',function(e){if(_this2.cursorElm){_this2.cursorElm.style.display='block';}});}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('mousemove',this.mouseMoveHandler);document.body.removeEventListener('mouseleave',this.mouseLeaveHandler);document.body.removeEventListener('mouseenter',this.mouseEnterHandler);this.mouseMoveHandler=this.mouseLeaveHandler=this.mouseEnterHandler=null;}},{key:'render',value:function render(){var _this3=this;var cursorStyle={backgroundImage:"url("+this.props.icon+")"};if(this.cursorElm){// wow violating react conventions
cursorStyle.transform=this.cursorElm.style.transform;cursorStyle.display=this.cursorElm.style.display;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cursor-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cursor',ref:function ref(e){return _this3.cursorElm=e;},style:cursorStyle}));}},{key:'setCursorVisible',value:function setCursorVisible(visible){if(!this.cursorElm){return;}if(visible){this.cursorElm.style.display='block';}else{this.cursorElm.style.display='none';}}}]);return CURSOR;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* unused harmony default export */ var _unused_webpack_default_export = (CURSOR);

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BSOD_css__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BSOD_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__BSOD_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BSOD=function(_PureComponent){_inherits(BSOD,_PureComponent);function BSOD(){_classCallCheck(this,BSOD);return _possibleConstructorReturn(this,(BSOD.__proto__||Object.getPrototypeOf(BSOD)).apply(this,arguments));}_createClass(BSOD,[{key:'render',value:function render(){var dismiss=this.props.dismiss;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bsod',onClick:dismiss,onKeyPress:dismiss,onTouchEnd:dismiss},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},'Windows'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'A fatal exception 0E has occurred at 002B:C00268ZZ in VXD VFAT(01) * 0000798E. The current application will be terminated.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'* Press any key to terminate the current application.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'* Press CTRL+ALT+DEL again to restart your computer. You will lose any unsaved information in all applications.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'press'},'Press any key to continue _'))));}}]);return BSOD;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (BSOD);

/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EXPLCTRL__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DESKTOP=function(_PureComponent){_inherits(DESKTOP,_PureComponent);function DESKTOP(props){_classCallCheck(this,DESKTOP);var _this=_possibleConstructorReturn(this,(DESKTOP.__proto__||Object.getPrototypeOf(DESKTOP)).call(this,props));var initialPath="C:\\WINDOWS\\DESKTOP";_this.state={};_this.state.currentPath=initialPath;_this.state.currentInfo=window.WINAPI.GetFileInfo(_this.state.currentPath);_this.state.currentDirectory=window.WINAPI.FindFile(_this.state.currentPath);_this.activeWindowHandler=window.WINAPI.SetWinEventHook("dismiss",function(){if(_this.explctrl){_this.explctrl.onFocusLost();}});return _this;}_createClass(DESKTOP,[{key:'componentWillUnmount',value:function componentWillUnmount(){window.WINAPI.UnhookWinEvent("dismiss",this.activeWindowHandler);}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desktop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__EXPLCTRL__["a" /* default */],{path:this.state.currentPath,directory:this.state.currentDirectory,showChrome:false,stackVertically:true,ref:function ref(c){_this2.explctrl=c;}}));}}]);return DESKTOP;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (DESKTOP);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.18f05751.js